/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/aircrafts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:aircrafts] */
    get: {
      parameters: {
        query?: {
          pageIndex?: number;
          itemsPerPage?: number;
          ids?: string;
          maoIds?: string;
          registration?: string;
          orderBy?: components['schemas']['AircraftOrderBy'];
          asc?: boolean;
          testAircrafts?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['AircraftViewListOperationResult'];
            'application/json': components['schemas']['AircraftViewListOperationResult'];
            'text/json': components['schemas']['AircraftViewListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/aircrafts/case-booking-history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Gets aircraft booking history for specific cases.
     *     [read:aircrafts]
     */
    get: {
      parameters: {
        query: {
          /** @description Comma-separated list of Case IDs. */
          caseIds: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CaseAircraftReservationHistoryViewIEnumerableOperationResult'];
            'application/json': components['schemas']['CaseAircraftReservationHistoryViewIEnumerableOperationResult'];
            'text/json': components['schemas']['CaseAircraftReservationHistoryViewIEnumerableOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/clinical-specialists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          caseId: string;
          orTime: string;
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          donor: components['schemas']['Donor'];
          hubId?: string;
          trialProgramId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/relief/clinical-specialists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          caseId: string;
          goTime: string;
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          donor: components['schemas']['Donor'];
          hubId?: string;
          trialProgramId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CSAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/retrieval-surgeons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          caseId: string;
          orTime: string;
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          donor: components['schemas']['Donor'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['RSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['RSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['RSAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/retrieval-surgeons-contractors': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          caseId: string;
          orTime: string;
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          donor: components['schemas']['Donor'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['RSContractorAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['RSContractorAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['RSContractorAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * [read:resource-availabilities]
     *     Get best assignment candidates for clinical specialists and retrieval surgeons for organ donor hubs within a specified time range and step.
     */
    get: {
      parameters: {
        query: {
          /**
           * @description The start date of the range (inclusive).
           *     Must be less than or equal to ResourceService.ApiContracts.AssignmentCandidates.GetBulkAssignmentCandidatesRequest.To.
           */
          from: string;
          /**
           * @description The end date of the range (inclusive).
           *     May be adjusted to align with the step interval in upper direction.
           *     Must be greater than or equal to ResourceService.ApiContracts.AssignmentCandidates.GetBulkAssignmentCandidatesRequest.From.
           */
          to: string;
          /**
           * @description The time interval between each assignment slot.
           *     If the range does not align perfectly with the step, the end date will be adjusted to the next valid slot.
           *     Must be between 1 minute and 1 hour (inclusive).
           *     Default is 15 minutes.
           */
          step?: string;
          /**
           * @description Whether to include reserved assignments in the results.
           *     Default is false.
           */
          includeReserved?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['BulkAssignmentCandidatesOperationResult'];
            'application/json': components['schemas']['BulkAssignmentCandidatesOperationResult'];
            'text/json': components['schemas']['BulkAssignmentCandidatesOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/clinical-coordinators': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          assignedEmployeeIds?: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CCAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CCAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/clinical-leads': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          assignedEmployeeIds?: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CLAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CLAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CLAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/assignment-candidates/organ-management-specialists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          assignedEmployeeIds?: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['OMSAssignmentCandidateIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['OMSAssignmentCandidateIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/banned-tail-numbers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: {
          searchQuery?: string;
          bannedTailNumberIds?: string;
          logisticProviderIds?: string;
          orderBy?: components['schemas']['BannedTailNumberOrderByOptions'];
          asc?: boolean;
          pageIndex?: number;
          itemsPerPage?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['BannedTailNumberListOperationResult'];
            'application/json': components['schemas']['BannedTailNumberListOperationResult'];
            'text/json': components['schemas']['BannedTailNumberListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateBannedTailNumberRequest'];
          'text/json': components['schemas']['CreateBannedTailNumberRequest'];
          'application/*+json': components['schemas']['CreateBannedTailNumberRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['BannedTailNumberOperationResult'];
            'application/json': components['schemas']['BannedTailNumberOperationResult'];
            'text/json': components['schemas']['BannedTailNumberOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/banned-tail-numbers/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['BannedTailNumberOperationResult'];
            'application/json': components['schemas']['BannedTailNumberOperationResult'];
            'text/json': components['schemas']['BannedTailNumberOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchBannedTailNumberRequest'];
          'text/json': components['schemas']['PatchBannedTailNumberRequest'];
          'application/*+json': components['schemas']['PatchBannedTailNumberRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['BannedTailNumberOperationResult'];
            'application/json': components['schemas']['BannedTailNumberOperationResult'];
            'text/json': components['schemas']['BannedTailNumberOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/schedules/clinical-coordinator': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description The identifier of the clinical specialist viewing the schedule. */
          resourceId: string;
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/{scheduleId}/validation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCShiftTypeScheduleValidationResultOperationResult'];
            'application/json': components['schemas']['CCShiftTypeScheduleValidationResultOperationResult'];
            'text/json': components['schemas']['CCShiftTypeScheduleValidationResultOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/{scheduleId}/refresh-hr': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/{scheduleId}/hr-system-conflicts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCResourceCCShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CCResourceCCShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CCResourceCCShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/hr-system-conflicts/resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCResolveHrSystemConflict'];
          'text/json': components['schemas']['CCResolveHrSystemConflict'];
          'application/*+json': components['schemas']['CCResolveHrSystemConflict'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCShiftOperationResult'];
            'application/json': components['schemas']['CCShiftOperationResult'];
            'text/json': components['schemas']['CCShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{planningProcessId}/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule:planning:process] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CCScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CCScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{planningProcessId}/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{planningProcessId}/cancel-generation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          generationJobId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{planningProcessId}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/planning-processes/{planningProcessId}/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          scheduleId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['CCRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['CCRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cc:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCRequirementsInputsSettings'];
          'text/json': components['schemas']['CCRequirementsInputsSettings'];
          'application/*+json': components['schemas']['CCRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['CCResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['CCResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cc:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCResourceRulesSettings'];
          'text/json': components['schemas']['CCResourceRulesSettings'];
          'application/*+json': components['schemas']['CCResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CCScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CCScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/nexus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:schedule] */
    get: {
      parameters: {
        query?: {
          /**
           * @description Start date for the schedule segment. If not provided:
           *     - Uses today's UTC date if current time is >= 09:00 EST
           *     - Uses yesterday's UTC date if current time is less than 09:00 EST
           */
          from?: string;
          /** @description Number of days to include in the schedule segment. Default is 7 days if not specified. */
          daysCount?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCScheduleNexusSegmentOperationResult'];
            'application/json': components['schemas']['CCScheduleNexusSegmentOperationResult'];
            'text/json': components['schemas']['CCScheduleNexusSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cc:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CCMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CCMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCSetShiftType'];
          'text/json': components['schemas']['CCSetShiftType'];
          'application/*+json': components['schemas']['CCSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCShiftOperationResult'];
            'application/json': components['schemas']['CCShiftOperationResult'];
            'text/json': components['schemas']['CCShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCResetShiftType'];
          'text/json': components['schemas']['CCResetShiftType'];
          'application/*+json': components['schemas']['CCResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/set-fixation-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule:fixation-type] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCSetFixationType'];
          'text/json': components['schemas']['CCSetFixationType'];
          'application/*+json': components['schemas']['CCSetFixationType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCSetMyShiftTypeModel'];
          'text/json': components['schemas']['CCSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['CCSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCShiftOperationResult'];
            'application/json': components['schemas']['CCShiftOperationResult'];
            'text/json': components['schemas']['CCShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCResetMyShiftTypeModel'];
          'text/json': components['schemas']['CCResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['CCResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-coordinator/shifts/set-manager': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cc:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CCSetDayManager'];
          'text/json': components['schemas']['CCSetDayManager'];
          'application/*+json': components['schemas']['CCSetDayManager'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CCShiftIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CCShiftIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CCShiftIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/clinical-specialists/rest-periods/{clinicalSpecialistRestPeriodId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:clinical-specialists:rest-period] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          clinicalSpecialistRestPeriodId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/clinical-specialists/rest-periods/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [create:clinical-specialists:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CreateEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/clinical-specialists/rest-periods/modify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:clinical-specialists:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/clinical-specialists/rest-periods/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [cancel:clinical-specialists:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CancelEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/clinical-specialists/rest-periods/delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [delete:clinical-specialists:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/crews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:aircrafts] */
    get: {
      parameters: {
        query?: {
          pageIndex?: number;
          itemsPerPage?: number;
          ids?: string;
          maoIds?: string;
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CrewViewListOperationResult'];
            'application/json': components['schemas']['CrewViewListOperationResult'];
            'text/json': components['schemas']['CrewViewListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description The identifier of the clinical specialist viewing the schedule. */
          resourceId: string;
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/{scheduleId}/validation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSShiftTypeScheduleValidationResultOperationResult'];
            'application/json': components['schemas']['CSShiftTypeScheduleValidationResultOperationResult'];
            'text/json': components['schemas']['CSShiftTypeScheduleValidationResultOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/{scheduleId}/refresh-hr': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/{scheduleId}/hr-system-conflicts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSResourceCSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CSResourceCSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CSResourceCSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/hr-system-conflicts/resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSResolveHrSystemConflict'];
          'text/json': components['schemas']['CSResolveHrSystemConflict'];
          'application/*+json': components['schemas']['CSResolveHrSystemConflict'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSShiftOperationResult'];
            'application/json': components['schemas']['CSShiftOperationResult'];
            'text/json': components['schemas']['CSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{planningProcessId}/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:planning:process] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CSScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CSScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{planningProcessId}/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{planningProcessId}/cancel-generation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          generationJobId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{planningProcessId}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/planning-processes/{planningProcessId}/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          scheduleId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Get list of regions for clinical specialist */
          query?: components['schemas']['GetCSRegions'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['RegionIEnumerableOperationResult'];
            'application/json': components['schemas']['RegionIEnumerableOperationResult'];
            'text/json': components['schemas']['RegionIEnumerableOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:inputs] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['CSRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['CSRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:settings:inputs] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSRequirementsInputsSettings'];
          'text/json': components['schemas']['CSRequirementsInputsSettings'];
          'application/*+json': components['schemas']['CSRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['CSResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['CSResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [read:cs:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSResourceRulesSettings'];
          'text/json': components['schemas']['CSResourceRulesSettings'];
          'application/*+json': components['schemas']['CSResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/period/time-group-inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:inputs] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSTimeGroupRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['CSTimeGroupRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['CSTimeGroupRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:settings:inputs] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSTimeGroupRequirementsInputsSettings'];
          'text/json': components['schemas']['CSTimeGroupRequirementsInputsSettings'];
          'application/*+json': components['schemas']['CSTimeGroupRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/period/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSPeriodResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['CSPeriodResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['CSPeriodResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSPeriodResourceRulesSettings'];
          'text/json': components['schemas']['CSPeriodResourceRulesSettings'];
          'application/*+json': components['schemas']['CSPeriodResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/period/deduction-shift-rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:deduction-shift-rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSDeductionShiftRulesOperationResult'];
            'application/json': components['schemas']['CSDeductionShiftRulesOperationResult'];
            'text/json': components['schemas']['CSDeductionShiftRulesOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:settings:deduction-shift-rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSDeductionShiftRules'];
          'text/json': components['schemas']['CSDeductionShiftRules'];
          'application/*+json': components['schemas']['CSDeductionShiftRules'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/settings/period/at-hub-weekly': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule:settings:at-hub-weekly] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSAtHubWeeklyRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['CSAtHubWeeklyRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['CSAtHubWeeklyRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:cs:schedule:settings:at-hub-weekly] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSAtHubWeeklyRequirementsInputsSettings'];
          'text/json': components['schemas']['CSAtHubWeeklyRequirementsInputsSettings'];
          'application/*+json': components['schemas']['CSAtHubWeeklyRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CSScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CSScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/nexus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:schedule] */
    get: {
      parameters: {
        query?: {
          /**
           * @description Start date for the schedule segment. If not provided:
           *     - Uses today's UTC date if current UTC time is >= 07:00 PST
           *     - Uses yesterday's UTC date if current UTC time is less than 07:00 PST
           */
          from?: string;
          /** @description Number of days to include in the schedule segment. Default is 7 days if not specified. */
          daysCount?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSScheduleNexusSegmentOperationResult'];
            'application/json': components['schemas']['CSScheduleNexusSegmentOperationResult'];
            'text/json': components['schemas']['CSScheduleNexusSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:cs:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['CSMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['CSMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSSetShiftType'];
          'text/json': components['schemas']['CSSetShiftType'];
          'application/*+json': components['schemas']['CSSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSShiftOperationResult'];
            'application/json': components['schemas']['CSShiftOperationResult'];
            'text/json': components['schemas']['CSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSResetShiftType'];
          'text/json': components['schemas']['CSResetShiftType'];
          'application/*+json': components['schemas']['CSResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/set-fixation-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:schedule:fixation-type] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSSetFixationType'];
          'text/json': components['schemas']['CSSetFixationType'];
          'application/*+json': components['schemas']['CSSetFixationType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSSetMyShiftTypeModel'];
          'text/json': components['schemas']['CSSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['CSSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CSShiftOperationResult'];
            'application/json': components['schemas']['CSShiftOperationResult'];
            'text/json': components['schemas']['CSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/clinical-specialists/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:cs:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CSResetMyShiftTypeModel'];
          'text/json': components['schemas']['CSResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['CSResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/drivers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: {
          isBanned?: boolean;
          searchQuery?: string;
          affiliationTypes?: string;
          pageIndex?: number;
          itemsPerPage?: number;
          orderBy?: components['schemas']['DriversSearchOrderBy'];
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['DriverListOperationResult'];
            'application/json': components['schemas']['DriverListOperationResult'];
            'text/json': components['schemas']['DriverListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateDriverRequest'];
          'text/json': components['schemas']['CreateDriverRequest'];
          'application/*+json': components['schemas']['CreateDriverRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['DriverOperationResult'];
            'application/json': components['schemas']['DriverOperationResult'];
            'text/json': components['schemas']['DriverOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/drivers/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['DriverOperationResult'];
            'application/json': components['schemas']['DriverOperationResult'];
            'text/json': components['schemas']['DriverOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchDriverRequest'];
          'text/json': components['schemas']['PatchDriverRequest'];
          'application/*+json': components['schemas']['PatchDriverRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['DriverOperationResult'];
            'application/json': components['schemas']['DriverOperationResult'];
            'text/json': components['schemas']['DriverOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: {
          pageIndex?: number;
          itemsPerPage?: number;
          employeeIds?: string;
          userIds?: string;
          /** @description Human organ */
          organType?: components['schemas']['Organ'];
          searchQuery?: string;
          status?: components['schemas']['Status'];
          baseLocation?: string;
          roles?: string;
          position?: string;
          isContractor?: boolean;
          trialProgramIds?: string;
          shiftTimeGroup?: string;
          orderBy?: components['schemas']['EmployeeSearchOrderBy'];
          surgeonAffiliationType?: components['schemas']['AffiliationType'];
          withDeleted?: boolean;
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataListOperationResult'];
            'application/json': components['schemas']['EmployeeDataListOperationResult'];
            'text/json': components['schemas']['EmployeeDataListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Allows to update own profile [update:employees-own] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchOwnEmployeeRequest'];
          'text/json': components['schemas']['PatchOwnEmployeeRequest'];
          'application/*+json': components['schemas']['PatchOwnEmployeeRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/employees/compact': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: {
          pageIndex?: number;
          itemsPerPage?: number;
          searchQuery?: string;
          userIds?: string;
          excludedUserIds?: string;
          hasReferencedUser?: boolean;
          status?: components['schemas']['Status'];
          roles?: string;
          isContractor?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeCompactDataListOperationResult'];
            'application/json': components['schemas']['EmployeeCompactDataListOperationResult'];
            'text/json': components['schemas']['EmployeeCompactDataListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** [update:employees OR update:cl:employees OR update:cs:employees] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchEmployeeRequest'];
          'text/json': components['schemas']['PatchEmployeeRequest'];
          'application/*+json': components['schemas']['PatchEmployeeRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/employees/userid/{userId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          userId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/userid/{userId}/basic': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] - Returns basic employee information for performance-critical scenarios */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          userId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeBasicDataOperationResult'];
            'application/json': components['schemas']['EmployeeBasicDataOperationResult'];
            'text/json': components['schemas']['EmployeeBasicDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/clinical-specialist': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** [update:employees OR update:cs:employees] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchEmployeeRequest'];
          'text/json': components['schemas']['PatchEmployeeRequest'];
          'application/*+json': components['schemas']['PatchEmployeeRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/employees/{id}/clinical-lead': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** [update:employees OR update:cl:employees] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchEmployeeRequest'];
          'text/json': components['schemas']['PatchEmployeeRequest'];
          'application/*+json': components['schemas']['PatchEmployeeRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/employees/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Allows to read own profile [read:employees-own] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/cancel-rest-period': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:employees:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/track-location': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * [update:employees]
     * @deprecated
     */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['TrackEmployeeLocationRequest'];
          'text/json': components['schemas']['TrackEmployeeLocationRequest'];
          'application/*+json': components['schemas']['TrackEmployeeLocationRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['TrackedLocationModelOperationResult'];
            'application/json': components['schemas']['TrackedLocationModelOperationResult'];
            'text/json': components['schemas']['TrackedLocationModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/track-location': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['TrackEmployeeLocationRequest'];
          'text/json': components['schemas']['TrackEmployeeLocationRequest'];
          'application/*+json': components['schemas']['TrackEmployeeLocationRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['TrackedLocationModelOperationResult'];
            'application/json': components['schemas']['TrackedLocationModelOperationResult'];
            'text/json': components['schemas']['TrackedLocationModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [activate:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/deactivate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [deactivate:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/clinical-specialist/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:cs:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/clinical-specialist/deactivate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:cs:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/clinical-lead/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:cl:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/{id}/clinical-lead/deactivate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:cl:employees] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/active-ids-by-roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: {
          roles?: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeIdDataIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['EmployeeIdDataIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['EmployeeIdDataIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/certificates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: {
          employeeId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CertificatesDataOperationResult'];
            'application/json': components['schemas']['CertificatesDataOperationResult'];
            'text/json': components['schemas']['CertificatesDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/certificates/by-employee-ids': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees] */
    get: {
      parameters: {
        query?: {
          employeeIds?: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeCertificatesDataIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['EmployeeCertificatesDataIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['EmployeeCertificatesDataIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/{employeeRestPeriodId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:employees:rest-period] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          employeeRestPeriodId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [create:employees:rest-period OR create:cs:employees:rest-period OR create:rs-liver:employees:rest-period OR create:rs-heart-or-lungs:employees:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CreateEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/modify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:employees:rest-period OR update:cs:employees:rest-period OR update:rs-liver:employees:rest-period OR update:rs-heart-or-lungs:employees:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [cancel:employees:rest-period OR cancel:cs:employees:rest-period OR cancel:rs-liver:employees:rest-period OR cancel:rs-heart-or-lungs:employees:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CancelEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [delete:employees:rest-period OR delete:cs:employees:rest-period OR delete:rs-liver:employees:rest-period OR delete:rs-heart-or-lungs:employees:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/employees/rest-periods/cancel-my-active': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [cancel:employees:my:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDataOperationResult'];
            'application/json': components['schemas']['EmployeeDataOperationResult'];
            'text/json': components['schemas']['EmployeeDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/gcc/employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get filtered and paginated list of employees for GCC passengers search.
     * @description Permissions: gcc:read:employees.
     *     M2M Auth is supported.
     */
    get: {
      parameters: {
        query?: {
          /** @description TMDX Employees IDs. */
          ids?: string;
          /**
           * @description Gets the search text to filter TMDX Employees by FirstName, LastName, Phone, or Email.
           *     Search is case-insensitive and supports partial matches.
           */
          searchText?: string;
          /** @description Zero-based page index for pagination. Default is 0. */
          pageIndex?: number;
          /** @description Maximum number of items to return per page. Default is 20. */
          itemsPerPage?: number;
          /** @description Field by which to order the results. Default is None (no specific ordering). */
          orderBy?: components['schemas']['GccEmployeeSearchOrderBy'];
          /**
           * @description Gets a value indicating whether to sort in ascending order.
           *     If null or false, sorts in descending order. Default is false.
           */
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeDetailsListOperationResult'];
            'application/json': components['schemas']['EmployeeDetailsListOperationResult'];
            'text/json': components['schemas']['EmployeeDetailsListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:htlus:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Get heart and lungs surgeon regions */
          query?: components['schemas']['GetHtLuSRegions'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRegionIEnumerableOperationResult'];
            'application/json': components['schemas']['SRegionIEnumerableOperationResult'];
            'text/json': components['schemas']['SRegionIEnumerableOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:htlus:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SRequirementsInputsSettings'];
          'text/json': components['schemas']['SRequirementsInputsSettings'];
          'application/*+json': components['schemas']['SRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['SResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['SResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:htlus:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResourceRulesSettings'];
          'text/json': components['schemas']['SResourceRulesSettings'];
          'application/*+json': components['schemas']['SResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/nexus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:htlus:schedule] */
    get: {
      parameters: {
        query?: {
          /**
           * @description Start date for the schedule segment. If not provided:
           *     - Uses today's UTC date if current time is >= 07:00 PT
           *     - Uses yesterday's UTC date if current time is less than 07:00 PT
           */
          from?: string;
          /** @description Number of days to include in the schedule segment. Default is 7 days if not specified. */
          daysCount?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleNexusSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleNexusSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleNexusSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:htlus:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['HtLuSSetShiftType'];
          'text/json': components['schemas']['HtLuSSetShiftType'];
          'application/*+json': components['schemas']['HtLuSSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:htlus:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['HtLuSResetShiftType'];
          'text/json': components['schemas']['HtLuSResetShiftType'];
          'application/*+json': components['schemas']['HtLuSResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:htlus:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SSetMyShiftTypeModel'];
          'text/json': components['schemas']['SSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/htlu-surgeons/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:htlus:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResetMyShiftTypeModel'];
          'text/json': components['schemas']['SResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/internal/technical/unlock': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['UnlockResourcesRequest'];
          'text/json': components['schemas']['UnlockResourcesRequest'];
          'application/*+json': components['schemas']['UnlockResourcesRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ResourcesUnlockedEventOperationResult'];
            'application/json': components['schemas']['ResourcesUnlockedEventOperationResult'];
            'text/json': components['schemas']['ResourcesUnlockedEventOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/inventory': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:inventories] */
    get: {
      parameters: {
        query?: {
          trialProgramIds?: string;
          caseIds?: string;
          inventoryPartIds?: string;
          inventoryPartTypes?: string;
          searchQuery?: string;
          pageIndex?: number;
          itemsPerPage?: number;
          orderBy?: components['schemas']['InventoryPartsSearchOrderBy'];
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InventoryPartModelListOperationResult'];
            'application/json': components['schemas']['InventoryPartModelListOperationResult'];
            'text/json': components['schemas']['InventoryPartModelListOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [create:inventories] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateInventoryPartRequest'];
          'text/json': components['schemas']['CreateInventoryPartRequest'];
          'application/*+json': components['schemas']['CreateInventoryPartRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InventoryPartModelOperationResult'];
            'application/json': components['schemas']['InventoryPartModelOperationResult'];
            'text/json': components['schemas']['InventoryPartModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/inventory/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:inventories] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InventoryPartModelListOperationResult'];
            'application/json': components['schemas']['InventoryPartModelListOperationResult'];
            'text/json': components['schemas']['InventoryPartModelListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    /** [delete:inventories] */
    delete: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** [update:inventories] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchInventoryPartRequest'];
          'text/json': components['schemas']['PatchInventoryPartRequest'];
          'application/*+json': components['schemas']['PatchInventoryPartRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InventoryPartModelOperationResult'];
            'application/json': components['schemas']['InventoryPartModelOperationResult'];
            'text/json': components['schemas']['InventoryPartModelOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/inventory/copy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:inventories] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CopyInventoryPartRequest'];
          'text/json': components['schemas']['CopyInventoryPartRequest'];
          'application/*+json': components['schemas']['CopyInventoryPartRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:lis:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Get liver surgeon regions */
          query?: components['schemas']['GetLiSRegions'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRegionIEnumerableOperationResult'];
            'application/json': components['schemas']['SRegionIEnumerableOperationResult'];
            'text/json': components['schemas']['SRegionIEnumerableOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:lis:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SRequirementsInputsSettings'];
          'text/json': components['schemas']['SRequirementsInputsSettings'];
          'application/*+json': components['schemas']['SRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['SResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['SResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:lis:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResourceRulesSettings'];
          'text/json': components['schemas']['SResourceRulesSettings'];
          'application/*+json': components['schemas']['SResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/nexus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:lis:schedule] */
    get: {
      parameters: {
        query?: {
          /**
           * @description Start date for the schedule segment. If not provided:
           *     - Uses today's UTC date if current time is >= 07:00 PT
           *     - Uses yesterday's UTC date if current time is less than 07:00 PT
           */
          from?: string;
          /** @description Number of days to include in the schedule segment. Default is 7 days if not specified. */
          daysCount?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleNexusSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleNexusSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleNexusSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:lis:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['LiSSetShiftType'];
          'text/json': components['schemas']['LiSSetShiftType'];
          'application/*+json': components['schemas']['LiSSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:lis:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['LiSResetShiftType'];
          'text/json': components['schemas']['LiSResetShiftType'];
          'application/*+json': components['schemas']['LiSResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:lis:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SSetMyShiftTypeModel'];
          'text/json': components['schemas']['SSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/li-surgeons/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:lis:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResetMyShiftTypeModel'];
          'text/json': components['schemas']['SResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/logos/files/signed-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [create:ocsconsoles, update:ocsconsoles, update:employees, update:employees_own] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateSignedUrlRequest'];
          'text/json': components['schemas']['CreateSignedUrlRequest'];
          'application/*+json': components['schemas']['CreateSignedUrlRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SignedUrlDataOperationResult'];
            'application/json': components['schemas']['SignedUrlDataOperationResult'];
            'text/json': components['schemas']['SignedUrlDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/ocsconsoles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves a paginated list of OCS Consoles matching the provided query filter.
     * @description Requires either permission:
     *     - read:ocsconsoles
     *     - gcc:read:ocsconsoles
     */
    get: {
      parameters: {
        query?: {
          /** @description Zero-based index of the page to return. Defaults to Packages.API.Utils.Constants.PagingConstants.DefaultPageIndex. */
          pageIndex?: number;
          /** @description Maximum number of items to include in a single page. Defaults to Packages.API.Utils.Constants.PagingConstants.DefaultItemsPerPage. */
          itemsPerPage?: number;
          /** @description Case-insensitive free text search applied to Serial Number, Case Number and Console Name fields. */
          searchQuery?: string;
          /** @description Comma-separated list of Console IDs (GUIDs). When provided limits results to this explicit set. */
          ids?: string;
          /** @description Comma-separated list of organ types to filter by (e.g. Liver, Heart, Lungs). Matches the console's organ specialization. */
          organType?: string;
          /** @description Comma-separated list of NOP Hub identifiers (GUIDs) to filter by. */
          nOPHub?: string;
          /** @description Comma-separated list of console status values (Available, Reserved, OnCase) to include. */
          ocsConsoleStatus?: string;
          /** @description Filters by maintenance state when specified. Null means do not filter on maintenance. */
          isInMaintenance?: boolean;
          /**
           * @description The filter type for trial programs.
           *     If set to ResourceService.ApiContracts.OscConsole.Requests.TrialProgramsFilterType.AnyOf, and ResourceService.ApiContracts.OscConsole.Requests.GetOscConsolesQuery.TrialProgramIds is not specified filter returns consoles with any program.
           *     If set to ResourceService.ApiContracts.OscConsole.Requests.TrialProgramsFilterType.AnyOf, and ResourceService.ApiContracts.OscConsole.Requests.GetOscConsolesQuery.TrialProgramIds is specified, filter returns consoles with programs matching the IDs.
           *     If set to ResourceService.ApiContracts.OscConsole.Requests.TrialProgramsFilterType.None, filter returns consoles without any trial program. ResourceService.ApiContracts.OscConsole.Requests.GetOscConsolesQuery.TrialProgramIds will be ignored.
           */
          trialProgramsFilterType?: components['schemas']['TrialProgramsFilterType'];
          /** @description Comma-separated list of trial program IDs (GUIDs). Only works with ResourceService.ApiContracts.OscConsole.Requests.TrialProgramsFilterType.AnyOf. */
          trialProgramIds?: string;
          /** @description Field used to order the result set. Defaults to ResourceService.Application.Models.OcsConsole.OcsConsoleSearchOrderBy.None. */
          orderBy?: components['schemas']['OcsConsoleSearchOrderBy'];
          /** @description Sort direction. true = ascending, false = descending (default). */
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Successful retrieval of consoles. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OcsConsoleDataListOperationResult'];
            'application/json': components['schemas']['OcsConsoleDataListOperationResult'];
            'text/json': components['schemas']['OcsConsoleDataListOperationResult'];
          };
        };
        /** @description Invalid query parameters supplied. */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Authentication required. */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Insufficient permissions. */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Server error while retrieving consoles. */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    put?: never;
    /** [create:ocsconsoles] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateOcsConsoleRequest'];
          'text/json': components['schemas']['CreateOcsConsoleRequest'];
          'application/*+json': components['schemas']['CreateOcsConsoleRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OcsConsoleDataOperationResult'];
            'application/json': components['schemas']['OcsConsoleDataOperationResult'];
            'text/json': components['schemas']['OcsConsoleDataOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/ocsconsoles/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:ocsconsoles] */
    get: {
      parameters: {
        query?: {
          withDeleted?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OcsConsoleDataOperationResult'];
            'application/json': components['schemas']['OcsConsoleDataOperationResult'];
            'text/json': components['schemas']['OcsConsoleDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    /** [delete:ocsconsoles] */
    delete: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** [update:ocsconsoles] */
    patch: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchOcsConsoleRequest'];
          'text/json': components['schemas']['PatchOcsConsoleRequest'];
          'application/*+json': components['schemas']['PatchOcsConsoleRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OcsConsoleDataOperationResult'];
            'application/json': components['schemas']['OcsConsoleDataOperationResult'];
            'text/json': components['schemas']['OcsConsoleDataOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/schedules/organ-management-specialist': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description The identifier of the clinical specialist viewing the schedule. */
          resourceId: string;
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/{scheduleId}/validation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSShiftTypeScheduleValidationResultOperationResult'];
            'application/json': components['schemas']['OMSShiftTypeScheduleValidationResultOperationResult'];
            'text/json': components['schemas']['OMSShiftTypeScheduleValidationResultOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/{scheduleId}/refresh-hr': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/{scheduleId}/hr-system-conflicts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSResourceOMSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['OMSResourceOMSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['OMSResourceOMSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/hr-system-conflicts/resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSResolveHrSystemConflict'];
          'text/json': components['schemas']['OMSResolveHrSystemConflict'];
          'application/*+json': components['schemas']['OMSResolveHrSystemConflict'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSShiftOperationResult'];
            'application/json': components['schemas']['OMSShiftOperationResult'];
            'text/json': components['schemas']['OMSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/planning-processes/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:oms:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/planning-processes/{planningProcessId}/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule:planning:process] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSScheduleSegmentOperationResult'];
            'application/json': components['schemas']['OMSScheduleSegmentOperationResult'];
            'text/json': components['schemas']['OMSScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/planning-processes/{planningProcessId}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/planning-processes/{planningProcessId}/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          scheduleId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['OMSRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['OMSRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:oms:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSRequirementsInputsSettings'];
          'text/json': components['schemas']['OMSRequirementsInputsSettings'];
          'application/*+json': components['schemas']['OMSRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['OMSResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['OMSResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:oms:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSResourceRulesSettings'];
          'text/json': components['schemas']['OMSResourceRulesSettings'];
          'application/*+json': components['schemas']['OMSResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSScheduleSegmentOperationResult'];
            'application/json': components['schemas']['OMSScheduleSegmentOperationResult'];
            'text/json': components['schemas']['OMSScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/nexus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:schedule] */
    get: {
      parameters: {
        query?: {
          /**
           * @description Start date for the schedule segment. If not provided:
           *     - Uses today's UTC date if current time is >= 09:00 EST
           *     - Uses yesterday's UTC date if current time is less than 09:00 EST
           */
          from?: string;
          /** @description Number of days to include in the schedule segment. Default is 7 days if not specified. */
          daysCount?: number;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSScheduleNexusSegmentOperationResult'];
            'application/json': components['schemas']['OMSScheduleNexusSegmentOperationResult'];
            'text/json': components['schemas']['OMSScheduleNexusSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:oms:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['OMSMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['OMSMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSSetShiftType'];
          'text/json': components['schemas']['OMSSetShiftType'];
          'application/*+json': components['schemas']['OMSSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSShiftOperationResult'];
            'application/json': components['schemas']['OMSShiftOperationResult'];
            'text/json': components['schemas']['OMSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSResetShiftType'];
          'text/json': components['schemas']['OMSResetShiftType'];
          'application/*+json': components['schemas']['OMSResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/set-fixation-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:schedule:fixation-type] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSSetFixationType'];
          'text/json': components['schemas']['OMSSetFixationType'];
          'application/*+json': components['schemas']['OMSSetFixationType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSSetMyShiftTypeModel'];
          'text/json': components['schemas']['OMSSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['OMSSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OMSShiftOperationResult'];
            'application/json': components['schemas']['OMSShiftOperationResult'];
            'text/json': components['schemas']['OMSShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/organ-management-specialist/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:oms:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['OMSResetMyShiftTypeModel'];
          'text/json': components['schemas']['OMSResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['OMSResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          from?: string;
          to?: string;
          exludeShiftAvailability?: boolean;
          reserved?: boolean;
          testAircrafts?: boolean;
          aircraftIds?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ResourcesAvailibilityDataOperationResult'];
            'application/json': components['schemas']['ResourcesAvailibilityDataOperationResult'];
            'text/json': components['schemas']['ResourcesAvailibilityDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/aircrafts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          from?: string;
          to?: string;
          exludeShiftAvailability?: boolean;
          reserved?: boolean;
          testAircrafts?: boolean;
          aircraftIds?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['AircraftAvailabilityView'][];
            'application/json': components['schemas']['AircraftAvailabilityView'][];
            'text/json': components['schemas']['AircraftAvailabilityView'][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          reserved?: boolean;
          from?: string;
          to?: string;
          exludeShiftAvailability?: boolean;
          employeeId?: string;
          pageIndex?: number;
          itemsPerPage?: number;
          employeeIds?: string;
          userIds?: string;
          /** @description Human organ */
          organType?: components['schemas']['Organ'];
          searchQuery?: string;
          status?: components['schemas']['Status'];
          baseLocation?: string;
          roles?: string;
          position?: string;
          isContractor?: boolean;
          trialProgramIds?: string;
          shiftTimeGroup?: string;
          orderBy?: components['schemas']['EmployeeSearchOrderBy'];
          surgeonAffiliationType?: components['schemas']['AffiliationType'];
          withDeleted?: boolean;
          asc?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeAvailabilityDataListOperationResult'];
            'application/json': components['schemas']['EmployeeAvailabilityDataListOperationResult'];
            'text/json': components['schemas']['EmployeeAvailabilityDataListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/ocsconsoles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          from?: string;
          to?: string;
          exludeShiftAvailability?: boolean;
          reserved?: boolean;
          testAircrafts?: boolean;
          aircraftIds?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OcsConsoleDataIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['OcsConsoleDataIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['OcsConsoleDataIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/reservation/employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          from: string;
          to: string;
          employeeRoles: string[];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeesReservationsDataOperationResult'];
            'application/json': components['schemas']['EmployeesReservationsDataOperationResult'];
            'text/json': components['schemas']['EmployeesReservationsDataOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/employees/{employeeId}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          statusAt?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          employeeId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeStatusOperationResult'];
            'application/json': components['schemas']['EmployeeStatusOperationResult'];
            'text/json': components['schemas']['EmployeeStatusOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/coordinators': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query?: {
          onlyPrimary?: boolean;
          /**
           * @description When `true`, returns only coordinators currently on an active shift.
           *     When `false`, returns all active coordinators regardless of shift status.
           *
           *     Default value is `true`.
           */
          onWorkingShift?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CurrentActiveCoordinatorIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CurrentActiveCoordinatorIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CurrentActiveCoordinatorIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/clinical-leads': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          /**
           * @description When `true`, returns only clinical leads currently on an active shift for the specified organ.
           *     When `false`, returns clinical leads with either an active shift for the organ or an organ specialization.
           *
           *     Default value is `true`.
           */
          onWorkingShift?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CurrentActiveClinicalLeadIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CurrentActiveClinicalLeadIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CurrentActiveClinicalLeadIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/resources/availability/organ-management-specialists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:resource-availabilities] */
    get: {
      parameters: {
        query: {
          /** @description Human organ */
          organ: components['schemas']['Organ'];
          /**
           * @description When `true`, returns only OMS currently on an active shift for the specified organ.
           *     When `false`, returns OMS with either an active shift for the organ or an organ specialization.
           *
           *     Default value is `true`.
           */
          onWorkingShift?: boolean;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CurrentActiveOmsIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['CurrentActiveOmsIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['CurrentActiveOmsIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/build-info': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['BuildInfoResponse'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/liver/{surgeonRestPeriodId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:retrieval-surgeons:liver:rest-period] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          surgeonRestPeriodId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/liver/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [create:retrieval-surgeons:liver:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CreateEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/liver/modify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:retrieval-surgeons:liver:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/liver/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [cancel:retrieval-surgeons:liver:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CancelEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/liver/delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [delete:retrieval-surgeons:liver:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/heart-lungs/{surgeonRestPeriodId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:retrieval-surgeons:heart-lungs:rest-period] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          surgeonRestPeriodId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/heart-lungs/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [create:retrieval-surgeons:heart-lungs:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CreateEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CreateEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/heart-lungs/modify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [update:retrieval-surgeons:heart-lungs:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['ModifyEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/heart-lungs/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [cancel:retrieval-surgeons:heart-lungs:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['CancelEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['CancelEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'application/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
            'text/json': components['schemas']['EmployeeRestPeriodModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/retrieval-surgeons/rest-periods/heart-lungs/delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [delete:retrieval-surgeons:heart-lungs:rest-period] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'text/json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
          'application/*+json': components['schemas']['DeleteEmployeeRestPeriodCommand'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PeriodScheduleOperationResult'];
            'application/json': components['schemas']['PeriodScheduleOperationResult'];
            'text/json': components['schemas']['PeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyPeriodSchedule.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/my-range': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:my:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.FromPeriodStartDay. */
          fromStartDayOfMonth?: string;
          /** @description First day of the first target period */
          fromPeriodStartDay?: string;
          /** @description Legacy name of ResourceService.API.Models.Scheduler.GetMyRangePeriodSchedule.ToPeriodStartDay. */
          toStartDayOfMonth?: string;
          /** @description First day of the last target period */
          toPeriodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['MyPeriodScheduleIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/{scheduleId}/validation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftTypeScheduleValidationResultOperationResult'];
            'application/json': components['schemas']['SShiftTypeScheduleValidationResultOperationResult'];
            'text/json': components['schemas']['SShiftTypeScheduleValidationResultOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/{scheduleId}/refresh-hr': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/{scheduleId}/hr-system-conflicts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          scheduleId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SResourceSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'application/json': components['schemas']['SResourceSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
            'text/json': components['schemas']['SResourceSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/hr-system-conflicts/resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResolveHrSystemConflict'];
          'text/json': components['schemas']['SResolveHrSystemConflict'];
          'application/*+json': components['schemas']['SResolveHrSystemConflict'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule:planning:process] */
    get: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.Application.Contracts.Scheduler.Queries.GetSchedulePlanningProcessByPeriod.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description First day of the target period */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          /** @description Legacy name of ResourceService.API.Models.Scheduler.CreatePlanningProcessModel.PeriodStartDay. */
          startDayOfMonth?: string;
          /** @description The first day of the period for which the schedule needs to be created. */
          periodStartDay?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{planningProcessId}/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule:planning:process] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{planningProcessId}/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{planningProcessId}/cancel-generation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          generationJobId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{planningProcessId}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/planning-processes/{planningProcessId}/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: {
          scheduleId?: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path: {
          planningProcessId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PlanningProcessOperationResult'];
            'application/json': components['schemas']['PlanningProcessOperationResult'];
            'text/json': components['schemas']['PlanningProcessOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [write:s:schedule] */
    get: {
      parameters: {
        query?: {
          /** @description Get list of regions for clinical specialist */
          query?: components['schemas']['GetSRegions'];
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRegionIEnumerableOperationResult'];
            'application/json': components['schemas']['SRegionIEnumerableOperationResult'];
            'text/json': components['schemas']['SRegionIEnumerableOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/settings/inputs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule:planning:process] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'application/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
            'text/json': components['schemas']['SRequirementsInputsSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:s:schedule:planning:process] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SRequirementsInputsSettings'];
          'text/json': components['schemas']['SRequirementsInputsSettings'];
          'application/*+json': components['schemas']['SRequirementsInputsSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/settings/rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule:settings:rules] */
    get: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SResourceRulesSettingsOperationResult'];
            'application/json': components['schemas']['SResourceRulesSettingsOperationResult'];
            'text/json': components['schemas']['SResourceRulesSettingsOperationResult'];
          };
        };
      };
    };
    put?: never;
    /** [write:s:schedule:settings:rules] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResourceRulesSettings'];
          'text/json': components['schemas']['SResourceRulesSettings'];
          'application/*+json': components['schemas']['SResourceRulesSettings'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/my': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** [read:s:my:schedule] */
    get: {
      parameters: {
        query: {
          /** @description Inclusive lower boundary of shifts diapason */
          from: string;
          /** @description Inclusive upper boundary of shifts diapason */
          to: string;
        };
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SMyScheduleSegmentOperationResult'];
            'application/json': components['schemas']['SMyScheduleSegmentOperationResult'];
            'text/json': components['schemas']['SMyScheduleSegmentOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/set-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SSetShiftType'];
          'text/json': components['schemas']['SSetShiftType'];
          'application/*+json': components['schemas']['SSetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/reset-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResetShiftType'];
          'text/json': components['schemas']['SResetShiftType'];
          'application/*+json': components['schemas']['SResetShiftType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/set-fixation-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:schedule:fixation-type] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SSetFixationType'];
          'text/json': components['schemas']['SSetFixationType'];
          'application/*+json': components['schemas']['SSetFixationType'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/set-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SSetMyShiftTypeModel'];
          'text/json': components['schemas']['SSetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SSetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SShiftOperationResult'];
            'application/json': components['schemas']['SShiftOperationResult'];
            'text/json': components['schemas']['SShiftOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/schedules/surgeons/shifts/reset-my-shift-type': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** [write:s:my:schedule] */
    post: {
      parameters: {
        query?: never;
        header?: {
          /** @description Tenant identifier (Guid) to perform operations as a Customer. */
          'X-Tenant-Id'?: string;
        };
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['SResetMyShiftTypeModel'];
          'text/json': components['schemas']['SResetMyShiftTypeModel'];
          'application/*+json': components['schemas']['SResetMyShiftTypeModel'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  schemas: {
    /**
     * ActionType
     * @enum {string}
     */
    ActionType: ActionType;
    /** AffiliationData */
    AffiliationData: {
      affiliationType: components['schemas']['AffiliationType'];
      /** Format: uuid */
      txCenterId: string | null;
      /** Format: uuid */
      opoId: string | null;
    };
    /**
     * AffiliationType
     * @enum {string}
     */
    AffiliationType: AffiliationType;
    /** AircraftAvailabilityView */
    AircraftAvailabilityView: {
      /** Format: uuid */
      id: string;
      /** Format: int32 */
      myAirOpsId: number;
      defaultFlightNumber: string | null;
      description: string | null;
      registration: string | null;
      /** Format: int32 */
      fleetId: number | null;
      icaoAddress: string | null;
      isHidden: boolean;
      serialNumber: string | null;
      /** Format: double */
      longitude: number | null;
      /** Format: double */
      latitude: number | null;
      /** Format: int32 */
      baseAirportId: number | null;
      baseAirport: components['schemas']['AirportView'];
      /** Format: int32 */
      currentAirportId: number | null;
      currentAirport: components['schemas']['AirportView'];
      isTest: boolean;
      availabilities: components['schemas']['CrewDutyAvailabilityView'][];
      predictedAvailabilities: components['schemas']['CrewDutyAvailabilityView'][];
      historicalAvailabilities: components['schemas']['CrewDutyAvailabilityView'][];
      trips: components['schemas']['TripView'][];
      maintenances: components['schemas']['MaintenanceEntryView'][];
      predictedCrewDuties: components['schemas']['CrewDutyView'][];
      reservations: components['schemas']['ReservationData'][];
      diaryEntries: components['schemas']['DiaryEntryView'][];
    };
    /**
     * AircraftOrderBy
     * @enum {string}
     */
    AircraftOrderBy: AircraftOrderBy;
    /** AircraftView */
    AircraftView: {
      /** Format: uuid */
      id: string;
      /** Format: int32 */
      maoId: number;
      cbpDecalNumber: string | null;
      defaultFlightNumber: string | null;
      description: string | null;
      /** Format: int32 */
      fleetId: number | null;
      icaoAddress: string | null;
      isHidden: boolean;
      registration: string | null;
      serialNumber: string | null;
      isTest: boolean;
    };
    /** AircraftViewListOperationResult */
    AircraftViewListOperationResult: {
      data: components['schemas']['AircraftViewPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** AircraftViewPaginatedData */
    AircraftViewPaginatedData: {
      items: components['schemas']['AircraftView'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** AirportView */
    AirportView: {
      /** Format: uuid */
      id: string;
      name: string | null;
      icao: string | null;
      iata: string | null;
      faa: string | null;
      /** Format: double */
      latitude: number | null;
      /** Format: double */
      longitude: number | null;
      /** Format: int32 */
      countryId: number;
      servedCity: string | null;
      ianaTimeZone: string | null;
      /** Format: int32 */
      maoId: number;
    };
    /** AssignmentCandidateLocation */
    AssignmentCandidateLocation: {
      /** Format: uuid */
      locationId: string;
      postalCode: string | null;
      city: string | null;
      country: string | null;
      state: string | null;
      addressLine: string | null;
      /** Format: double */
      latitude: number | null;
      /** Format: double */
      longitude: number | null;
    };
    /** AssignmentCandidateMatch */
    AssignmentCandidateMatch: {
      matchType: components['schemas']['CandidateMatchType'];
      caseType: components['schemas']['CaseMatchType'];
      availableActionType: components['schemas']['ActionType'];
    };
    /**
     * AutoSchedulerInfo
     * @description Contains auto scheduler solution metadata.
     */
    AutoSchedulerInfo: {
      readonly hasSolution: boolean;
      resultType: components['schemas']['AutoSchedulerResultType'];
      /**
       * Format: date-span
       * @description Total time spent to obtain a solution.
       */
      spendTime: string;
      /** @description Error message from auto scheduler */
      errorMessage: string | null;
      /** @description True if this is information about final best proposed solution */
      isFinal: boolean;
      /**
       * Format: int32
       * @description How many solutions found on current moment
       */
      foundSolutions: number;
      /**
       * Format: int32
       * @description How many soft rules violations contains current proposed solutions
       */
      softRulesViolations: number;
    };
    /**
     * AutoSchedulerResultType
     * @description The result of the automatic planning algorithm.
     * @enum {string}
     */
    AutoSchedulerResultType: AutoSchedulerResultType;
    /** BannedTailNumber */
    BannedTailNumber: {
      /** Format: uuid */
      id?: string;
      tailNumber: string | null;
      /** Format: uuid */
      logisticProviderId?: string | null;
      comment?: string | null;
      /** Format: date-time */
      createdAt?: string;
      /** Format: date-time */
      modifiedAt?: string;
    };
    /** BannedTailNumberListOperationResult */
    BannedTailNumberListOperationResult: {
      data: components['schemas']['BannedTailNumberPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** BannedTailNumberOperationResult */
    BannedTailNumberOperationResult: {
      data: components['schemas']['BannedTailNumber'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * BannedTailNumberOrderByOptions
     * @enum {string}
     */
    BannedTailNumberOrderByOptions: BannedTailNumberOrderByOptions;
    /** BannedTailNumberPaginatedData */
    BannedTailNumberPaginatedData: {
      items: components['schemas']['BannedTailNumber'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** BuildInfoResponse */
    BuildInfoResponse: {
      gitCommitHash: string | null;
      gitCommitMessage: string | null;
      gitBranchName: string | null;
      gitPlatformVersion: string | null;
    };
    /**
     * BulkAssignmentCandidates
     * @description Represents best assignment candidates for clinical specialists and retrieval surgeons for organ donor hubs within a specified time range and step.
     */
    BulkAssignmentCandidates: {
      range: components['schemas']['BulkAssignmentRange'];
      /**
       * @description List of all clinical specialists available for assignment.
       *     You can get clinical specialist details from the ClinicalSpecialists collection by index in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.CSCandidatesNode.BestForSlot from ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.CSCandidates.
       */
      clinicalSpecialists: components['schemas']['ClinicalSpecialist'][];
      /**
       * @description List of all retrieval surgeons available for assignment.
       *     You can get retrieval surgeon details from the RetrievalSurgeons collection by index in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.RSCandidatesNode.BestsForSlot from ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.RSCandidates.
       */
      retrievalSurgeons: components['schemas']['RetrievalSurgeon'][];
      /**
       * @description List of nodes for each donor/organ/hub combination with clinical specialist candidates for each time slot.
       *     You can get clinical specialist details from the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.ClinicalSpecialists collection by index in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.CSCandidatesNode.BestForSlot.
       */
      csCandidates: components['schemas']['CSCandidatesNode'][];
      /**
       * @description List of nodes for each donor/organ/hub combination with retrieval surgeon candidates for each time slot.
       *     You can get retrieval surgeon details from the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.RetrievalSurgeons collection by index in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.RSCandidatesNode.BestsForSlot.
       */
      rsCandidates: components['schemas']['RSCandidatesNode'][];
    };
    /** BulkAssignmentCandidatesOperationResult */
    BulkAssignmentCandidatesOperationResult: {
      data: components['schemas']['BulkAssignmentCandidates'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * BulkAssignmentRange
     * @description Defines a range of dates with a specific step interval for bulk assignment queries.
     */
    BulkAssignmentRange: {
      /**
       * Format: date-time
       * @description The start date of the range (inclusive).
       *     Must be less than or equal to ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentRange.To.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end date of the range (inclusive).
       *     May be adjusted to align with the step interval in upper direction.
       *     Must be greater than or equal to ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentRange.From.
       */
      to: string;
      /**
       * Format: date-span
       * @description The time interval between each assignment slot.
       *     If the range does not align perfectly with the step, the end date will be adjusted to the next valid slot.
       *     Must be between 1 minute and 1 hour (inclusive).
       */
      step: string;
    };
    /** CCAssignmentCandidate */
    CCAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      phone: string | null;
      lastActiveShift: components['schemas']['CCAssignmentCandidateShift'];
      nextOnCallShift: components['schemas']['CCAssignmentCandidateShift'];
      isAssigned: boolean;
    };
    /** CCAssignmentCandidateIReadOnlyCollectionOperationResult */
    CCAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CCAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCAssignmentCandidateShift
     * @description Clinical specialist shift base information
     */
    CCAssignmentCandidateShift: {
      /**
       * Format: date
       * @description The day on which the work shift takes place.
       */
      day: string;
      /**
       * Format: date-time
       * @description The start timestamp of the shift.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift.
       */
      to: string;
      shiftType: components['schemas']['CCShiftType'];
      /**
       * @description Indicates whether the coordinator should perform the role of manager.
       *     Clinical coordinator should has one manger on each day
       */
      isManager: boolean | null;
    };
    /**
     * CCCustomRule
     * @description Custom work rule for clinical coordinator
     */
    CCCustomRule: {
      /**
       * Format: uuid
       * @description Resource for which this rule is used
       */
      resourceId: string;
      status: components['schemas']['CCShiftType'];
      /** @description Days on which shifts should be assigned. */
      dayOfWeeks: components['schemas']['DayOfWeek'][];
    };
    /**
     * CCMyScheduleSegment
     * @description Clinical specialist schedule for a specific period for the clinical specialist viewing the schedule.
     */
    CCMyScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      myShifts: components['schemas']['CCResourceScheduleSegment'];
      /**
       * @description Shifts of resource grouped by clinical specialist id.
       *     Key is resource id.
       */
      otherResourcesShifts: {
        [key: string]: components['schemas']['CCResourceScheduleSegment'];
      } | null;
      /** @description Hub information for all hubs referenced in shifts. */
      hubs: {
        [key: string]: components['schemas']['RegionalHub'];
      } | null;
    };
    /** CCMyScheduleSegmentOperationResult */
    CCMyScheduleSegmentOperationResult: {
      data: components['schemas']['CCMyScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCRequirementsInputsSettings
     * @description Settings of the basic rules for service requirements by country.
     */
    CCRequirementsInputsSettings: {
      /**
       * Format: int32
       * @description Count of total on call coordinators per day
       */
      onCallPerDay: number;
    };
    /** CCRequirementsInputsSettingsOperationResult */
    CCRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['CCRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCResetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.ClinicalCoordinator.CCResetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    CCResetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
    };
    /**
     * CCResetShiftType
     * @description Resets the specified shift type on a specified day for a specified resource.
     */
    CCResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /**
     * CCResolveHrSystemConflict
     * @description Resolve HR system conflict command for Clinical Coordinator
     */
    CCResolveHrSystemConflict: {
      /** Format: uuid */
      conflictId: string;
      setShiftData: components['schemas']['SetCCShiftData'];
    };
    /**
     * CCResource
     * @description Information about clinical coordinator - type of Transmedics resource
     */
    CCResource: {
      /**
       * Format: uuid
       * @description Resource id
       */
      id: string;
      /** @description FirstName */
      firstName: string | null;
      /** @description LastName */
      lastName: string | null;
      /** @description Link to profile image */
      profilePhoto: string | null;
      /** @description Resource phone number */
      phoneNumber: string | null;
      type: components['schemas']['CCResourceType'];
    };
    /**
     * CCResourceCCShiftTypeHrSystemConflict
     * @description Represents a conflict between a scheduled shift and a HR system shift for a specific resource on a given day.
     */
    CCResourceCCShiftTypeHrSystemConflict: {
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier of the conflict.
       */
      conflictId: string;
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the schedule associated with this conflict.
       */
      scheduleId: string;
      type: components['schemas']['ScheduleHrSystemConflictType'];
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the resource.
       */
      resourceId: string;
      resource: components['schemas']['CCResource'];
      /**
       * Format: date
       * @description Gets or sets the day represented as a System.DateOnly value.
       */
      day: string;
      hrSystemShiftType: components['schemas']['CCShiftType'];
      scheduleShiftType: components['schemas']['CCShiftType'];
    };
    /** CCResourceCCShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult */
    CCResourceCCShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CCResourceCCShiftTypeHrSystemConflict'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCResourceRulesSettings
     * @description Clinical coordinator work rules.
     */
    CCResourceRulesSettings: {
      tcOneTwoRules: components['schemas']['CCTypeSpecificRules'];
      tcThreeRules: components['schemas']['CCTypeSpecificRules'];
      /**
       * Format: int32
       * @description Count of weekend per month
       */
      weekendCount: number;
      deductionRule: components['schemas']['VacationDeductionRule'];
      /** @description List of custom rules for clinical coordinators */
      customRules: components['schemas']['CCCustomRule'][];
    };
    /** CCResourceRulesSettingsOperationResult */
    CCResourceRulesSettingsOperationResult: {
      data: components['schemas']['CCResourceRulesSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCResourceScheduleNexusSegment
     * @description Schedule for single clinical coordinator for Nexus view
     */
    CCResourceScheduleNexusSegment: {
      resource: components['schemas']['CCResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['CCShift'];
      } | null;
    };
    /**
     * CCResourceScheduleSegment
     * @description Schedule for single clinical specialist
     */
    CCResourceScheduleSegment: {
      resource: components['schemas']['CCResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['CCShift'];
      } | null;
    };
    /**
     * CCResourceType
     * @description Clinical coordinator resource type.
     * @enum {string}
     */
    CCResourceType: CCResourceType;
    /**
     * CCScheduleNexusSegment
     * @description Clinical Coordinator schedule segment for Nexus view
     */
    CCScheduleNexusSegment: {
      /**
       * Format: date-time
       * @description Start date of the schedule segment
       */
      from: string;
      /**
       * Format: date-time
       * @description End date of the schedule segment
       */
      to: string;
      /** @description Dictionary of resource shifts keyed by resource ID */
      resourcesShifts: {
        [key: string]: components['schemas']['CCResourceScheduleNexusSegment'];
      } | null;
    };
    /** CCScheduleNexusSegmentOperationResult */
    CCScheduleNexusSegmentOperationResult: {
      data: components['schemas']['CCScheduleNexusSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCScheduleSegment
     * @description Clinical specialist schedule for a specific period.
     */
    CCScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      /**
       * @description Shifts of clinical specialists grouped by clinical specialist id.
       *     Key is clinical specialist id.
       */
      resourcesShifts: {
        [key: string]: components['schemas']['CCResourceScheduleSegment'];
      } | null;
    };
    /** CCScheduleSegmentOperationResult */
    CCScheduleSegmentOperationResult: {
      data: components['schemas']['CCScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCSetDayManager
     * @description Set manager for particular day is specified schedule
     */
    CCSetDayManager: {
      /**
       * Format: uuid
       * @description Target scheduler id to set manager.
       */
      scheduleId: string;
      /**
       * Format: date-time
       * @description Target day to set manager.
       */
      day: string;
      /**
       * Format: uuid
       * @description The resource that will be set as a manager.
       */
      resourceId: string;
    };
    /** CCSetFixationType */
    CCSetFixationType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift is located.
       */
      scheduleId: string;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift fixation type is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is located.
       */
      day: string;
      fixationType: components['schemas']['ShiftFixationType'];
    };
    /**
     * CCSetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.ClinicalCoordinator.CCSetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    CCSetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      /** @description If true, then shift type can't be changed by algorithm */
      required: boolean;
      shiftType: components['schemas']['CCShiftType'];
      /**
       * @description Indicates whether the coordinator should perform the role of manager.
       *     Clinical coordinator should has one manger on each day
       */
      isManager: boolean | null;
    };
    /** CCSetShiftType */
    CCSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      shiftType: components['schemas']['CCShiftType'];
      /**
       * @description Indicates whether the coordinator should perform the role of manager.
       *     Clinical coordinator should has one manger on each day
       */
      isManager: boolean | null;
      fixationType?: components['schemas']['ShiftFixationType'];
    };
    /**
     * CCShift
     * @description Clinical specialist shift
     */
    CCShift: {
      /**
       * Format: uuid
       * @description The schedule identifier to which the shift belongs.
       */
      scheduleId: string;
      /**
       * Format: date-time
       * @description The day on which the work shift takes place.
       */
      day: string;
      /**
       * Format: date-time
       * @description The start timestamp of the shift.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift.
       */
      to: string;
      /**
       * Format: uuid
       * @description The ID of the resource that is scheduled to work this shift.
       */
      resourceId: string;
      shiftStatus: components['schemas']['ShiftStatus'];
      /** @description True is this shift can be changed manually */
      isEditable: boolean;
      /** @description True if this shift is placed on the pre (preliminary) schedule. */
      isPreSchedule: boolean;
      fixationType: components['schemas']['ShiftFixationType'];
      /** @description True if the shift source is HrSystem. */
      isHrShift: boolean;
      shiftType: components['schemas']['CCShiftType'];
      /**
       * @description Indicates whether the coordinator should perform the role of manager.
       *     Clinical coordinator should has one manger on each day
       */
      isManager: boolean | null;
    };
    /** CCShiftIReadOnlyCollectionOperationResult */
    CCShiftIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CCShift'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CCShiftOperationResult */
    CCShiftOperationResult: {
      data: components['schemas']['CCShift'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCShiftType
     * @description Type of clinical coordinator shift.
     * @enum {string}
     */
    CCShiftType: CCShiftType;
    /** CCShiftTypeCompositeShift */
    CCShiftTypeCompositeShift: {
      /** Format: uuid */
      resourceId: string;
      /** Format: uuid */
      regionId: string | null;
      /** Format: uuid */
      hubId: string | null;
      /** Format: date-time */
      fromOffset: string;
      /** Format: date-time */
      toOffset: string;
      shiftType: components['schemas']['CCShiftType'];
      isManager: boolean | null;
      /** Format: date-time */
      readonly fromUtc: string;
      /** Format: date-time */
      readonly toUtc: string;
    };
    /**
     * CCShiftTypeNeighborRule
     * @description The rule limits the possibility of adjacent shifts.
     */
    CCShiftTypeNeighborRule: {
      /**
       * Format: int32
       * @description Required days count before target shift
       */
      daysBefore: number;
      /**
       * Format: int32
       * @description Required days count after target shift
       */
      daysAfter: number;
      /** @description Allowable shift type before target shift */
      beforeShiftTypes: components['schemas']['CCShiftType'][];
      /** @description Allowable shift type after target shift */
      afterShiftTypes: components['schemas']['CCShiftType'][];
    };
    /**
     * CCShiftTypeResourceRulesViolations
     * @description Violations of employee work rules.
     */
    CCShiftTypeResourceRulesViolations: {
      /**
       * @description Violations of the number of shifts by type per period.
       *     Key is shift type.
       */
      periodShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountByTypeViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @description Violations of the number of shifts on weekend by type per period.
       *     Key is shift type.
       */
      periodShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountOnWeekEndViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
      } | null;
      periodShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      periodShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      /**
       * @description Violation of the number shifts in row by shift type.
       *     Key is shift type.
       */
      shiftTypeInRowViolations: {
        OnCall: components['schemas']['ShiftInRowRuleViolations'];
        NoCall: components['schemas']['ShiftInRowRuleViolations'];
        Unavailable: components['schemas']['ShiftInRowRuleViolations'];
        Vacation: components['schemas']['ShiftInRowRuleViolations'];
        Sick: components['schemas']['ShiftInRowRuleViolations'];
        WeekendOff: components['schemas']['ShiftInRowRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftNeighborViolations: {
        OnCall: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
        NoCall: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
        Unavailable: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
        Vacation: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
        Sick: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
        WeekendOff: components['schemas']['CCShiftTypeShiftNeighborRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftAllowedDayOfWeekViolations: {
        OnCall: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        NoCall: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Unavailable: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Vacation: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Sick: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        WeekendOff: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolations'];
      } | null;
    };
    /**
     * CCShiftTypeScheduleValidationResult
     * @description Result of schedule validation.
     */
    CCShiftTypeScheduleValidationResult: {
      /** @description True if there are any validation rule violations. */
      hasRuleViolations: boolean;
      /**
       * @description Indicates whether preprocessing has been performed for the schedule.
       *     Schedules without preprocessing can be obtained faster, but they may contain inaccuracies.
       */
      isPreprocessed: boolean;
      scheduleSize: components['schemas']['ScheduleSize'];
      publishReadiness: components['schemas']['SchedulePublishReadiness'];
      /** @description Violations of the rules of service (OnCall, PhoneSupport) requirements by day. */
      dailyRulesViolations: {
        [key: string]: components['schemas']['CCShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of the rules of service (OnCall, PhoneSupport) requirements by week.
       *     Key of dictionary is first day of week.
       */
      weeklyRulesViolations: {
        [key: string]: components['schemas']['CCShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of employees work rules.
       *     Key of dictionary is resource id.
       */
      resourceRulesViolations: {
        [key: string]: components['schemas']['CCShiftTypeResourceRulesViolations'];
      } | null;
    };
    /** CCShiftTypeScheduleValidationResultOperationResult */
    CCShiftTypeScheduleValidationResultOperationResult: {
      data: components['schemas']['CCShiftTypeScheduleValidationResult'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CCShiftTypeServicesRulesViolations
     * @description Violation of the requirements for the number of shifts of a certain type across countries, regions and hubs.
     */
    CCShiftTypeServicesRulesViolations: {
      /** @description Violation of needs across the country for different types of shifts. */
      countryRulesViolations: {
        OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
        Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
        Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
        WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
      } | null;
      /**
       * @description Violation of needs in different regions for different types of shifts.
       *     Key is region id.
       */
      regionsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
          WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
      /**
       * @description Violation of needs in different hubs for different types of shifts.
       *     Key is hub id.
       */
      hubsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
          WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
    };
    /**
     * CCShiftTypeShiftAllowedDayOfWeekRuleViolation
     * @description Violation of shift type day of week rule
     */
    CCShiftTypeShiftAllowedDayOfWeekRuleViolation: {
      /**
       * Format: date
       * @description Date of target shift
       */
      targetDate: string;
      actual: components['schemas']['DayOfWeek'];
    };
    /** CCShiftTypeShiftAllowedDayOfWeekRuleViolations */
    CCShiftTypeShiftAllowedDayOfWeekRuleViolations: {
      actualRule: components['schemas']['DayOfWeek'][];
      violations: components['schemas']['CCShiftTypeShiftAllowedDayOfWeekRuleViolation'][];
    };
    /** CCShiftTypeShiftAvailabilityData */
    CCShiftTypeShiftAvailabilityData: {
      currentShift: components['schemas']['CCShiftTypeCompositeShift'];
      isPartialCurrentShift: boolean;
      nextShift: components['schemas']['CCShiftTypeCompositeShift'];
      isPartialNextShift: boolean;
      activeShifts: components['schemas']['CCShiftTypeCompositeShift'][];
      unavailabilities: components['schemas']['CCShiftTypeCompositeShift'][];
    };
    /**
     * CCShiftTypeShiftNeighborRuleViolation
     * @description Shift neighbor rule violation incident
     */
    CCShiftTypeShiftNeighborRuleViolation: {
      /**
       * Format: date-time
       * @description A target shift for which the neighborhood requirement is not met.
       */
      targetDate: string;
      /** @description Current types of shifts before the target. */
      actualBefore: components['schemas']['CCShiftType'][];
      /** @description Current types of shifts after the target. */
      actualAfter: components['schemas']['CCShiftType'][];
    };
    /**
     * CCShiftTypeShiftNeighborRuleViolations
     * @description Violations of the rule on the shift neighbors
     */
    CCShiftTypeShiftNeighborRuleViolations: {
      violatedRule: components['schemas']['CCShiftTypeNeighborRule'];
      /** @description Collection of rule violation incidents */
      violations: components['schemas']['CCShiftTypeShiftNeighborRuleViolation'][];
    };
    /**
     * CCTypeSpecificRules
     * @description Coordinator type settings specific to coordinator role
     */
    CCTypeSpecificRules: {
      /**
       * Format: int32
       * @description Min count of on calls shifts per month, inclusive
       */
      minOnCall: number;
      /**
       * Format: int32
       * @description Max count of on calls shifts per month, inclusive
       */
      maxOnCall: number;
    };
    /** CLAssignmentCandidate */
    CLAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      phone: string | null;
      isAssigned: boolean;
      /** Format: date-time */
      phoneSupportStart: string | null;
      /** Format: date-time */
      phoneSupportEnd: string | null;
      /** Format: date-time */
      overlapOnCallShiftStart: string | null;
      /** Format: date-time */
      overlapOnCallShiftEnd: string | null;
      csOrganCertificates: components['schemas']['Organ'][];
      phoneSupportOrganCertificates: components['schemas']['Organ'][];
      csActiveReservationCase: components['schemas']['CSActiveReservationCase'];
    };
    /** CLAssignmentCandidateIReadOnlyCollectionOperationResult */
    CLAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CLAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CSActiveReservationCase */
    CSActiveReservationCase: {
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
    };
    /** CSAssignmentCandidate */
    CSAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      employeeRoles: string[];
      employeeCertificates: components['schemas']['Organ'][];
      lastTrackedLocation: components['schemas']['TrackedLocationModel'];
      lastCallDays: components['schemas']['LastCallInfo'];
      conflictedReservation?: components['schemas']['ConflictedReservation'];
      match: components['schemas']['CSAssignmentCandidateMatch'];
      shiftCertificates: components['schemas']['Organ'][];
      /** Format: uuid */
      baseLocation: string | null;
      /** Format: date-span */
      onCallBeforeTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onCallBeforeOr?: string | null;
      /** Format: date-span */
      onCallAfterTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onCallAfterOr?: string | null;
      /** Format: double */
      onCallBeforeTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onCallBeforeOrMinutes?: number | null;
      /** Format: double */
      onCallAfterTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onCallAfterOrMinutes?: number | null;
      /** Format: date-span */
      onRestEndsBeforeTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onRestEndsBeforeOr?: string | null;
      /** Format: double */
      onRestEndsBeforeTargetMinutes: number | null;
      /** Format: date-span */
      onRestStartsAfterTarget: string | null;
      /** Format: double */
      onRestStartsAfterTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onRestEndsBeforeOrMinutes?: number | null;
      conflictedRest?: components['schemas']['ConflictedRest'];
      days30Stats: components['schemas']['CSDays30Stats'];
      employeePhoneSupportOrganCertificates: components['schemas']['Organ'][];
      employeeProctorOrganCertificates: components['schemas']['Organ'][];
      employeeShadowOrganCertificates: components['schemas']['Organ'][];
      employeeTrialCertificates: components['schemas']['Organ'][];
      /** Format: uuid */
      shiftHubId: string | null;
      lastCertificationAtHubInfo: components['schemas']['CSLastCertificationsAtHub'];
      trialProgramIds: string[];
    };
    /** CSAssignmentCandidateIReadOnlyCollectionOperationResult */
    CSAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CSAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CSAssignmentCandidateMatch */
    CSAssignmentCandidateMatch: {
      matchType: components['schemas']['CandidateMatchType'];
      caseType: components['schemas']['CaseMatchType'];
      availableActionType: components['schemas']['ActionType'];
      onCallMatchType: components['schemas']['CandidateMatchType'];
      onCallBeforeTargetMatchType: components['schemas']['CandidateMatchType'];
      onCallAfterTargetMatchType: components['schemas']['CandidateMatchType'];
      onRestMatchType: components['schemas']['CandidateMatchType'];
      onRestEndsBeforeTargetMatchType: components['schemas']['CandidateMatchType'];
      onRestStartsAfterTargetMatchType: components['schemas']['CandidateMatchType'];
      lastCertificationAtHubMatchType?: components['schemas']['CandidateMatchType'];
      lastCertificationsAtHubMatchType: components['schemas']['PerOrganMatchType'];
    };
    /**
     * CSAtHubWeeklyRequirementsInputsSettings
     * @description "Clinical Specialists At Hub Weekly" requirements: which days of the week each hub expects
     *     At Hub coverage on.
     */
    CSAtHubWeeklyRequirementsInputsSettings: {
      /** @description Requirements for duty at the hub by days of the week. Key of map is hub id. */
      atHubDays: {
        [key: string]: components['schemas']['DayOfWeek'][];
      } | null;
    };
    /** CSAtHubWeeklyRequirementsInputsSettingsOperationResult */
    CSAtHubWeeklyRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['CSAtHubWeeklyRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSCandidatesNode
     * @description Clinical Specialist candidates node for specific organ, donor, and hub.
     *     Contains the best candidate for each time slot.
     */
    CSCandidatesNode: {
      organType: components['schemas']['Organ'];
      donorType: components['schemas']['Donor'];
      /**
       * Format: uuid
       * @description The identifier of the hub in which candidates have OnCall shift.
       */
      hubId: string;
      /**
       * @description The best candidates index for each time slot.
       *     You can use this index to retrieve the corresponding candidate from the candidates list ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.ClinicalSpecialists.
       */
      bestForSlot: number[];
      /**
       * @description The best candidates index for each time slot.
       *     3 layered collection:
       *     1st array - time slots in the same order as in ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.TimeSlots.
       *     2nd array - candidates for the time slot ordered by priority.
       *     3rd array - two integers: [0] - index of the candidate in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.ClinicalSpecialists, [1] - time buffer in minutes for the candidate.
       */
      bestsForSlot: number[][][];
    };
    /** CSDays30Stats */
    CSDays30Stats: {
      /** Format: int32 */
      successful: number;
      /** Format: int32 */
      total: number;
    };
    /**
     * CSDeductionShiftRule
     * @description One row of ResourceService.Domain.Contracts.Scheduler.Settings.ClinicalSpecialist.CSDeductionShiftRules — the mandatory shift mix for a single absence-day count.
     */
    CSDeductionShiftRule: {
      /**
       * Format: int32
       * @description Exact number of On-Call shifts per period.
       */
      onCall: number;
      /**
       * Format: int32
       * @description Maximum On-Call shifts that may fall on a Saturday or Sunday.
       */
      weekendOnCall: number;
      /**
       * Format: int32
       * @description Maximum At Hub shifts per period.
       */
      atHub: number;
      /**
       * Format: int32
       * @description Minimum Office Day (Admin Day) shifts per period.
       */
      officeDay: number;
      /**
       * Format: int32
       * @description Minimum No Call shifts per period.
       */
      noCall: number;
      /**
       * Format: int32
       * @description Maximum Weekend Off shifts per period, placed only on Saturday or Sunday.
       */
      weekendOff: number;
    };
    /**
     * CSDeductionShiftRules
     * @description The clinical specialist deduction table: how the mandatory shift mix reduces as absence days rise.
     */
    CSDeductionShiftRules: {
      /** @description One row per absence-day count. Keys are exactly `0 .. Schedule28DaysPeriodCalendar.PeriodDays`. */
      byAbsenceDays: {
        [key: string]: components['schemas']['CSDeductionShiftRule'];
      } | null;
    };
    /** CSDeductionShiftRulesOperationResult */
    CSDeductionShiftRulesOperationResult: {
      data: components['schemas']['CSDeductionShiftRules'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSHolidayDutyGroup
     * @description Clinical specialist holiday duty groups.
     * @enum {string}
     */
    CSHolidayDutyGroup: CSHolidayDutyGroup;
    /**
     * CSLastCertificationAtHub
     * @description Represents employee last certification status at a hub.
     */
    CSLastCertificationAtHub: {
      lastCertificationAtHubStatus: components['schemas']['LastCertificationAtHubStatus'];
      /**
       * Format: date-time
       * @description The date and time when the status going to be changed, or null if not applicable.
       */
      statusChangeAt: string | null;
    };
    /** CSLastCertificationsAtHub */
    CSLastCertificationsAtHub: {
      liver: components['schemas']['CSLastCertificationAtHub'];
      heart: components['schemas']['CSLastCertificationAtHub'];
      lungs: components['schemas']['CSLastCertificationAtHub'];
    };
    /**
     * CSMyScheduleSegment
     * @description Clinical specialist schedule for a specific period for the clinical specialist viewing the schedule.
     */
    CSMyScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      myShifts: components['schemas']['CSResourceScheduleSegment'];
      /**
       * @description Shifts of resource grouped by clinical specialist id.
       *     Key is resource id.
       */
      otherResourcesShifts: {
        [key: string]: components['schemas']['CSResourceScheduleSegment'];
      } | null;
      /** @description Hub information for all hubs referenced in shifts. */
      hubs: {
        [key: string]: components['schemas']['RegionalHub'];
      } | null;
    };
    /** CSMyScheduleSegmentOperationResult */
    CSMyScheduleSegmentOperationResult: {
      data: components['schemas']['CSMyScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSPeriodResourceRulesSettings
     * @description Clinical specialist work rules for period-based planning: the guardrails that survive the deduction table.
     */
    CSPeriodResourceRulesSettings: {
      onCallInRow: components['schemas']['OnCallInRowRules'];
      /**
       * Format: int32
       * @description The number of bonus NoCalls for working on holidays.
       */
      holidayNoCallBonus: number;
    };
    /** CSPeriodResourceRulesSettingsOperationResult */
    CSPeriodResourceRulesSettingsOperationResult: {
      data: components['schemas']['CSPeriodResourceRulesSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSRequirementsInputsSettings
     * @description Settings of the basic rules for service requirements by hub, region and country.
     */
    CSRequirementsInputsSettings: {
      /**
       * @description Minimal per regions per organ requirements.
       *     Key of map is region id.
       */
      perRegions: {
        [key: string]: {
          Liver: components['schemas']['ComboMinRule'];
          Heart: components['schemas']['ComboMinRule'];
          Lungs: components['schemas']['ComboMinRule'];
          Kidney: components['schemas']['ComboMinRule'];
        };
      } | null;
      /**
       * @description Minimal per hub per organ requirements.
       *     Key of map is hub id.
       */
      perHubs: {
        [key: string]: {
          Liver: components['schemas']['ComboMinRule'];
          Heart: components['schemas']['ComboMinRule'];
          Lungs: components['schemas']['ComboMinRule'];
          Kidney: components['schemas']['ComboMinRule'];
        };
      } | null;
      /** @description Requirements for the number of specialists for phone support per organ. */
      exactlyDailyPhoneSupport: {
        /** Format: int32 */
        Liver: number | null;
        /** Format: int32 */
        Heart: number | null;
        /** Format: int32 */
        Lungs: number | null;
        /** Format: int32 */
        Kidney: number | null;
      } | null;
      /** @description Requirements for duty at the hub by days of the week. */
      atHubDays: {
        [key: string]: components['schemas']['DayOfWeek'][];
      } | null;
    };
    /** CSRequirementsInputsSettingsOperationResult */
    CSRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['CSRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSResetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.ClinicalSpecialist.CSResetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    CSResetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
    };
    /**
     * CSResetShiftType
     * @description Resets the specified shift type on a specified day for a specified resource.
     */
    CSResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /**
     * CSResolveHrSystemConflict
     * @description Resolve HR system conflict command for Clinical Specialist
     */
    CSResolveHrSystemConflict: {
      /** Format: uuid */
      conflictId: string;
      setShiftData: components['schemas']['SetCSShiftData'];
    };
    /**
     * CSResource
     * @description Information about clinical specialist - type of Transmedics resource
     */
    CSResource: {
      /**
       * Format: uuid
       * @description Resource id
       */
      id: string;
      /** @description FirstName */
      firstName: string | null;
      /** @description LastName */
      lastName: string | null;
      /** @description Link to profile image */
      profilePhoto: string | null;
      /** @description Resource phone number */
      phoneNumber: string | null;
      /** @description List of certificates from the bodies with which the specialist can work. */
      organs: components['schemas']['Organ'][];
      /** @description List of certificates from the bodies with which the specialist can work as phone support lead. */
      phoneSupportOrgans: components['schemas']['Organ'][];
      /** @description List of certificates from the bodies with which the specialist can work as shadow. */
      shadowOrgans: components['schemas']['Organ'][];
      /** @description List of certificates from the bodies with which the specialist can work as proctor. */
      proctorOrgans: components['schemas']['Organ'][];
      /** @description Indicates that a clinical specialist can provide telephone support. */
      canPhoneSupport: boolean;
      shiftTimeGroup: components['schemas']['CSShiftTimeGroup'];
      /**
       * Format: uuid
       * @description The identifier of the region to which this specialist belongs.
       */
      regionId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the hub to which this specialist belongs.
       */
      hubId: string | null;
    };
    /**
     * CSResourceCSShiftTypeHrSystemConflict
     * @description Represents a conflict between a scheduled shift and a HR system shift for a specific resource on a given day.
     */
    CSResourceCSShiftTypeHrSystemConflict: {
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier of the conflict.
       */
      conflictId: string;
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the schedule associated with this conflict.
       */
      scheduleId: string;
      type: components['schemas']['ScheduleHrSystemConflictType'];
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the resource.
       */
      resourceId: string;
      resource: components['schemas']['CSResource'];
      /**
       * Format: date
       * @description Gets or sets the day represented as a System.DateOnly value.
       */
      day: string;
      hrSystemShiftType: components['schemas']['CSShiftType'];
      scheduleShiftType: components['schemas']['CSShiftType'];
    };
    /** CSResourceCSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult */
    CSResourceCSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CSResourceCSShiftTypeHrSystemConflict'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSResourceRulesSettings
     * @description Clinical specialists work rules.
     */
    CSResourceRulesSettings: {
      shiftPerPeriods?: components['schemas']['ShiftPerPeriodRules'];
      shiftPerMonths?: components['schemas']['ShiftPerPeriodRules'];
      /**
       * Format: int32
       * @description Minimum number of weekends (Fri Sat Sun) per period.
       */
      minimumWeekends: number | null;
      /**
       * Format: int32
       * @description Count of NoCall shift type per period
       */
      noCallDaysPerPeriod?: number | null;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.ClinicalSpecialist.CSResourceRulesSettings.NoCallDaysPerPeriod.
       *     Supports reading settings persisted before the migration to scheduling periods.
       *     Write-only for deserelization, never serialized back.
       */
      noCallDaysPerMonth?: number | null;
      onCallInRow: components['schemas']['OnCallInRowRules'];
      vacationDeduction: components['schemas']['YearDeductionRules'];
      /**
       * Format: int32
       * @description The number of bonus NoCalls for working on holidays.
       */
      holidayNoCallBonus: number;
    };
    /** CSResourceRulesSettingsOperationResult */
    CSResourceRulesSettingsOperationResult: {
      data: components['schemas']['CSResourceRulesSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSResourceScheduleNexusSegment
     * @description Schedule for single clinical specialist with availability information for Nexus view
     */
    CSResourceScheduleNexusSegment: {
      resource: components['schemas']['CSResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['CSShift'];
      } | null;
      /** @description Resource availability information including reservations, case assignments, and rest periods */
      resourceAvailability: components['schemas']['ResourceAvailabilityNode'][];
    };
    /**
     * CSResourceScheduleSegment
     * @description Schedule for single clinical specialist
     */
    CSResourceScheduleSegment: {
      resource: components['schemas']['CSResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['CSShift'];
      } | null;
    };
    /**
     * CSScheduleNexusSegment
     * @description Clinical specialist schedule for Nexus view - includes regions and resource availability
     */
    CSScheduleNexusSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      /** @description List of regions with their hubs */
      regions: components['schemas']['Region'][];
      /**
       * @description Shifts of clinical specialists grouped by clinical specialist id.
       *     Key is clinical specialist id.
       */
      resourcesShifts: {
        [key: string]: components['schemas']['CSResourceScheduleNexusSegment'];
      } | null;
    };
    /** CSScheduleNexusSegmentOperationResult */
    CSScheduleNexusSegmentOperationResult: {
      data: components['schemas']['CSScheduleNexusSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSScheduleSegment
     * @description Clinical specialist schedule for a specific period.
     */
    CSScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      /**
       * @description Shifts of clinical specialists grouped by clinical specialist id.
       *     Key is clinical specialist id.
       */
      resourcesShifts: {
        [key: string]: components['schemas']['CSResourceScheduleSegment'];
      } | null;
    };
    /** CSScheduleSegmentOperationResult */
    CSScheduleSegmentOperationResult: {
      data: components['schemas']['CSScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CSSetFixationType */
    CSSetFixationType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift is located.
       */
      scheduleId: string;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift fixation type is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is located.
       */
      day: string;
      fixationType: components['schemas']['ShiftFixationType'];
    };
    /**
     * CSSetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.ClinicalSpecialist.CSSetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    CSSetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      /** @description If true, then shift type can't be changed by algorithm */
      required: boolean;
      shiftType: components['schemas']['CSShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      /**
       * Format: uuid
       * @description The hub in which the work shift takes place.
       *     If the type of shift is not related to the hub, it will be ignored.
       */
      hubId?: string | null;
      /** @description True if the given work shift is above the monthly resource rule */
      isExtra?: boolean;
      /** @description True if the shift occurs in a non-native hub. */
      isTravel?: boolean;
      timeGroup?: components['schemas']['CSShiftTimeGroup'];
    };
    /** CSSetShiftType */
    CSSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      shiftType: components['schemas']['CSShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      /**
       * Format: uuid
       * @description The hub in which the work shift takes place.
       *     If the type of shift is not related to the hub, it will be ignored.
       */
      hubId?: string | null;
      /** @description True if the given work shift is above the monthly resource rule */
      isExtra?: boolean;
      /** @description True if the shift occurs in a non-native hub. */
      isTravel?: boolean;
      timeGroup?: components['schemas']['CSShiftTimeGroup'];
      fixationType?: components['schemas']['ShiftFixationType'];
    };
    /**
     * CSShift
     * @description Clinical specialist shift
     */
    CSShift: {
      /**
       * Format: uuid
       * @description The schedule identifier to which the shift belongs.
       */
      scheduleId: string;
      /**
       * Format: date-time
       * @description The day on which the work shift takes place.
       */
      day: string;
      /**
       * Format: date-time
       * @description The start timestamp of the shift.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift.
       */
      to: string;
      /**
       * Format: uuid
       * @description The ID of the resource that is scheduled to work this shift.
       */
      resourceId: string;
      shiftStatus: components['schemas']['ShiftStatus'];
      /** @description True is this shift can be changed manually */
      isEditable: boolean;
      /** @description True if this shift is placed on the pre (preliminary) schedule. */
      isPreSchedule: boolean;
      fixationType: components['schemas']['ShiftFixationType'];
      /** @description True if the shift source is HrSystem. */
      isHrShift: boolean;
      shiftType: components['schemas']['CSShiftType'];
      /** @description List of organs, for which this shift is intended */
      organs: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The region id where the shift takes place.
       */
      regionId: string | null;
      /**
       * Format: uuid
       * @description The hub id where the shift takes place.
       */
      hubId: string | null;
      timeGroup?: components['schemas']['CSShiftTimeGroup'];
      /** @description Shift is not located in clinical specialist base location */
      isTravel?: boolean;
      /**
       * @description This shift exceeds the monthly norm for the number of shifts of this type,
       *     but the employee agrees to take additional shifts.
       */
      isExtra?: boolean;
    };
    /** CSShiftOperationResult */
    CSShiftOperationResult: {
      data: components['schemas']['CSShift'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSShiftTimeGroup
     * @description Clinical specialist shift time groups.
     * @enum {string}
     */
    CSShiftTimeGroup: CSShiftTimeGroup;
    /**
     * CSShiftType
     * @description Type of clinical specialist shift.
     * @enum {string}
     */
    CSShiftType: CSShiftType;
    /** CSShiftTypeCompositeShift */
    CSShiftTypeCompositeShift: {
      /** Format: uuid */
      resourceId: string;
      /** Format: uuid */
      regionId: string | null;
      /** Format: uuid */
      hubId: string | null;
      /** Format: date-time */
      fromOffset: string;
      /** Format: date-time */
      toOffset: string;
      shiftType: components['schemas']['CSShiftType'];
      isManager: boolean | null;
      /** Format: date-time */
      readonly fromUtc: string;
      /** Format: date-time */
      readonly toUtc: string;
    };
    /**
     * CSShiftTypeNeighborRule
     * @description The rule limits the possibility of adjacent shifts.
     */
    CSShiftTypeNeighborRule: {
      /**
       * Format: int32
       * @description Required days count before target shift
       */
      daysBefore: number;
      /**
       * Format: int32
       * @description Required days count after target shift
       */
      daysAfter: number;
      /** @description Allowable shift type before target shift */
      beforeShiftTypes: components['schemas']['CSShiftType'][];
      /** @description Allowable shift type after target shift */
      afterShiftTypes: components['schemas']['CSShiftType'][];
    };
    /**
     * CSShiftTypeResourceRulesViolations
     * @description Violations of employee work rules.
     */
    CSShiftTypeResourceRulesViolations: {
      /**
       * @description Violations of the number of shifts by type per period.
       *     Key is shift type.
       */
      periodShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AtHub: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
        OfficeDay: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        PhoneSupport: components['schemas']['RangeRuleViolation'];
        TravelDay: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountByTypeViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AtHub: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
        OfficeDay: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        PhoneSupport: components['schemas']['RangeRuleViolation'];
        TravelDay: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @description Violations of the number of shifts on weekend by type per period.
       *     Key is shift type.
       */
      periodShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AtHub: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
        OfficeDay: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        PhoneSupport: components['schemas']['RangeRuleViolation'];
        TravelDay: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountOnWeekEndViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AtHub: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        WeekendOff: components['schemas']['RangeRuleViolation'];
        OfficeDay: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
        PhoneSupport: components['schemas']['RangeRuleViolation'];
        TravelDay: components['schemas']['RangeRuleViolation'];
      } | null;
      periodShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      periodShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      /**
       * @description Violation of the number shifts in row by shift type.
       *     Key is shift type.
       */
      shiftTypeInRowViolations: {
        OnCall: components['schemas']['ShiftInRowRuleViolations'];
        AtHub: components['schemas']['ShiftInRowRuleViolations'];
        NoCall: components['schemas']['ShiftInRowRuleViolations'];
        WeekendOff: components['schemas']['ShiftInRowRuleViolations'];
        OfficeDay: components['schemas']['ShiftInRowRuleViolations'];
        Unavailable: components['schemas']['ShiftInRowRuleViolations'];
        Vacation: components['schemas']['ShiftInRowRuleViolations'];
        Sick: components['schemas']['ShiftInRowRuleViolations'];
        PhoneSupport: components['schemas']['ShiftInRowRuleViolations'];
        TravelDay: components['schemas']['ShiftInRowRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftNeighborViolations: {
        OnCall: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        AtHub: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        NoCall: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        WeekendOff: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        OfficeDay: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        Unavailable: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        Vacation: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        Sick: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        PhoneSupport: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
        TravelDay: components['schemas']['CSShiftTypeShiftNeighborRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftAllowedDayOfWeekViolations: {
        OnCall: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        AtHub: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        NoCall: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        WeekendOff: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        OfficeDay: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Unavailable: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Vacation: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Sick: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        PhoneSupport: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        TravelDay: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
      } | null;
    };
    /**
     * CSShiftTypeScheduleValidationResult
     * @description Result of schedule validation.
     */
    CSShiftTypeScheduleValidationResult: {
      /** @description True if there are any validation rule violations. */
      hasRuleViolations: boolean;
      /**
       * @description Indicates whether preprocessing has been performed for the schedule.
       *     Schedules without preprocessing can be obtained faster, but they may contain inaccuracies.
       */
      isPreprocessed: boolean;
      scheduleSize: components['schemas']['ScheduleSize'];
      publishReadiness: components['schemas']['SchedulePublishReadiness'];
      /** @description Violations of the rules of service (OnCall, PhoneSupport) requirements by day. */
      dailyRulesViolations: {
        [key: string]: components['schemas']['CSShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of the rules of service (OnCall, PhoneSupport) requirements by week.
       *     Key of dictionary is first day of week.
       */
      weeklyRulesViolations: {
        [key: string]: components['schemas']['CSShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of employees work rules.
       *     Key of dictionary is resource id.
       */
      resourceRulesViolations: {
        [key: string]: components['schemas']['CSShiftTypeResourceRulesViolations'];
      } | null;
    };
    /** CSShiftTypeScheduleValidationResultOperationResult */
    CSShiftTypeScheduleValidationResultOperationResult: {
      data: components['schemas']['CSShiftTypeScheduleValidationResult'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CSShiftTypeServicesRulesViolations
     * @description Violation of the requirements for the number of shifts of a certain type across countries, regions and hubs.
     */
    CSShiftTypeServicesRulesViolations: {
      /** @description Violation of needs across the country for different types of shifts. */
      countryRulesViolations: {
        OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        AtHub: components['schemas']['ServiceShiftTypeRulesViolations'];
        NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
        OfficeDay: components['schemas']['ServiceShiftTypeRulesViolations'];
        Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
        Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
        Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
        PhoneSupport: components['schemas']['ServiceShiftTypeRulesViolations'];
        TravelDay: components['schemas']['ServiceShiftTypeRulesViolations'];
      } | null;
      /**
       * @description Violation of needs in different regions for different types of shifts.
       *     Key is region id.
       */
      regionsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          AtHub: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
          OfficeDay: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
          PhoneSupport: components['schemas']['ServiceShiftTypeRulesViolations'];
          TravelDay: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
      /**
       * @description Violation of needs in different hubs for different types of shifts.
       *     Key is hub id.
       */
      hubsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          AtHub: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          WeekendOff: components['schemas']['ServiceShiftTypeRulesViolations'];
          OfficeDay: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
          PhoneSupport: components['schemas']['ServiceShiftTypeRulesViolations'];
          TravelDay: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
    };
    /**
     * CSShiftTypeShiftAllowedDayOfWeekRuleViolation
     * @description Violation of shift type day of week rule
     */
    CSShiftTypeShiftAllowedDayOfWeekRuleViolation: {
      /**
       * Format: date
       * @description Date of target shift
       */
      targetDate: string;
      actual: components['schemas']['DayOfWeek'];
    };
    /** CSShiftTypeShiftAllowedDayOfWeekRuleViolations */
    CSShiftTypeShiftAllowedDayOfWeekRuleViolations: {
      actualRule: components['schemas']['DayOfWeek'][];
      violations: components['schemas']['CSShiftTypeShiftAllowedDayOfWeekRuleViolation'][];
    };
    /** CSShiftTypeShiftAvailabilityData */
    CSShiftTypeShiftAvailabilityData: {
      currentShift: components['schemas']['CSShiftTypeCompositeShift'];
      isPartialCurrentShift: boolean;
      nextShift: components['schemas']['CSShiftTypeCompositeShift'];
      isPartialNextShift: boolean;
      activeShifts: components['schemas']['CSShiftTypeCompositeShift'][];
      unavailabilities: components['schemas']['CSShiftTypeCompositeShift'][];
    };
    /**
     * CSShiftTypeShiftNeighborRuleViolation
     * @description Shift neighbor rule violation incident
     */
    CSShiftTypeShiftNeighborRuleViolation: {
      /**
       * Format: date-time
       * @description A target shift for which the neighborhood requirement is not met.
       */
      targetDate: string;
      /** @description Current types of shifts before the target. */
      actualBefore: components['schemas']['CSShiftType'][];
      /** @description Current types of shifts after the target. */
      actualAfter: components['schemas']['CSShiftType'][];
    };
    /**
     * CSShiftTypeShiftNeighborRuleViolations
     * @description Violations of the rule on the shift neighbors
     */
    CSShiftTypeShiftNeighborRuleViolations: {
      violatedRule: components['schemas']['CSShiftTypeNeighborRule'];
      /** @description Collection of rule violation incidents */
      violations: components['schemas']['CSShiftTypeShiftNeighborRuleViolation'][];
    };
    /**
     * CSTimeGroupRequirementsInputsSettings
     * @description Settings of the basic rules for service requirements by hub and region, sliced by Shift Time Group.
     */
    CSTimeGroupRequirementsInputsSettings: {
      /**
       * @description Minimal per region per organ per Shift Time Group requirements.
       *     Key of map is region id.
       */
      perRegions: {
        [key: string]: {
          Liver: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Heart: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Lungs: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Kidney: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
        };
      } | null;
      /**
       * @description Minimal per hub per organ per Shift Time Group requirements.
       *     Key of map is hub id.
       */
      perHubs: {
        [key: string]: {
          Liver: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Heart: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Lungs: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
          Kidney: {
            GroupA: components['schemas']['ComboMinRule'];
            GroupB: components['schemas']['ComboMinRule'];
          };
        };
      } | null;
      /** @description Requirements for the number of specialists for phone support per organ. */
      exactlyDailyPhoneSupport?: {
        /** Format: int32 */
        Liver: number | null;
        /** Format: int32 */
        Heart: number | null;
        /** Format: int32 */
        Lungs: number | null;
        /** Format: int32 */
        Kidney: number | null;
      } | null;
    };
    /** CSTimeGroupRequirementsInputsSettingsOperationResult */
    CSTimeGroupRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['CSTimeGroupRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CancelEmployeeRestPeriodCommand */
    CancelEmployeeRestPeriodCommand: {
      /** Format: uuid */
      employeeRestPeriodId: string;
    };
    /**
     * CandidateMatchType
     * @enum {string}
     */
    CandidateMatchType: CandidateMatchType;
    /**
     * CaseAircraftReservationHistoryView
     * @description Represents aircraft booking history for a case.
     */
    CaseAircraftReservationHistoryView: {
      /**
       * Format: uuid
       * @description Case ID.
       */
      caseId: string;
      /**
       * Format: uuid
       * @description Aircraft Internal ID.
       */
      aircraftId: string;
      status: components['schemas']['ResourceStatus'];
      /**
       * Format: date-time
       * @description When the status was last modified.
       */
      createdAt: string;
      /**
       * Format: date-time
       * @description When the status was last modified.
       */
      modifiedAt: string;
    };
    /** CaseAircraftReservationHistoryViewIEnumerableOperationResult */
    CaseAircraftReservationHistoryViewIEnumerableOperationResult: {
      data: components['schemas']['CaseAircraftReservationHistoryView'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * CaseMatchType
     * @enum {string}
     */
    CaseMatchType: CaseMatchType;
    /** CertificatesData */
    CertificatesData: {
      organCertificates: components['schemas']['Organ'][];
      phoneSupportOrganCertificates: components['schemas']['Organ'][];
      onCallShiftOrganCertificates: components['schemas']['Organ'][];
      phoneSupportShiftOrganCertificates: components['schemas']['Organ'][];
      proctorOrganCertificates: components['schemas']['Organ'][];
      shadowOrganCertificates: components['schemas']['Organ'][];
    };
    /** CertificatesDataOperationResult */
    CertificatesDataOperationResult: {
      data: components['schemas']['CertificatesData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * ClinicalSpecialist
     * @description Clinical Specialist details for bulk assignment candidates.
     */
    ClinicalSpecialist: {
      /**
       * Format: uuid
       * @description The unique identifier of the employee.
       */
      id: string;
      /** @description The first name of the employee. */
      firstName: string | null;
      /** @description The last name of the employee. */
      lastName: string | null;
      /**
       * Format: uuid
       * @description The case ID where the current resource has an active reservation.
       */
      activeCaseId: string | null;
      /** @description List of trial program IDs associated with the clinical specialist. */
      readonly trialProgramIds?: string[];
      /** @description List of trial programs associated with the clinical specialist. */
      trialPrograms: components['schemas']['TrialProgramResponse'][];
    };
    /**
     * ComboMinRule
     * @description Describes strict and flexible minimum requirements.
     */
    ComboMinRule: {
      /**
       * Format: int32
       * @description The algorithm always fulfills strict requirements,
       *     and if this is impossible, it does not build a schedule.
       */
      strict: number | null;
      /**
       * Format: int32
       * @description The algorithm strives to fulfill the flexible requirement,
       *     but does not guarantee its fulfillment.
       */
      flex: number | null;
    };
    /**
     * ComboRangeRule
     * @description A combination rule consisting of a strict and a flexible rule.
     */
    ComboRangeRule: {
      hard: components['schemas']['RangeRule'];
      soft: components['schemas']['RangeRule'];
    };
    /**
     * ComboRangeRuleViolation
     * @description Violations of the combination rule.
     */
    ComboRangeRuleViolation: {
      /**
       * Format: int32
       * @description Current actual value that does not fit into the rule.
       */
      actualValue: number;
      violatedRule: components['schemas']['ComboRangeRule'];
    };
    /** ConflictedReservation */
    ConflictedReservation: {
      /** Format: uuid */
      reservationId: string;
      /** Format: date-time */
      from: string;
      isReservedOnly?: boolean;
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
    };
    /** ConflictedRest */
    ConflictedRest: {
      /** Format: uuid */
      restId: string;
      /** Format: date-time */
      from: string;
      /** Format: date-time */
      to: string;
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
    };
    /** ContractorCertificationData */
    ContractorCertificationData: {
      organType: components['schemas']['Organ'];
      /** Format: date-time */
      certificationDate: string;
    };
    /** ContractorCertificationModel */
    ContractorCertificationModel: {
      organType: components['schemas']['Organ'];
      /** Format: date-time */
      certificationDate: string;
    };
    /** Coordinator */
    Coordinator: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      userId: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone: string | null;
      profilePhoto: string | null;
    };
    /** CopyInventoryPartRequest */
    CopyInventoryPartRequest: {
      /** Format: uuid */
      fromCaseId: string;
      /** Format: uuid */
      toCaseId: string;
    };
    /** CreateBannedTailNumberRequest */
    CreateBannedTailNumberRequest: {
      tailNumber: string | null;
      /** Format: uuid */
      logisticProviderId: string | null;
      comment: string | null;
    };
    /** CreateDriverRequest */
    CreateDriverRequest: {
      firstName: string | null;
      lastName: string | null;
      phone: string | null;
      isBanned: boolean;
      affiliationType: components['schemas']['DriverAffiliationType'];
      companyName: string | null;
      /** Format: uuid */
      logisticProviderId: string | null;
      /** Format: uuid */
      txCenterProviderId: string | null;
      comment: string | null;
    };
    /** CreateEmployeeRestPeriodCommand */
    CreateEmployeeRestPeriodCommand: {
      /** Format: uuid */
      employeeId: string;
      /** Format: date-time */
      restStartTime?: string;
      /** Format: int32 */
      restDurationInHours?: number;
      /** Format: uuid */
      caseId?: string | null;
    };
    /** CreateInventoryPartRequest */
    CreateInventoryPartRequest: {
      /** Format: uuid */
      caseId: string;
      type: components['schemas']['InventoryPartType'];
      partNumber: string | null;
      serialCode: string | null;
      /** Format: uuid */
      trialProgramId: string | null;
      /** Format: date-time */
      expirationDate: string | null;
      caseNumber: string | null;
    };
    /** CreateOcsConsoleRequest */
    CreateOcsConsoleRequest: {
      ocsConsoleName: string | null;
      serialNumber: string | null;
      /** Format: uuid */
      nopHub: string;
      organType: components['schemas']['Organ'];
      isInMaintenance?: boolean;
      logoPath?: string | null;
      /** Format: uuid */
      trialProgramId?: string | null;
    };
    /** CreateSignedUrlRequest */
    CreateSignedUrlRequest: {
      fileName: string | null;
      /** Format: int32 */
      fileContentLength: number | null;
      fileExtension: string | null;
    };
    /** CrewDutyAvailabilityView */
    CrewDutyAvailabilityView: {
      /** Format: date-time */
      endUtc: string;
      /** Format: date-time */
      endLocal: string;
      /** Format: date-time */
      startUtc: string;
      /** Format: date-time */
      startLocal: string;
      airport: components['schemas']['AirportView'];
      crewDutyViews: components['schemas']['CrewDutyView'][];
    };
    /** CrewDutyView */
    CrewDutyView: {
      /** Format: int32 */
      id: number;
      /** Format: int32 */
      crewId: number;
      /** Format: date-time */
      onDutyDateTime: string;
      /** Format: date-time */
      onDutyDateTimeLocal: string;
      /** Format: date-time */
      offDutyDateTime: string;
      /** Format: date-time */
      offDutyDateTimeLocal: string;
      /** Format: double */
      totalDuty: number;
      /** Format: double */
      totalRestDuty: number;
      /** Format: double */
      totalFlightDutyPeriod: number;
      /** Format: double */
      totalFlying: number | null;
      /** Format: int32 */
      startAirportId: number | null;
      /** Format: int32 */
      endAirportId: number | null;
      /** Format: int32 */
      aircraftId: number;
      plannedDutyType: string | null;
      actualDutyType: string | null;
      requestedDutyType: string | null;
      crew: components['schemas']['CrewView'];
    };
    /** CrewView */
    CrewView: {
      /** Format: uuid */
      id: string;
      /** Format: int32 */
      maoId: number;
      code: string | null;
      firstName: string | null;
      lastName: string | null;
      phone: string | null;
    };
    /** CrewViewListOperationResult */
    CrewViewListOperationResult: {
      data: components['schemas']['CrewViewPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CrewViewPaginatedData */
    CrewViewPaginatedData: {
      items: components['schemas']['CrewView'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** CurrentActiveClinicalLead */
    CurrentActiveClinicalLead: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      userId: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone: string | null;
      profilePhoto: string | null;
      roles: string[];
    };
    /** CurrentActiveClinicalLeadIReadOnlyCollectionOperationResult */
    CurrentActiveClinicalLeadIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CurrentActiveClinicalLead'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CurrentActiveCoordinator */
    CurrentActiveCoordinator: {
      isPrimaryNow: boolean;
      coordinator: components['schemas']['Coordinator'];
    };
    /** CurrentActiveCoordinatorIReadOnlyCollectionOperationResult */
    CurrentActiveCoordinatorIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CurrentActiveCoordinator'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CurrentActiveOms */
    CurrentActiveOms: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      userId: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone: string | null;
      profilePhoto: string | null;
      roles: string[];
    };
    /** CurrentActiveOmsIReadOnlyCollectionOperationResult */
    CurrentActiveOmsIReadOnlyCollectionOperationResult: {
      data: components['schemas']['CurrentActiveOms'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** CurrentDeploymentData */
    CurrentDeploymentData: {
      /** Format: int32 */
      lastCallDaysAgo: number;
      /** Format: int32 */
      successfulCasesLastThirtyDays: number;
      /** Format: int32 */
      allCasesLastThirtyDays: number;
    };
    /**
     * DayOfWeek
     * @enum {string}
     */
    DayOfWeek: DayOfWeek;
    /** DeleteEmployeeRestPeriodCommand */
    DeleteEmployeeRestPeriodCommand: {
      /** Format: uuid */
      employeeRestPeriodId: string;
    };
    /** DeploymentData */
    DeploymentData: {
      /** Format: int32 */
      lastCallDaysAgo: number;
      organType: components['schemas']['Organ'];
      donorType: components['schemas']['Donor'];
    };
    /** DiaryEntryView */
    DiaryEntryView: {
      /** Format: int32 */
      id: number;
      /** Format: int32 */
      aircraftId: number;
      diaryEntryType: string | null;
      /** Format: date-time */
      startDateAndTimeUTC: string;
      /** Format: date-time */
      endDateAndTimeUTC: string;
      note: string | null;
    };
    /**
     * Donor
     * @enum {string}
     */
    Donor: Donor;
    /** Driver */
    Driver: {
      /** Format: uuid */
      id: string;
      firstName: string | null;
      lastName: string | null;
      affiliationType: components['schemas']['DriverAffiliationType'];
      companyName?: string | null;
      /** Format: uuid */
      logisticProviderId?: string | null;
      /** Format: uuid */
      txCenterProviderId?: string | null;
      phone?: string | null;
      comment?: string | null;
      isBanned?: boolean;
      /** Format: date-time */
      createdAt?: string;
      /** Format: date-time */
      modifiedAt?: string;
    };
    /**
     * DriverAffiliationType
     * @enum {string}
     */
    DriverAffiliationType: DriverAffiliationType;
    /** DriverListOperationResult */
    DriverListOperationResult: {
      data: components['schemas']['DriverPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** DriverOperationResult */
    DriverOperationResult: {
      data: components['schemas']['Driver'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** DriverPaginatedData */
    DriverPaginatedData: {
      items: components['schemas']['Driver'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /**
     * DriversSearchOrderBy
     * @enum {string}
     */
    DriversSearchOrderBy: DriversSearchOrderBy;
    /** EmployeeAvailabilityData */
    EmployeeAvailabilityData: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      userId?: string | null;
      /** Format: int32 */
      workdayId?: number | null;
      /** Format: uuid */
      azureAdId?: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone?: string | null;
      businessPhone?: string | null;
      department?: string | null;
      profilePhoto?: string | null;
      position?: string | null;
      roles?: string[];
      /** Format: date */
      hireDate?: string | null;
      /** Format: date-time */
      workdayTerminationDate?: string | null;
      /** Format: float */
      weight?: number | null;
      scrubSizeTop?: components['schemas']['Size'];
      scrubSizeBottom?: components['schemas']['Size'];
      tsaPrecheckNumber?: string | null;
      /** Format: uuid */
      baseLocation?: string | null;
      /** Format: uuid */
      homeLocation?: string | null;
      /** Format: uuid */
      currentLocation?: string | null;
      /** Format: int32 */
      closestAirportForDeployment?: number | null;
      locationPreference?: components['schemas']['LocationPreference'];
      /** Format: date */
      dateOfBirth?: string | null;
      isActive?: boolean;
      /** Format: date-time */
      createdAt?: string;
      /** Format: date-time */
      modifiedAt?: string;
      organSpecializations?: components['schemas']['Organ'][];
      phoneSupportOrganSpecializations?: components['schemas']['Organ'][];
      rsScheduleManagerOrgans?: components['schemas']['Organ'][];
      organManagementSpecialistSpecializations?: components['schemas']['Organ'][];
      proctorOrganSpecializations?: components['schemas']['Organ'][];
      shadowOrganSpecializations?: components['schemas']['Organ'][];
      reservations?: components['schemas']['ReservationData'][];
      /** Format: uuid */
      caseId?: string | null;
      activeRestPeriod?: components['schemas']['EmployeeRestPeriodModel'];
      canWorkOnExtraShifts?: boolean;
      /** Format: int32 */
      extraShiftsCount?: number;
      canTravel?: boolean;
      /** Format: int32 */
      travelShiftsCount?: number;
      currentDeploymentData?: components['schemas']['CurrentDeploymentData'];
      /** Format: uuid */
      liverSurgeonRegionId?: string | null;
      /** Format: uuid */
      heartLungsSurgeonRegionId?: string | null;
      affiliation?: components['schemas']['AffiliationData'];
      contractorCertifications?: components['schemas']['ContractorCertificationData'][];
      trackedLocation?: components['schemas']['TrackedLocationModel'];
      clinicalCoordinatorType?: components['schemas']['CCResourceType'];
      clinicalSpecialistShiftGroupType?: components['schemas']['CSHolidayDutyGroup'];
      shiftTimeGroup?: components['schemas']['CSShiftTimeGroup'];
      deploymentDatas?: components['schemas']['DeploymentData'][];
      isContractor?: boolean;
      trialPrograms?: components['schemas']['TrialProgramResponse'][];
      csShiftAvailabilityData?: components['schemas']['CSShiftTypeShiftAvailabilityData'];
      sShiftAvailabilityData?: components['schemas']['SShiftTypeShiftAvailabilityData'];
      ccShiftAvailabilityData?: components['schemas']['CCShiftTypeShiftAvailabilityData'];
    };
    /** EmployeeAvailabilityDataListOperationResult */
    EmployeeAvailabilityDataListOperationResult: {
      data: components['schemas']['EmployeeAvailabilityDataPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeAvailabilityDataPaginatedData */
    EmployeeAvailabilityDataPaginatedData: {
      items: components['schemas']['EmployeeAvailabilityData'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** EmployeeBasicData */
    EmployeeBasicData: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      userId?: string | null;
      /** Format: int32 */
      workdayId?: number | null;
      /** Format: uuid */
      azureAdId?: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone?: string | null;
      department?: string | null;
      profilePhoto?: string | null;
      position?: string | null;
      roles?: string[];
      /** Format: date */
      hireDate?: string | null;
      /** Format: date-time */
      workdayTerminationDate?: string | null;
      /** Format: float */
      weight?: number | null;
      scrubSizeTop?: components['schemas']['Size'];
      scrubSizeBottom?: components['schemas']['Size'];
      tsaPrecheckNumber?: string | null;
      /** Format: uuid */
      baseLocation?: string | null;
      /** Format: uuid */
      homeLocation?: string | null;
      /** Format: uuid */
      currentLocation?: string | null;
      /** Format: int32 */
      closestAirportForDeployment?: number | null;
      locationPreference?: components['schemas']['LocationPreference'];
      /** Format: date */
      dateOfBirth?: string | null;
      isActive?: boolean;
      activeRestPeriod?: components['schemas']['EmployeeRestPeriodModel'];
      canWorkOnExtraShifts?: boolean;
      /** Format: int32 */
      extraShiftsCount?: number;
      canTravel?: boolean;
      /** Format: int32 */
      travelShiftsCount?: number;
      /** Format: uuid */
      liverSurgeonRegionId?: string | null;
      /** Format: uuid */
      heartLungsSurgeonRegionId?: string | null;
      clinicalCoordinatorType?: components['schemas']['CCResourceType'];
      clinicalSpecialistShiftGroupType?: components['schemas']['CSHolidayDutyGroup'];
      shiftTimeGroup?: components['schemas']['CSShiftTimeGroup'];
      isContractor?: boolean;
      organSpecializations?: components['schemas']['Organ'][];
      phoneSupportOrganSpecializations?: components['schemas']['Organ'][];
      rsScheduleManagerOrgans?: components['schemas']['Organ'][];
      organManagementSpecialistSpecializations?: components['schemas']['Organ'][];
      proctorOrganSpecializations?: components['schemas']['Organ'][];
      shadowOrganSpecializations?: components['schemas']['Organ'][];
    };
    /** EmployeeBasicDataOperationResult */
    EmployeeBasicDataOperationResult: {
      data: components['schemas']['EmployeeBasicData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeCertificatesData */
    EmployeeCertificatesData: {
      /** Format: uuid */
      employeeId: string;
      certificatesData: components['schemas']['CertificatesData'];
    };
    /** EmployeeCertificatesDataIReadOnlyCollectionOperationResult */
    EmployeeCertificatesDataIReadOnlyCollectionOperationResult: {
      data: components['schemas']['EmployeeCertificatesData'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeCompactData */
    EmployeeCompactData: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      userId?: string | null;
      firstName: string | null;
      lastName: string | null;
      email?: string | null;
      roles: string[];
      isActive: boolean;
      isContractor?: boolean | null;
      /** Format: date-time */
      createdAt: string;
      /** Format: date-time */
      modifiedAt: string;
    };
    /** EmployeeCompactDataListOperationResult */
    EmployeeCompactDataListOperationResult: {
      data: components['schemas']['EmployeeCompactDataPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeCompactDataPaginatedData */
    EmployeeCompactDataPaginatedData: {
      items: components['schemas']['EmployeeCompactData'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** EmployeeData */
    EmployeeData: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      userId?: string | null;
      /** Format: int32 */
      workdayId?: number | null;
      /** Format: uuid */
      azureAdId?: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      phone?: string | null;
      businessPhone?: string | null;
      department?: string | null;
      profilePhoto?: string | null;
      position?: string | null;
      roles?: string[];
      /** Format: date */
      hireDate?: string | null;
      /** Format: date-time */
      workdayTerminationDate?: string | null;
      /** Format: float */
      weight?: number | null;
      scrubSizeTop?: components['schemas']['Size'];
      scrubSizeBottom?: components['schemas']['Size'];
      tsaPrecheckNumber?: string | null;
      /** Format: uuid */
      baseLocation?: string | null;
      /** Format: uuid */
      homeLocation?: string | null;
      /** Format: uuid */
      currentLocation?: string | null;
      /** Format: int32 */
      closestAirportForDeployment?: number | null;
      locationPreference?: components['schemas']['LocationPreference'];
      /** Format: date */
      dateOfBirth?: string | null;
      isActive?: boolean;
      /** Format: date-time */
      createdAt?: string;
      /** Format: date-time */
      modifiedAt?: string;
      organSpecializations?: components['schemas']['Organ'][];
      phoneSupportOrganSpecializations?: components['schemas']['Organ'][];
      rsScheduleManagerOrgans?: components['schemas']['Organ'][];
      organManagementSpecialistSpecializations?: components['schemas']['Organ'][];
      proctorOrganSpecializations?: components['schemas']['Organ'][];
      shadowOrganSpecializations?: components['schemas']['Organ'][];
      reservations?: components['schemas']['ReservationData'][];
      /** Format: uuid */
      caseId?: string | null;
      activeRestPeriod?: components['schemas']['EmployeeRestPeriodModel'];
      canWorkOnExtraShifts?: boolean;
      /** Format: int32 */
      extraShiftsCount?: number;
      canTravel?: boolean;
      /** Format: int32 */
      travelShiftsCount?: number;
      currentDeploymentData?: components['schemas']['CurrentDeploymentData'];
      /** Format: uuid */
      liverSurgeonRegionId?: string | null;
      /** Format: uuid */
      heartLungsSurgeonRegionId?: string | null;
      affiliation?: components['schemas']['AffiliationData'];
      contractorCertifications?: components['schemas']['ContractorCertificationData'][];
      trackedLocation?: components['schemas']['TrackedLocationModel'];
      clinicalCoordinatorType?: components['schemas']['CCResourceType'];
      clinicalSpecialistShiftGroupType?: components['schemas']['CSHolidayDutyGroup'];
      shiftTimeGroup?: components['schemas']['CSShiftTimeGroup'];
      deploymentDatas?: components['schemas']['DeploymentData'][];
      isContractor?: boolean;
      trialPrograms?: components['schemas']['TrialProgramResponse'][];
    };
    /** EmployeeDataListOperationResult */
    EmployeeDataListOperationResult: {
      data: components['schemas']['EmployeeDataPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeDataOperationResult */
    EmployeeDataOperationResult: {
      data: components['schemas']['EmployeeData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeDataPaginatedData */
    EmployeeDataPaginatedData: {
      items: components['schemas']['EmployeeData'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /**
     * EmployeeDetails
     * @description Represents an employee's details to be used for GCC passengers info.
     */
    EmployeeDetails: {
      /**
       * Format: uuid
       * @description Unique identifier of the employee.
       */
      id: string;
      /**
       * Format: uuid
       * @description Optional identifier linking the employee to a user account.
       */
      userId: string | null;
      /** @description First name of the employee. */
      firstName: string | null;
      /** @description Last name of the employee. */
      lastName: string | null;
      /** @description Primary contact phone number (may be null if not provided). */
      phone: string | null;
      /** @description Primary contact email address (may be null if not provided). */
      email: string | null;
      /** @description URL to the employee's profile photo (may be null if not provided). */
      profilePhoto: string | null;
      baseLocation: components['schemas']['HubDetails'];
      /** @description Collection of roles associated with the employee (authorization / responsibility context). */
      roles: components['schemas']['RoleInfo'][];
    };
    /** EmployeeDetailsListOperationResult */
    EmployeeDetailsListOperationResult: {
      data: components['schemas']['EmployeeDetailsPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeDetailsPaginatedData */
    EmployeeDetailsPaginatedData: {
      items: components['schemas']['EmployeeDetails'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** EmployeeIdData */
    EmployeeIdData: {
      /** Format: uuid */
      employeeId: string;
      /** Format: uuid */
      employeeUserId: string | null;
    };
    /** EmployeeIdDataIReadOnlyCollectionOperationResult */
    EmployeeIdDataIReadOnlyCollectionOperationResult: {
      data: components['schemas']['EmployeeIdData'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeeRestPeriodModel */
    EmployeeRestPeriodModel: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      employeeId: string;
      /** Format: date-time */
      restStartTime: string;
      /** Format: int32 */
      restDurationInHours: number;
      /** Format: date-time */
      restEndTime: string;
      /** Format: date-time */
      restCancellationTime: string | null;
      /** Format: date-time */
      actualRestEndTime: string;
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
    };
    /** EmployeeRestPeriodModelOperationResult */
    EmployeeRestPeriodModelOperationResult: {
      data: components['schemas']['EmployeeRestPeriodModel'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * EmployeeSearchOrderBy
     * @enum {string}
     */
    EmployeeSearchOrderBy: EmployeeSearchOrderBy;
    /** EmployeeStatus */
    EmployeeStatus: {
      /** Format: uuid */
      employeeId: string;
      /** Format: date-time */
      statusAt: string;
      isOnCall: boolean;
      hasNextPlannedOnCall?: boolean;
      /** Format: date-time */
      nextOnCallStartAt: string | null;
      readonly isOnRest?: boolean;
      /** Format: date-time */
      activeRestEndsAt: string | null;
      actualTimezone?: string | null;
    };
    /** EmployeeStatusOperationResult */
    EmployeeStatusOperationResult: {
      data: components['schemas']['EmployeeStatus'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** EmployeesReservationsData */
    EmployeesReservationsData: {
      employees: {
        [key: string]: components['schemas']['Node'][];
      } | null;
    };
    /** EmployeesReservationsDataOperationResult */
    EmployeesReservationsDataOperationResult: {
      data: components['schemas']['EmployeesReservationsData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** Error */
    Error: {
      code: string | null;
      message: string | null;
      innerErrors: components['schemas']['Error'][];
      /** @deprecated */
      detailedCodes: string[];
    };
    /**
     * GccEmployeeSearchOrderBy
     * @description Defines the sortable fields that can be applied to a GCC employee search.
     * @enum {string}
     */
    GccEmployeeSearchOrderBy: GccEmployeeSearchOrderBy;
    /**
     * GeoLocation
     * @description Represents a geographical location with latitude and longitude.
     */
    GeoLocation: {
      /**
       * Format: uuid
       * @description Location identifier.
       *     Null if location is not fixed in system.
       */
      id: string | null;
      /**
       * Format: double
       * @description The latitude of the location.
       */
      latitude: number;
      /**
       * Format: double
       * @description The longitude of the location.
       */
      longitude: number;
    };
    /**
     * GetCSRegions
     * @description Get list of regions for clinical specialist
     */
    GetCSRegions: Record<string, never>;
    /**
     * GetHtLuSRegions
     * @description Get heart and lungs surgeon regions
     */
    GetHtLuSRegions: Record<string, never>;
    /**
     * GetLiSRegions
     * @description Get liver surgeon regions
     */
    GetLiSRegions: Record<string, never>;
    /**
     * GetSRegions
     * @description Get list of regions for clinical specialist
     */
    GetSRegions: Record<string, never>;
    /** HtLuSResetShiftType */
    HtLuSResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /** HtLuSSetShiftType */
    HtLuSSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      shiftType: components['schemas']['SShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
      unavailabilities?: components['schemas']['Unavailability'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel?: boolean;
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      fixationType?: components['schemas']['ShiftFixationType'];
    };
    /**
     * Hub
     * @description Transmedics hub basic information
     */
    Hub: {
      /**
       * Format: uuid
       * @description Hub id
       */
      id: string;
      /**
       * Format: uuid
       * @description Region Id
       */
      regionId: string;
      /** @description Hub code */
      code: string | null;
      /** @description Hub display name */
      name: string | null;
      /** @description Hub timezone */
      timezone: string | null;
    };
    /**
     * HubDetails
     * @description Represents basic identifying information for a hub.
     */
    HubDetails: {
      /** @description Hub code, e.g. 'AND'. */
      code: string | null;
      /** @description Display name of the hub, e.g. 'Andover'. */
      name: string | null;
    };
    /** InventoryPartCaseModel */
    InventoryPartCaseModel: {
      /** Format: uuid */
      caseId: string;
    };
    /** InventoryPartModel */
    InventoryPartModel: {
      /** Format: uuid */
      id: string;
      cases: components['schemas']['InventoryPartCaseModel'][];
      type: components['schemas']['InventoryPartType'];
      partNumber: string | null;
      serialCode: string | null;
      /** Format: date-time */
      expirationDate: string | null;
      caseNumber: string | null;
      trialProgram: components['schemas']['TrialProgramResponse'];
      /** Format: date-time */
      createdAt: string;
      /** Format: date-time */
      modifiedAt: string;
    };
    /** InventoryPartModelListOperationResult */
    InventoryPartModelListOperationResult: {
      data: components['schemas']['InventoryPartModelPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** InventoryPartModelOperationResult */
    InventoryPartModelOperationResult: {
      data: components['schemas']['InventoryPartModel'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** InventoryPartModelPaginatedData */
    InventoryPartModelPaginatedData: {
      items: components['schemas']['InventoryPartModel'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /**
     * InventoryPartType
     * @enum {string}
     */
    InventoryPartType: InventoryPartType;
    /**
     * InventoryPartsSearchOrderBy
     * @enum {string}
     */
    InventoryPartsSearchOrderBy: InventoryPartsSearchOrderBy;
    /** JsonNode */
    JsonNode: {
      options: components['schemas']['JsonNodeOptions'];
      parent: components['schemas']['JsonNode'];
      root: components['schemas']['JsonNode'];
    };
    /** JsonNodeOptions */
    JsonNodeOptions: {
      propertyNameCaseInsensitive: boolean;
    };
    /**
     * LastCallInfo
     * @description Contains information about the last calls for donors and organs.
     */
    LastCallInfo: {
      /** @description Gets the dictionary of calls grouped by donors and organs. */
      byDonorAndOrgan: {
        DBD: {
          /** Format: double */
          Liver: number | null;
          /** Format: double */
          Heart: number | null;
          /** Format: double */
          Lungs: number | null;
          /** Format: double */
          Kidney: number | null;
        };
        DCD: {
          /** Format: double */
          Liver: number | null;
          /** Format: double */
          Heart: number | null;
          /** Format: double */
          Lungs: number | null;
          /** Format: double */
          Kidney: number | null;
        };
      } | null;
      /** @description Gets the dictionary of calls grouped by organs (minimum value for each organ). */
      readonly byOrgan: {
        /** Format: double */
        Liver: number | null;
        /** Format: double */
        Heart: number | null;
        /** Format: double */
        Lungs: number | null;
        /** Format: double */
        Kidney: number | null;
      } | null;
      /** @description Gets the dictionary of calls for the current case donor, grouped by organs. */
      readonly forCaseDonorByOrgan: {
        /** Format: double */
        Liver: number | null;
        /** Format: double */
        Heart: number | null;
        /** Format: double */
        Lungs: number | null;
        /** Format: double */
        Kidney: number | null;
      } | null;
      /**
       * Format: double
       * @description Gets the call value for the current case donor and organ.
       */
      readonly forCaseDonorAndOrgan: number | null;
      /**
       * Format: double
       * @description Gets the maximum call value among all calls.
       */
      readonly anyCall: number | null;
    };
    /**
     * LastCertificationAtHubStatus
     * @enum {string}
     */
    LastCertificationAtHubStatus: LastCertificationAtHubStatus;
    /**
     * LeadShiftPerPeriodRules
     * @description Describes the number of shifts of different types per period for a clinical lead.
     */
    LeadShiftPerPeriodRules: {
      /**
       * Format: int32
       * @description OnCall count per period
       */
      onCall: number | null;
      /**
       * Format: int32
       * @description OnCall on weekend count per period
       */
      onCallOnWeekend: number | null;
      /**
       * Format: int32
       * @description AtHub minimal count per period
       */
      maxAtHub: number | null;
      /**
       * Format: int32
       * @description PhoneSupport max count per period
       */
      maxPhoneSupport: number | null;
      /**
       * Format: int32
       * @description Weighted sum of OnCall and PhoneSupport shifts
       */
      onCallAndPhoneSupport: number | null;
    };
    /** LiSResetShiftType */
    LiSResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /** LiSSetShiftType */
    LiSSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      shiftType: components['schemas']['SShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
      unavailabilities?: components['schemas']['Unavailability'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel?: boolean;
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      fixationType?: components['schemas']['ShiftFixationType'];
    };
    /** Location */
    Location: {
      /** Format: uuid */
      locationId: string;
      postalCode: string | null;
      city: string | null;
      country: string | null;
      state: string | null;
      addressLine: string | null;
      /** Format: double */
      latitude: number | null;
      /** Format: double */
      longitude: number | null;
      timezone: string | null;
    };
    /**
     * LocationPreference
     * @enum {string}
     */
    LocationPreference: LocationPreference;
    /** MaintenanceEntryView */
    MaintenanceEntryView: {
      /** Format: int32 */
      id: number;
      /** Format: int32 */
      aircraftId: number;
      description: string | null;
      /** Format: int32 */
      maintenanceTypeId: number | null;
      /** Format: date-time */
      scheduledStartDateAndTimeUtc: string | null;
      /** Format: date-time */
      scheduledStartDateAndTimeLocal: string | null;
      /** Format: date-time */
      actualStartDateAndTimeUtc: string | null;
      /** Format: date-time */
      actualStartDateAndTimeLocal: string | null;
      /** Format: date-time */
      scheduledEndDateAndTimeUtc: string | null;
      /** Format: date-time */
      scheduledEndDateAndTimeLocal: string | null;
      /** Format: date-time */
      actualEndDateAndTimeUtc: string | null;
      /** Format: date-time */
      actualEndDateAndTimeLocal: string | null;
      isCancelled: boolean;
      isReleased: boolean;
    };
    /** ModifyEmployeeRestPeriodCommand */
    ModifyEmployeeRestPeriodCommand: {
      /** Format: uuid */
      employeeRestPeriodId: string;
      /** Format: date-time */
      restStartTime: string;
      /** Format: int32 */
      restDurationInHours: number;
      /** Format: int32 */
      restDurationMinutes: number | null;
    };
    /**
     * MyPeriodSchedule
     * @description Monthly schedule information for clinical specialist for the clinical specialist viewing the schedule.
     */
    MyPeriodSchedule: {
      /**
       * Format: date-time
       * @description First day of month
       */
      periodStartDay: string;
      /**
       * Format: date-time
       * @description Last day of month
       */
      periodEndDay: string;
      /** @description True if published work schedule exist for this month */
      readonly hasSchedule?: boolean;
      /** @description True if pre schedule exist for this month */
      readonly hasPreSchedule?: boolean;
      /** @description True if planning process is enabled for this month */
      hasPlanningProcess: boolean;
      /**
       * Format: uuid
       * @description Id of published work schedule
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.MyPeriodSchedule.HasSchedule is false
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description Id of pre schedule
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.MyPeriodSchedule.HasPreSchedule is false
       */
      preScheduleId: string | null;
      /**
       * Format: date-time
       * @deprecated
       * @description Legacy name of ResourceService.Application.Contracts.Scheduler.QueryModels.MyPeriodSchedule.PeriodStartDay.
       */
      readonly startDayOfMonth?: string;
      /**
       * Format: date-time
       * @deprecated
       * @description Legacy name of ResourceService.Application.Contracts.Scheduler.QueryModels.MyPeriodSchedule.PeriodEndDay.
       */
      readonly endDayOfMonth?: string;
    };
    /** MyPeriodScheduleIReadOnlyCollectionOperationResult */
    MyPeriodScheduleIReadOnlyCollectionOperationResult: {
      data: components['schemas']['MyPeriodSchedule'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** MyPeriodScheduleOperationResult */
    MyPeriodScheduleOperationResult: {
      data: components['schemas']['MyPeriodSchedule'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * NoCallInRowRules
     * @description Describes the number of shifts in-row.
     */
    NoCallInRowRules: {
      /**
       * Format: int32
       * @description Minimum sequence length
       */
      hardMin: number | null;
      /**
       * Format: int32
       * @description Lower limit of recommended length.
       */
      recommendedMin: number | null;
      /**
       * Format: int32
       * @description Upper limit of recommended length.
       */
      recommendedMax: number | null;
      /**
       * Format: int32
       * @description Maximum sequence length
       */
      hardMax: number | null;
    };
    /** Node */
    Node: {
      /** Format: uuid */
      nodeId: string;
      /** Format: date-time */
      from: string;
      /** Format: date-time */
      to: string | null;
      type: components['schemas']['NodeType'];
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
    };
    /**
     * NodeType
     * @enum {string}
     */
    NodeType: NodeType;
    /** OMSAssignmentCandidate */
    OMSAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      phone: string | null;
      isAssigned: boolean;
      /** Format: date-time */
      currentShiftEnd: string | null;
      currentSlotShiftType: components['schemas']['OMSShiftType'];
      /** Format: date-time */
      nextOnCallStart: string | null;
      /** Format: date-time */
      overlapCSOnCallShiftStart: string | null;
      /** Format: date-time */
      overlapCSOnCallShiftEnd: string | null;
      /** Format: date-time */
      overlapPhoneSupportShiftStart: string | null;
      /** Format: date-time */
      overlapPhoneSupportShiftEnd: string | null;
    };
    /** OMSAssignmentCandidateIReadOnlyCollectionOperationResult */
    OMSAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['OMSAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSMyScheduleSegment
     * @description OMS schedule segment for the current user.
     */
    OMSMyScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      myShifts: components['schemas']['OMSResourceScheduleSegment'];
      /**
       * @description Shifts of resource grouped by clinical specialist id.
       *     Key is resource id.
       */
      otherResourcesShifts: {
        [key: string]: components['schemas']['OMSResourceScheduleSegment'];
      } | null;
      /** @description Hub information for all hubs referenced in shifts. */
      hubs: {
        [key: string]: components['schemas']['RegionalHub'];
      } | null;
    };
    /** OMSMyScheduleSegmentOperationResult */
    OMSMyScheduleSegmentOperationResult: {
      data: components['schemas']['OMSMyScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSRequirementsInputsSettings
     * @description Settings of the basic rules for service requirements by organ.
     */
    OMSRequirementsInputsSettings: {
      /**
       * @description Minimal requirements for the first slot per organ.
       *     Key of map is organ type.
       */
      minForFirstSlotPerOrgan: {
        Liver: components['schemas']['ComboMinRule'];
        Heart: components['schemas']['ComboMinRule'];
        Lungs: components['schemas']['ComboMinRule'];
        Kidney: components['schemas']['ComboMinRule'];
      } | null;
      /**
       * @description Minimal requirements for the second slot per organ.
       *     Key of map is organ type.
       */
      minForSecondSlotPerOrgan: {
        Liver: components['schemas']['ComboMinRule'];
        Heart: components['schemas']['ComboMinRule'];
        Lungs: components['schemas']['ComboMinRule'];
        Kidney: components['schemas']['ComboMinRule'];
      } | null;
    };
    /** OMSRequirementsInputsSettingsOperationResult */
    OMSRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['OMSRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSResetMyShiftTypeModel
     * @description Model for resetting OMS shift type for current user.
     */
    OMSResetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId?: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /**
     * OMSResetShiftType
     * @description Resets the specified shift type on a specified day for a specified resource.
     */
    OMSResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /**
     * OMSResolveHrSystemConflict
     * @description Resolves an HR system conflict for OMS by accepting either the schedule or HR system value.
     */
    OMSResolveHrSystemConflict: {
      /** Format: uuid */
      conflictId: string;
      setShiftData: components['schemas']['OMSSetShiftData'];
    };
    /**
     * OMSResource
     * @description Information about OMS resource - type of Transmedics resource.
     */
    OMSResource: {
      /**
       * Format: uuid
       * @description Resource id
       */
      id: string;
      /** @description FirstName */
      firstName: string | null;
      /** @description LastName */
      lastName: string | null;
      /** @description Link to profile image */
      profilePhoto: string | null;
      /** @description Resource phone number */
      phoneNumber: string | null;
      /** @description List of organ certifications for this specialist. */
      organs: components['schemas']['Organ'][];
    };
    /**
     * OMSResourceOMSShiftTypeHrSystemConflict
     * @description Represents a conflict between a scheduled shift and a HR system shift for a specific resource on a given day.
     */
    OMSResourceOMSShiftTypeHrSystemConflict: {
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier of the conflict.
       */
      conflictId: string;
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the schedule associated with this conflict.
       */
      scheduleId: string;
      type: components['schemas']['ScheduleHrSystemConflictType'];
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the resource.
       */
      resourceId: string;
      resource: components['schemas']['OMSResource'];
      /**
       * Format: date
       * @description Gets or sets the day represented as a System.DateOnly value.
       */
      day: string;
      hrSystemShiftType: components['schemas']['OMSShiftType'];
      scheduleShiftType: components['schemas']['OMSShiftType'];
    };
    /** OMSResourceOMSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult */
    OMSResourceOMSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult: {
      data: components['schemas']['OMSResourceOMSShiftTypeHrSystemConflict'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSResourceRulesSettings
     * @description Organ Management Specialist resource rules.
     */
    OMSResourceRulesSettings: {
      /**
       * Format: int32
       * @description Maximum number of on call shifts slots per period for Organ Management Specialist
       */
      maxOnCallShiftsSlotsPerPeriod: number;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.OrganManagementSpecialist.OMSResourceRulesSettings.MaxOnCallShiftsSlotsPerPeriod. Write-only for deserelization, never serialized back.
       */
      maxOnCallShiftsSlotsPerMonth: number;
      /**
       * Format: int32
       * @description Minimum number of on call shifts slots per period for Organ Management Specialist
       */
      minOnCallShiftsSlotsPerPeriod: number;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.OrganManagementSpecialist.OMSResourceRulesSettings.MinOnCallShiftsSlotsPerPeriod. Write-only for deserelization, never serialized back.
       */
      minOnCallShiftsSlotsPerMonth: number;
      /**
       * Format: int32
       * @description Maximum number of admin day slots per period for Organ Management Specialist
       */
      maxAdminDaySlotsPerPeriod: number;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.OrganManagementSpecialist.OMSResourceRulesSettings.MaxAdminDaySlotsPerPeriod. Write-only for deserelization, never serialized back.
       */
      maxAdminDaySlotsPerMonth: number;
      /**
       * Format: int32
       * @description Minimum number of admin day slots per period for Organ Management Specialist
       */
      minAdminDaySlotsPerPeriod: number;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.OrganManagementSpecialist.OMSResourceRulesSettings.MinAdminDaySlotsPerPeriod. Write-only for deserelization, never serialized back.
       */
      minAdminDaySlotsPerMonth: number;
    };
    /** OMSResourceRulesSettingsOperationResult */
    OMSResourceRulesSettingsOperationResult: {
      data: components['schemas']['OMSResourceRulesSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSResourceScheduleNexusSegment
     * @description Schedule for single organ management specialist for Nexus view
     */
    OMSResourceScheduleNexusSegment: {
      resource: components['schemas']['OMSResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['OMSShift'];
      } | null;
    };
    /**
     * OMSResourceScheduleSegment
     * @description OMS resource schedule segment.
     */
    OMSResourceScheduleSegment: {
      resource: components['schemas']['OMSResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['OMSShift'];
      } | null;
    };
    /**
     * OMSScheduleNexusSegment
     * @description Organ Management Specialist schedule segment for Nexus view
     */
    OMSScheduleNexusSegment: {
      /**
       * Format: date-time
       * @description Start date of the schedule segment
       */
      from: string;
      /**
       * Format: date-time
       * @description End date of the schedule segment
       */
      to: string;
      /** @description Dictionary of resource shifts keyed by resource ID */
      resourcesShifts: {
        [key: string]: components['schemas']['OMSResourceScheduleNexusSegment'];
      } | null;
    };
    /** OMSScheduleNexusSegmentOperationResult */
    OMSScheduleNexusSegmentOperationResult: {
      data: components['schemas']['OMSScheduleNexusSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSScheduleSegment
     * @description OMS schedule for a specific period.
     */
    OMSScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      /**
       * @description Shifts of clinical specialists grouped by clinical specialist id.
       *     Key is clinical specialist id.
       */
      resourcesShifts: {
        [key: string]: components['schemas']['OMSResourceScheduleSegment'];
      } | null;
    };
    /** OMSScheduleSegmentOperationResult */
    OMSScheduleSegmentOperationResult: {
      data: components['schemas']['OMSScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSSetFixationType
     * @description Sets the fixation type for a specific OMS shift.
     */
    OMSSetFixationType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift is located.
       */
      scheduleId: string;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift fixation type is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is located.
       */
      day: string;
      fixationType: components['schemas']['ShiftFixationType'];
    };
    /**
     * OMSSetMyShiftTypeModel
     * @description Model for setting OMS shift type for current user.
     */
    OMSSetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId?: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      /**
       * Format: int32
       * @description Total number of slots per day for this shift (1 for full-day, 2 for split-day OnCall).
       */
      slotsPerDay: number;
      slot1?: components['schemas']['OMSShiftSlotInput'] | null;
      slot2?: components['schemas']['OMSShiftSlotInput'] | null;
    };
    /**
     * OMSSetShiftData
     * @description Data for setting an OMS shift when resolving HR system conflict.
     *     Supports both single-slot (full day) and two-slot (split day) configurations.
     */
    OMSSetShiftData: {
      /**
       * Format: int32
       * @description Total number of slots per day for this shift (1 for full-day shifts, 2 for split-day shifts like OnCall).
       */
      slotsPerDay: number;
      slot1?: components['schemas']['OMSShiftSlotInput'] | null;
      slot2?: components['schemas']['OMSShiftSlotInput'] | null;
    };
    /** OMSSetShiftType */
    OMSSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      /**
       * Format: int32
       * @description Total number of slots per day for this shift (1 for full-day shifts, 2 for split-day shifts like OnCall).
       */
      slotsPerDay: number;
      fixationType?: components['schemas']['ShiftFixationType'];
      slot1?: components['schemas']['OMSShiftSlotInput'] | null;
      slot2?: components['schemas']['OMSShiftSlotInput'] | null;
    };
    /**
     * OMSShift
     * @description OMS shift information.
     */
    OMSShift: {
      /**
       * Format: uuid
       * @description The schedule identifier to which the shift belongs.
       */
      scheduleId: string;
      /**
       * Format: date-time
       * @description The day on which the work shift takes place.
       */
      day: string;
      /**
       * Format: date-time
       * @description The start timestamp of the shift.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift.
       */
      to: string;
      /**
       * Format: uuid
       * @description The ID of the resource that is scheduled to work this shift.
       */
      resourceId: string;
      shiftStatus: components['schemas']['ShiftStatus'];
      /** @description True is this shift can be changed manually */
      isEditable: boolean;
      /** @description True if this shift is placed on the pre (preliminary) schedule. */
      isPreSchedule: boolean;
      fixationType: components['schemas']['ShiftFixationType'];
      /** @description True if the shift source is HrSystem. */
      isHrShift: boolean;
      slot1?: components['schemas']['OMSShiftSlot'];
      slot2?: components['schemas']['OMSShiftSlot'];
    };
    /** OMSShiftOperationResult */
    OMSShiftOperationResult: {
      data: components['schemas']['OMSShift'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSShiftSlot
     * @description OMS shift slot information.
     */
    OMSShiftSlot: {
      /**
       * Format: int32
       * @description Index of the time slot in the schedule day (1-based).
       */
      slotIndex: number;
      /**
       * Format: int32
       * @description Total number of slots per day in the schedule.
       */
      ofSlotsPerDay: number;
      shiftType: components['schemas']['OMSShiftType'];
      /** @description Organs for which the shift is assigned. */
      organs: components['schemas']['Organ'][];
      /** @description This shift exceeds the monthly norm but employee agrees to take additional shifts. */
      isVoluntary: boolean;
      /**
       * Format: date-time
       * @description The start timestamp of the shift slot.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift slot.
       */
      to: string;
    };
    /**
     * OMSShiftSlotInput
     * @description Input data for setting an OMS shift slot.
     */
    OMSShiftSlotInput: {
      shiftType: components['schemas']['OMSShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     Required for OnCall shifts.
       */
      organs?: components['schemas']['Organ'][];
      /**
       * @description This shift exceeds the monthly norm for the number of shifts of this type,
       *     but the employee agrees to take additional shifts.
       */
      isVoluntary?: boolean;
    };
    /**
     * OMSShiftType
     * @description Type of Organ Management Specialist shift.
     * @enum {string}
     */
    OMSShiftType: OMSShiftType;
    /**
     * OMSShiftTypeNeighborRule
     * @description The rule limits the possibility of adjacent shifts.
     */
    OMSShiftTypeNeighborRule: {
      /**
       * Format: int32
       * @description Required days count before target shift
       */
      daysBefore: number;
      /**
       * Format: int32
       * @description Required days count after target shift
       */
      daysAfter: number;
      /** @description Allowable shift type before target shift */
      beforeShiftTypes: components['schemas']['OMSShiftType'][];
      /** @description Allowable shift type after target shift */
      afterShiftTypes: components['schemas']['OMSShiftType'][];
    };
    /**
     * OMSShiftTypeResourceRulesViolations
     * @description Violations of employee work rules.
     */
    OMSShiftTypeResourceRulesViolations: {
      /**
       * @description Violations of the number of shifts by type per period.
       *     Key is shift type.
       */
      periodShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AdminDay: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        SickLeave: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountByTypeViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AdminDay: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        SickLeave: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @description Violations of the number of shifts on weekend by type per period.
       *     Key is shift type.
       */
      periodShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AdminDay: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        SickLeave: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountOnWeekEndViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        AdminDay: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        SickLeave: components['schemas']['RangeRuleViolation'];
      } | null;
      periodShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      periodShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      /**
       * @description Violation of the number shifts in row by shift type.
       *     Key is shift type.
       */
      shiftTypeInRowViolations: {
        OnCall: components['schemas']['ShiftInRowRuleViolations'];
        AdminDay: components['schemas']['ShiftInRowRuleViolations'];
        NoCall: components['schemas']['ShiftInRowRuleViolations'];
        Unavailable: components['schemas']['ShiftInRowRuleViolations'];
        Vacation: components['schemas']['ShiftInRowRuleViolations'];
        SickLeave: components['schemas']['ShiftInRowRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftNeighborViolations: {
        OnCall: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
        AdminDay: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
        NoCall: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
        Unavailable: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
        Vacation: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
        SickLeave: components['schemas']['OMSShiftTypeShiftNeighborRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftAllowedDayOfWeekViolations: {
        OnCall: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        AdminDay: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        NoCall: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Unavailable: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Vacation: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        SickLeave: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolations'];
      } | null;
    };
    /**
     * OMSShiftTypeScheduleValidationResult
     * @description Result of schedule validation.
     */
    OMSShiftTypeScheduleValidationResult: {
      /** @description True if there are any validation rule violations. */
      hasRuleViolations: boolean;
      /**
       * @description Indicates whether preprocessing has been performed for the schedule.
       *     Schedules without preprocessing can be obtained faster, but they may contain inaccuracies.
       */
      isPreprocessed: boolean;
      scheduleSize: components['schemas']['ScheduleSize'];
      publishReadiness: components['schemas']['SchedulePublishReadiness'];
      /** @description Violations of the rules of service (OnCall, PhoneSupport) requirements by day. */
      dailyRulesViolations: {
        [key: string]: components['schemas']['OMSShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of the rules of service (OnCall, PhoneSupport) requirements by week.
       *     Key of dictionary is first day of week.
       */
      weeklyRulesViolations: {
        [key: string]: components['schemas']['OMSShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of employees work rules.
       *     Key of dictionary is resource id.
       */
      resourceRulesViolations: {
        [key: string]: components['schemas']['OMSShiftTypeResourceRulesViolations'];
      } | null;
    };
    /** OMSShiftTypeScheduleValidationResultOperationResult */
    OMSShiftTypeScheduleValidationResultOperationResult: {
      data: components['schemas']['OMSShiftTypeScheduleValidationResult'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * OMSShiftTypeServicesRulesViolations
     * @description Violation of the requirements for the number of shifts of a certain type across countries, regions and hubs.
     */
    OMSShiftTypeServicesRulesViolations: {
      /** @description Violation of needs across the country for different types of shifts. */
      countryRulesViolations: {
        OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        AdminDay: components['schemas']['ServiceShiftTypeRulesViolations'];
        NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
        Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
        SickLeave: components['schemas']['ServiceShiftTypeRulesViolations'];
      } | null;
      /**
       * @description Violation of needs in different regions for different types of shifts.
       *     Key is region id.
       */
      regionsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          AdminDay: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          SickLeave: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
      /**
       * @description Violation of needs in different hubs for different types of shifts.
       *     Key is hub id.
       */
      hubsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          AdminDay: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          SickLeave: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
    };
    /**
     * OMSShiftTypeShiftAllowedDayOfWeekRuleViolation
     * @description Violation of shift type day of week rule
     */
    OMSShiftTypeShiftAllowedDayOfWeekRuleViolation: {
      /**
       * Format: date
       * @description Date of target shift
       */
      targetDate: string;
      actual: components['schemas']['DayOfWeek'];
    };
    /** OMSShiftTypeShiftAllowedDayOfWeekRuleViolations */
    OMSShiftTypeShiftAllowedDayOfWeekRuleViolations: {
      actualRule: components['schemas']['DayOfWeek'][];
      violations: components['schemas']['OMSShiftTypeShiftAllowedDayOfWeekRuleViolation'][];
    };
    /**
     * OMSShiftTypeShiftNeighborRuleViolation
     * @description Shift neighbor rule violation incident
     */
    OMSShiftTypeShiftNeighborRuleViolation: {
      /**
       * Format: date-time
       * @description A target shift for which the neighborhood requirement is not met.
       */
      targetDate: string;
      /** @description Current types of shifts before the target. */
      actualBefore: components['schemas']['OMSShiftType'][];
      /** @description Current types of shifts after the target. */
      actualAfter: components['schemas']['OMSShiftType'][];
    };
    /**
     * OMSShiftTypeShiftNeighborRuleViolations
     * @description Violations of the rule on the shift neighbors
     */
    OMSShiftTypeShiftNeighborRuleViolations: {
      violatedRule: components['schemas']['OMSShiftTypeNeighborRule'];
      /** @description Collection of rule violation incidents */
      violations: components['schemas']['OMSShiftTypeShiftNeighborRuleViolation'][];
    };
    /** OcsConsoleData */
    OcsConsoleData: {
      /** Format: uuid */
      id: string;
      /** Format: date-time */
      createdAt: string;
      /** Format: date-time */
      modifiedAt: string;
      ocsConsoleName: string | null;
      serialNumber: string | null;
      serialNumberPrefix: string | null;
      fullSerialNumber: string | null;
      caseNumber: string | null;
      /** Format: uuid */
      nopHub: string | null;
      organType: components['schemas']['Organ'];
      status: components['schemas']['OcsConsoleStatus'];
      isInMaintenance: boolean;
      /** Format: int32 */
      lastInUseDaysAgo: number | null;
      reservations: components['schemas']['ReservationData'][];
      /** Format: uuid */
      caseId: string | null;
      caseName: string | null;
      logoPath: string | null;
      trialProgram: components['schemas']['TrialProgramResponse'];
    };
    /** OcsConsoleDataIReadOnlyCollectionOperationResult */
    OcsConsoleDataIReadOnlyCollectionOperationResult: {
      data: components['schemas']['OcsConsoleData'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** OcsConsoleDataListOperationResult */
    OcsConsoleDataListOperationResult: {
      data: components['schemas']['OcsConsoleDataPaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** OcsConsoleDataOperationResult */
    OcsConsoleDataOperationResult: {
      data: components['schemas']['OcsConsoleData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** OcsConsoleDataPaginatedData */
    OcsConsoleDataPaginatedData: {
      items: components['schemas']['OcsConsoleData'][];
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /**
     * OcsConsoleSearchOrderBy
     * @enum {string}
     */
    OcsConsoleSearchOrderBy: OcsConsoleSearchOrderBy;
    /**
     * OcsConsoleStatus
     * @enum {string}
     */
    OcsConsoleStatus: OcsConsoleStatus;
    /**
     * OnCallInRowRules
     * @description Describes the number of shifts in-row.
     */
    OnCallInRowRules: {
      /**
       * Format: int32
       * @description Minimum sequence length
       */
      hardMin: number | null;
      /**
       * Format: int32
       * @description Lower limit of recommended length.
       */
      recommendedMin: number | null;
      /**
       * Format: int32
       * @description Upper limit of recommended length.
       */
      recommendedMax: number | null;
      /**
       * Format: int32
       * @description Maximum sequence length
       */
      hardMax: number | null;
    };
    /** OperationResult */
    OperationResult: {
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
    };
    /**
     * Organ
     * @description Human organ
     * @enum {string}
     */
    Organ: Organ;
    /** PatchBannedTailNumberRequest */
    PatchBannedTailNumberRequest: {
      tailNumber: string | null;
      comment: string | null;
      /** Format: uuid */
      logisticProviderId: string | null;
    };
    /** PatchDriverRequest */
    PatchDriverRequest: {
      firstName: string | null;
      lastName: string | null;
      phone: string | null;
      isBanned: boolean | null;
      affiliationType: components['schemas']['DriverAffiliationType'];
      companyName: string | null;
      /** Format: uuid */
      logisticProviderId: string | null;
      /** Format: uuid */
      txCenterProviderId: string | null;
      comment: string | null;
    };
    /** PatchEmployeeRequest */
    PatchEmployeeRequest: {
      /** Format: float */
      weight: number | null;
      scrubSizeTop: components['schemas']['Size'];
      scrubSizeBottom: components['schemas']['Size'];
      tsaPrecheckNumber: string | null;
      phone: string | null;
      /** Format: uuid */
      baseLocation: string | null;
      /** Format: uuid */
      homeLocation: string | null;
      /** Format: int32 */
      closestAirportForDeployment: number | null;
      locationPreference: components['schemas']['LocationPreference'];
      organSpecializations: components['schemas']['Organ'][];
      canWorkOnExtraShifts: boolean | null;
      /** Format: int32 */
      extraShiftsCount: number | null;
      canTravel: boolean | null;
      /** Format: int32 */
      travelShiftsCount: number | null;
      affiliationType: components['schemas']['AffiliationType'];
      /** Format: uuid */
      affiliationId: string | null;
      contractorCertifications: components['schemas']['ContractorCertificationModel'][];
      clinicalCoordinatorType: components['schemas']['CCResourceType'];
      clinicalSpecialistShiftGroupType: components['schemas']['CSHolidayDutyGroup'];
      shiftTimeGroup: components['schemas']['CSShiftTimeGroup'];
      /** Format: uuid */
      liverSurgeonRegionId: string | null;
      /** Format: uuid */
      heartLungsSurgeonRegionId: string | null;
      phoneSupportOrganSpecializations: components['schemas']['Organ'][];
      organManagementSpecialistSpecializations: components['schemas']['Organ'][];
      proctorOrganSpecializations: components['schemas']['Organ'][];
      shadowOrganSpecializations: components['schemas']['Organ'][];
      profilePhoto: string | null;
      rsScheduleManagerOrgans: components['schemas']['Organ'][];
      roles: string[];
      trialProgramIds: string[];
    };
    /** PatchInventoryPartRequest */
    PatchInventoryPartRequest: {
      /** Format: uuid */
      trialProgramId: string | null;
      caseIds: string | null;
      type: components['schemas']['InventoryPartType'];
      partNumber: string | null;
      serialCode: string | null;
      /** Format: date-time */
      expirationDate: string | null;
      caseNumber: string | null;
    };
    /** PatchOcsConsoleRequest */
    PatchOcsConsoleRequest: {
      ocsConsoleName: string | null;
      serialNumber: string | null;
      /** Format: uuid */
      nopHub: string | null;
      organType: components['schemas']['Organ'];
      isInMaintenance: boolean | null;
      logoPath: string | null;
      /** Format: uuid */
      trialProgramId: string | null;
    };
    /** PatchOwnEmployeeRequest */
    PatchOwnEmployeeRequest: {
      /** Format: float */
      weight: number | null;
      scrubSizeTop: components['schemas']['Size'];
      scrubSizeBottom: components['schemas']['Size'];
      tsaPrecheckNumber: string | null;
      phone: string | null;
      /** Format: uuid */
      baseLocation: string | null;
      /** Format: uuid */
      homeLocation: string | null;
      /** Format: int32 */
      closestAirportForDeployment: number | null;
      locationPreference: components['schemas']['LocationPreference'];
      organSpecializations: components['schemas']['Organ'][];
      canWorkOnExtraShifts: boolean | null;
      /** Format: int32 */
      extraShiftsCount: number | null;
      canTravel: boolean | null;
      /** Format: int32 */
      travelShiftsCount: number | null;
      affiliationType: components['schemas']['AffiliationType'];
      /** Format: uuid */
      affiliationId: string | null;
      contractorCertifications: components['schemas']['ContractorCertificationModel'][];
      clinicalCoordinatorType: components['schemas']['CCResourceType'];
      clinicalSpecialistShiftGroupType: components['schemas']['CSHolidayDutyGroup'];
      shiftTimeGroup: components['schemas']['CSShiftTimeGroup'];
      /** Format: uuid */
      liverSurgeonRegionId: string | null;
      /** Format: uuid */
      heartLungsSurgeonRegionId: string | null;
      phoneSupportOrganSpecializations: components['schemas']['Organ'][];
      organManagementSpecialistSpecializations: components['schemas']['Organ'][];
      proctorOrganSpecializations: components['schemas']['Organ'][];
      shadowOrganSpecializations: components['schemas']['Organ'][];
      profilePhoto: string | null;
    };
    /** PerOrganMatchType */
    PerOrganMatchType: {
      global: components['schemas']['CandidateMatchType'];
      liver: components['schemas']['CandidateMatchType'];
      heart: components['schemas']['CandidateMatchType'];
      lungs: components['schemas']['CandidateMatchType'];
    };
    /**
     * PeriodSchedule
     * @description Monthly schedule information
     */
    PeriodSchedule: {
      /**
       * Format: date-time
       * @description First day of month
       */
      periodStartDay: string;
      /**
       * Format: date-time
       * @description Last day of month
       */
      periodEndDay: string;
      /** @description True if published work schedule exist for this month */
      readonly hasSchedule?: boolean;
      /** @description True if pre schedule exist for this month */
      readonly hasPreSchedule?: boolean;
      /** @description True if exist not cancelled planning process for this month */
      readonly hasPlanningProcess?: boolean;
      /**
       * Format: uuid
       * @description Id of published work schedule
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.HasSchedule is false
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description Date of last workday sync for work schedule
       */
      scheduleHrSystemLastSyncDate: string | null;
      /**
       * Format: uuid
       * @description Id of pre schedule
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.HasPreSchedule is false
       */
      preScheduleId: string | null;
      /**
       * Format: date-time
       * @description Date of last workday sync for pre schedule
       */
      preScheduleHrSystemLastSyncDate: string | null;
      /**
       * Format: uuid
       * @description Id of planning process
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.HasPlanningProcess is false
       */
      planningProcessId: string | null;
      /**
       * Format: uuid
       * @description The schedule identifier associated with the planning process.
       *     Null if ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.HasPlanningProcess is false
       */
      inPlanningScheduleId: string | null;
      planningProcessStatus: components['schemas']['PlanningProcessStatus'];
      /**
       * Format: date-time
       * @description Date of last workday sync for in planning schedule
       */
      inPlanningScheduleHrSystemLastSyncDate: string | null;
      /**
       * Format: date-time
       * @deprecated
       * @description Legacy name of ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.PeriodStartDay.
       */
      readonly startDayOfMonth?: string;
      /**
       * Format: date-time
       * @deprecated
       * @description Legacy name of ResourceService.Application.Contracts.Scheduler.QueryModels.PeriodSchedule.PeriodEndDay.
       */
      readonly endDayOfMonth?: string;
    };
    /** PeriodScheduleOperationResult */
    PeriodScheduleOperationResult: {
      data: components['schemas']['PeriodSchedule'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * PlanningProcess
     * @description The schedule planning process.
     */
    PlanningProcess: {
      /**
       * Format: uuid
       * @description Process id
       */
      id: string;
      /**
       * Format: date-time
       * @description The first day of the period for which the schedule is planned
       */
      periodStartDay: string;
      /**
       * Format: date-time
       * @description The last day of the period for which the schedule is planned
       */
      periodEndDay: string;
      /**
       * Format: date-time
       * @deprecated
       * @description Legacy name of ResourceService.Application.Contracts.Scheduler.QueryModels.PlanningProcess.PeriodStartDay.
       */
      readonly startDayOfMonth?: string;
      status: components['schemas']['PlanningProcessStatus'];
      /**
       * Format: uuid
       * @description The identifier of the schedule that is created by this scheduling process.
       */
      scheduleId: string | null;
      scheduleType: components['schemas']['ScheduleType'];
      /**
       * Format: uuid
       * @description Id of schedule generation job.
       */
      jobId: string | null;
      /** @description True if user request cancel generation job */
      jobCancellationRequested: boolean;
      /**
       * @description The last error that occurred during planning.
       *     It is cleared when the status changes.
       */
      lastErrors: components['schemas']['Error'][];
      autoSchedulerInfo: components['schemas']['AutoSchedulerInfo'];
      hrSystemError: components['schemas']['Error'];
    };
    /** PlanningProcessOperationResult */
    PlanningProcessOperationResult: {
      data: components['schemas']['PlanningProcess'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * PlanningProcessStatus
     * @description Planning process status.
     *     Represents the summary status for the user interface.
     * @enum {string}
     */
    PlanningProcessStatus: PlanningProcessStatus;
    /** RSAffiliation */
    RSAffiliation: {
      type: components['schemas']['AffiliationType'];
      /** Format: uuid */
      entityId: string | null;
      entityName: string | null;
      entityLocation: components['schemas']['Location'];
    };
    /** RSAssignmentCandidate */
    RSAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      employeeRoles: string[];
      employeeCertificates: components['schemas']['Organ'][];
      lastTrackedLocation: components['schemas']['TrackedLocationModel'];
      lastCallDays: components['schemas']['LastCallInfo'];
      conflictedReservation?: components['schemas']['ConflictedReservation'];
      match: components['schemas']['RSAssignmentCandidateMatch'];
      shiftCertificates: components['schemas']['Organ'][];
      /** Format: uuid */
      baseLocation: string | null;
      /** Format: date-span */
      onCallBeforeTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onCallBeforeOr?: string | null;
      /** Format: date-span */
      onCallAfterTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onCallAfterOr?: string | null;
      /** Format: double */
      onCallBeforeTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onCallBeforeOrMinutes?: number | null;
      /** Format: double */
      onCallAfterTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onCallAfterOrMinutes?: number | null;
      /** Format: date-span */
      onRestEndsBeforeTarget: string | null;
      /**
       * Format: date-span
       * @deprecated
       */
      readonly onRestEndsBeforeOr?: string | null;
      /** Format: double */
      onRestEndsBeforeTargetMinutes: number | null;
      /** Format: date-span */
      onRestStartsAfterTarget: string | null;
      /** Format: double */
      onRestStartsAfterTargetMinutes: number | null;
      /**
       * Format: double
       * @deprecated
       */
      readonly onRestEndsBeforeOrMinutes?: number | null;
      conflictedRest?: components['schemas']['ConflictedRest'];
      days30Stats: components['schemas']['RSDays30Stats'];
      homeLocation: components['schemas']['AssignmentCandidateLocation'];
      unavailabilities: components['schemas']['UnavailabilityInfo'][];
    };
    /** RSAssignmentCandidateIReadOnlyCollectionOperationResult */
    RSAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['RSAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** RSAssignmentCandidateMatch */
    RSAssignmentCandidateMatch: {
      matchType: components['schemas']['CandidateMatchType'];
      caseType: components['schemas']['CaseMatchType'];
      availableActionType: components['schemas']['ActionType'];
      onCallMatchType: components['schemas']['CandidateMatchType'];
      onCallBeforeTargetMatchType: components['schemas']['CandidateMatchType'];
      onCallAfterTargetMatchType: components['schemas']['CandidateMatchType'];
      onRestMatchType: components['schemas']['CandidateMatchType'];
      onRestEndsBeforeTargetMatchType: components['schemas']['CandidateMatchType'];
      onRestStartsAfterTargetMatchType: components['schemas']['CandidateMatchType'];
      onCallUnavailabilitiesMatchType: components['schemas']['CandidateMatchType'];
    };
    /**
     * RSCandidatesNode
     * @description Retrieval Surgeon candidates node for specific organ, donor, and hub.
     *     Contains priority ordered candidates for each time slot.
     */
    RSCandidatesNode: {
      organType: components['schemas']['Organ'];
      donorType: components['schemas']['Donor'];
      /**
       * @description The best candidates index for each time slot.
       *     3 layered collection:
       *     1st array - time slots in the same order as in ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.TimeSlots.
       *     2nd array - candidates for the time slot ordered by priority.
       *     3rd array - two integers: [0] - index of the candidate in the ResourceService.Application.Contracts.AssignmentCandidates.Bulk.BulkAssignmentCandidates.RetrievalSurgeons, [1] - time buffer in minutes for the candidate.
       */
      bestsForSlot: number[][][];
    };
    /** RSContractorAssignmentCandidate */
    RSContractorAssignmentCandidate: {
      /** Format: uuid */
      employeeId: string;
      employeeProfilePhoto: string | null;
      employeeFullName: string | null;
      employeeRoles: string[];
      employeeCertificates: components['schemas']['Organ'][];
      lastTrackedLocation: components['schemas']['TrackedLocationModel'];
      lastCallDays: components['schemas']['LastCallInfo'];
      conflictedReservation?: components['schemas']['ConflictedReservation'];
      match: components['schemas']['AssignmentCandidateMatch'];
      days30Stats: components['schemas']['RSDays30Stats'];
      homeLocation: components['schemas']['AssignmentCandidateLocation'];
      affiliation: components['schemas']['RSAffiliation'];
    };
    /** RSContractorAssignmentCandidateIReadOnlyCollectionOperationResult */
    RSContractorAssignmentCandidateIReadOnlyCollectionOperationResult: {
      data: components['schemas']['RSContractorAssignmentCandidate'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** RSDays30Stats */
    RSDays30Stats: {
      /** Format: int32 */
      successful: number;
      /** Format: int32 */
      total: number;
    };
    /**
     * RangeRule
     * @description From to inclusive rule.
     */
    RangeRule: {
      /**
       * Format: int32
       * @description Lower bound of range
       */
      inclusiveFrom: number | null;
      /**
       * Format: int32
       * @description Upper bound of range
       */
      inclusiveTo: number | null;
    };
    /**
     * RangeRuleViolation
     * @description Violations of the range rule.
     */
    RangeRuleViolation: {
      /**
       * Format: int32
       * @description Current actual value that does not fit into the rule.
       */
      actualValue: number;
      violatedRule: components['schemas']['RangeRule'];
    };
    /**
     * Region
     * @description Transmedics region basic information.
     *     Include related hubs.
     */
    Region: {
      /**
       * Format: uuid
       * @description Region id
       */
      id: string;
      /** @description Region display name */
      name: string | null;
      /** @description List of hubs belonging to this region. */
      hubs: components['schemas']['Hub'][];
    };
    /** RegionIEnumerableOperationResult */
    RegionIEnumerableOperationResult: {
      data: components['schemas']['Region'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * RegionInfo
     * @description Transmedics region basic information
     */
    RegionInfo: {
      /**
       * Format: uuid
       * @description Region id
       */
      id: string;
      /** @description Region display name */
      name: string | null;
    };
    /**
     * RegionalHub
     * @description Transmedics hub basic information with extended region information
     */
    RegionalHub: {
      /**
       * Format: uuid
       * @description Hub id
       */
      id: string;
      /**
       * Format: uuid
       * @description Region Id
       */
      regionId: string;
      /** @description Hub code */
      code: string | null;
      /** @description Hub display name */
      name: string | null;
      /** @description Hub timezone */
      timezone: string | null;
      region: components['schemas']['RegionInfo'];
    };
    /** ReservationData */
    ReservationData: {
      /** Format: uuid */
      caseId: string;
      caseName: string | null;
      status: components['schemas']['ResourceStatus'];
      /** Format: date-time */
      createdAt: string;
      /** Format: date-time */
      modifiedAt: string | null;
    };
    /**
     * ResourceAvailabilityNode
     * @description Represents a resource availability node indicating reservation, case assignment, or rest period
     */
    ResourceAvailabilityNode: {
      /**
       * Format: uuid
       * @description Unique identifier of the node (reservation id or rest period id)
       */
      nodeId: string;
      /**
       * Format: date-time
       * @description Start date and time of the availability node
       */
      from: string;
      /**
       * Format: date-time
       * @description End date and time of the availability node. Null if the end time is not yet determined.
       */
      to: string | null;
      type: components['schemas']['ResourceAvailabilityNodeType'];
      /**
       * Format: uuid
       * @description Case identifier if the node is related to a case
       */
      caseId: string | null;
      /** @description Case name if the node is related to a case */
      caseName: string | null;
    };
    /**
     * ResourceAvailabilityNodeType
     * @description Type of resource availability node
     * @enum {string}
     */
    ResourceAvailabilityNodeType: ResourceAvailabilityNodeType;
    /**
     * ResourceStatus
     * @enum {string}
     */
    ResourceStatus: ResourceStatus;
    /** ResourcesAvailibilityData */
    ResourcesAvailibilityData: {
      aircrafts: components['schemas']['AircraftAvailabilityView'][];
      employees: components['schemas']['EmployeeAvailabilityData'][];
      consoles: components['schemas']['OcsConsoleData'][];
    };
    /** ResourcesAvailibilityDataOperationResult */
    ResourcesAvailibilityDataOperationResult: {
      data: components['schemas']['ResourcesAvailibilityData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** ResourcesUnlockedEvent */
    ResourcesUnlockedEvent: {
      /** Format: uuid */
      correlationId: string;
      caseIds: string[];
      /** Format: int32 */
      removedCount: number;
    };
    /** ResourcesUnlockedEventOperationResult */
    ResourcesUnlockedEventOperationResult: {
      data: components['schemas']['ResourcesUnlockedEvent'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * RetrievalSurgeon
     * @description Retrieval Surgeon details for bulk assignment candidates.
     */
    RetrievalSurgeon: {
      /**
       * Format: uuid
       * @description The unique identifier of the employee.
       */
      id: string;
      /** @description The first name of the employee. */
      firstName: string | null;
      /** @description The last name of the employee. */
      lastName: string | null;
      /**
       * Format: uuid
       * @description The case ID where the current resource has an active reservation.
       */
      activeCaseId: string | null;
      trackedLocation: components['schemas']['TrackedGeoLocation'];
      homeLocation: components['schemas']['GeoLocation'];
    };
    /**
     * RoleInfo
     * @description Represents employee role info.
     */
    RoleInfo: {
      /** @description Name of the role (e.g., "Clinical Specialist"). */
      name: string | null;
      /** @description The abbreviated short code for the role (e.g., "CS"). */
      acronym: string | null;
    };
    /**
     * SMyScheduleSegment
     * @description Clinical specialist schedule for a specific period for the clinical specialist viewing the schedule.
     */
    SMyScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      myShifts: components['schemas']['SResourceScheduleSegment'];
      /**
       * @description Shifts of resource grouped by clinical specialist id.
       *     Key is resource id.
       */
      otherResourcesShifts: {
        [key: string]: components['schemas']['SResourceScheduleSegment'];
      } | null;
      /** @description Hub information for all hubs referenced in shifts. */
      hubs: {
        [key: string]: components['schemas']['RegionalHub'];
      } | null;
    };
    /** SMyScheduleSegmentOperationResult */
    SMyScheduleSegmentOperationResult: {
      data: components['schemas']['SMyScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SRegion
     * @description Transmedics surgeon region basic information
     */
    SRegion: {
      /**
       * Format: uuid
       * @description Region id
       */
      id: string;
      /** @description Region display name */
      name: string | null;
      /** @description List of hubs belonging to this region. */
      hubs: components['schemas']['Hub'][];
      /** @description List of organs supported by regions */
      organs: components['schemas']['Organ'][];
    };
    /** SRegionIEnumerableOperationResult */
    SRegionIEnumerableOperationResult: {
      data: components['schemas']['SRegion'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SRequirementsInputsSettings
     * @description Settings of the basic rules for service requirements by region.
     */
    SRequirementsInputsSettings: {
      /**
       * @description Minimal per regions per organ requirements.
       *     Key of map is region id.
       */
      perRegions: {
        [key: string]: {
          Liver: components['schemas']['ComboMinRule'];
          Heart: components['schemas']['ComboMinRule'];
          Lungs: components['schemas']['ComboMinRule'];
          Kidney: components['schemas']['ComboMinRule'];
        };
      } | null;
    };
    /** SRequirementsInputsSettingsOperationResult */
    SRequirementsInputsSettingsOperationResult: {
      data: components['schemas']['SRequirementsInputsSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SResetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.Surgeon.SResetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    SResetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
    };
    /**
     * SResetShiftType
     * @description Resets the specified shift type on a specified day for a specified resource.
     */
    SResetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be reset.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being reset.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is reset.
       */
      day: string;
    };
    /**
     * SResolveHrSystemConflict
     * @description Resolve HR system conflict command for Surgeon
     */
    SResolveHrSystemConflict: {
      /** Format: uuid */
      conflictId: string;
      setShiftData: components['schemas']['SetSShiftData'];
    };
    /**
     * SResource
     * @description Information about clinical specialist - type of Transmedics resource
     */
    SResource: {
      /**
       * Format: uuid
       * @description Resource id
       */
      id: string;
      /** @description FirstName */
      firstName: string | null;
      /** @description LastName */
      lastName: string | null;
      /** @description Link to profile image */
      profilePhoto: string | null;
      /** @description Resource phone number */
      phoneNumber: string | null;
      /** @description List of certificates from the bodies with which the specialist can work. */
      organs: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The identifier of the region to which this specialist belongs.
       */
      regionId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the hub to which this specialist belongs.
       */
      hubId: string | null;
      /** @description Resource hub timezone */
      timezone: string | null;
      group: components['schemas']['SurgeonGroup'];
    };
    /**
     * SResourceRulesSettings
     * @description Clinical specialists work rules.
     */
    SResourceRulesSettings: {
      /**
       * Format: int32
       * @description Count of NoCall sift type per period
       */
      minNoCallDaysPerPeriod?: number | null;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.Surgeon.SResourceRulesSettings.MinNoCallDaysPerPeriod. Write-only for deserelization, never serialized back.
       */
      minNoCallDaysPerMonth?: number | null;
      /**
       * Format: int32
       * @description Count of NoCall sift type per period
       */
      maxNoCallDaysPerPeriod?: number | null;
      /**
       * Format: int32
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Settings.Surgeon.SResourceRulesSettings.MaxNoCallDaysPerPeriod. Write-only for deserelization, never serialized back.
       */
      maxNoCallDaysPerMonth?: number | null;
      noCallInRow: components['schemas']['NoCallInRowRules'];
    };
    /** SResourceRulesSettingsOperationResult */
    SResourceRulesSettingsOperationResult: {
      data: components['schemas']['SResourceRulesSettings'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SResourceSShiftTypeHrSystemConflict
     * @description Represents a conflict between a scheduled shift and a HR system shift for a specific resource on a given day.
     */
    SResourceSShiftTypeHrSystemConflict: {
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier of the conflict.
       */
      conflictId: string;
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the schedule associated with this conflict.
       */
      scheduleId: string;
      type: components['schemas']['ScheduleHrSystemConflictType'];
      /**
       * Format: uuid
       * @description Gets or sets the unique identifier for the resource.
       */
      resourceId: string;
      resource: components['schemas']['SResource'];
      /**
       * Format: date
       * @description Gets or sets the day represented as a System.DateOnly value.
       */
      day: string;
      hrSystemShiftType: components['schemas']['SShiftType'];
      scheduleShiftType: components['schemas']['SShiftType'];
    };
    /** SResourceSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult */
    SResourceSShiftTypeHrSystemConflictIReadOnlyCollectionOperationResult: {
      data: components['schemas']['SResourceSShiftTypeHrSystemConflict'][];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SResourceScheduleNexusSegment
     * @description Schedule for single surgeon with availability information for Nexus view
     */
    SResourceScheduleNexusSegment: {
      resource: components['schemas']['SResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['SShift'];
      } | null;
      /** @description Resource availability information including reservations, case assignments, and rest periods */
      resourceAvailability: components['schemas']['ResourceAvailabilityNode'][];
    };
    /**
     * SResourceScheduleSegment
     * @description Schedule for single surgeon
     */
    SResourceScheduleSegment: {
      resource: components['schemas']['SResource'];
      /**
       * @description Resource shifts by days.
       *     Key is day.
       */
      days: {
        [key: string]: components['schemas']['SShift'];
      } | null;
    };
    /**
     * SScheduleNexusSegment
     * @description Surgeon schedule segment for Nexus view with regions and resource availability
     */
    SScheduleNexusSegment: {
      /**
       * Format: date-time
       * @description Start date of the schedule segment
       */
      from: string;
      /**
       * Format: date-time
       * @description End date of the schedule segment
       */
      to: string;
      /** @description List of all regions with their hubs */
      regions: components['schemas']['SRegion'][];
      /** @description Dictionary of resource shifts keyed by resource ID */
      resourcesShifts: {
        [key: string]: components['schemas']['SResourceScheduleNexusSegment'];
      } | null;
    };
    /** SScheduleNexusSegmentOperationResult */
    SScheduleNexusSegmentOperationResult: {
      data: components['schemas']['SScheduleNexusSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SScheduleSegment
     * @description Surgeon schedule for a specific period.
     */
    SScheduleSegment: {
      /**
       * Format: date-time
       * @description Schedule fragment start date, inclusive
       */
      from: string;
      /**
       * Format: date-time
       * @description Schedule fragment end date, inclusive
       */
      to: string;
      /**
       * @description Shifts of clinical specialists grouped by clinical specialist id.
       *     Key is clinical specialist id.
       */
      resourcesShifts: {
        [key: string]: components['schemas']['SResourceScheduleSegment'];
      } | null;
    };
    /** SScheduleSegmentOperationResult */
    SScheduleSegmentOperationResult: {
      data: components['schemas']['SScheduleSegment'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** SSetFixationType */
    SSetFixationType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift is located.
       */
      scheduleId: string;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift fixation type is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is located.
       */
      day: string;
      fixationType: components['schemas']['ShiftFixationType'];
    };
    /**
     * SSetMyShiftTypeModel
     * @description <inheritdoc cref="T:ResourceService.Application.Contracts.Scheduler.Command.Surgeon.SSetShiftType" path="/summary" />
     *                 Applicable only for pre schedule
     */
    SSetMyShiftTypeModel: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      /** @description If true, then shift type can't be changed by algorithm */
      required: boolean;
      shiftType: components['schemas']['SShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel?: boolean;
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
    };
    /** SSetShiftType */
    SSetShiftType: {
      /**
       * Format: uuid
       * @description The schedule identifier in which the shift should be set.
       *     If null, then tries to determine schedules by shift date.
       */
      scheduleId: string | null;
      /**
       * Format: uuid
       * @description The identifier of the resource for which the shift is being set.
       */
      resourceId: string;
      /**
       * Format: date-time
       * @description The day on which the shift is set.
       */
      day: string;
      shiftType: components['schemas']['SShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
      unavailabilities?: components['schemas']['Unavailability'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel?: boolean;
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      fixationType?: components['schemas']['ShiftFixationType'];
    };
    /**
     * SShift
     * @description Clinical specialist shift
     */
    SShift: {
      /**
       * Format: uuid
       * @description The schedule identifier to which the shift belongs.
       */
      scheduleId: string;
      /**
       * Format: date-time
       * @description The day on which the work shift takes place.
       */
      day: string;
      /**
       * Format: date-time
       * @description The start timestamp of the shift.
       */
      from: string;
      /**
       * Format: date-time
       * @description The end timestamp of the shift.
       */
      to: string;
      /**
       * Format: uuid
       * @description The ID of the resource that is scheduled to work this shift.
       */
      resourceId: string;
      shiftStatus: components['schemas']['ShiftStatus'];
      /** @description True is this shift can be changed manually */
      isEditable: boolean;
      /** @description True if this shift is placed on the pre (preliminary) schedule. */
      isPreSchedule: boolean;
      fixationType: components['schemas']['ShiftFixationType'];
      /** @description True if the shift source is HrSystem. */
      isHrShift: boolean;
      shiftType: components['schemas']['SShiftType'];
      /** @description List of organs, for which this shift is intended */
      organs: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The region id where the shift takes place.
       */
      regionId: string | null;
      /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
      unavailabilities: components['schemas']['Unavailability'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel: boolean;
    };
    /** SShiftOperationResult */
    SShiftOperationResult: {
      data: components['schemas']['SShift'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SShiftType
     * @description Type of surgeon shift.
     * @enum {string}
     */
    SShiftType: SShiftType;
    /** SShiftTypeCompositeShift */
    SShiftTypeCompositeShift: {
      /** Format: uuid */
      resourceId: string;
      /** Format: uuid */
      regionId: string | null;
      /** Format: uuid */
      hubId: string | null;
      /** Format: date-time */
      fromOffset: string;
      /** Format: date-time */
      toOffset: string;
      shiftType: components['schemas']['SShiftType'];
      isManager: boolean | null;
      /** Format: date-time */
      readonly fromUtc: string;
      /** Format: date-time */
      readonly toUtc: string;
    };
    /**
     * SShiftTypeNeighborRule
     * @description The rule limits the possibility of adjacent shifts.
     */
    SShiftTypeNeighborRule: {
      /**
       * Format: int32
       * @description Required days count before target shift
       */
      daysBefore: number;
      /**
       * Format: int32
       * @description Required days count after target shift
       */
      daysAfter: number;
      /** @description Allowable shift type before target shift */
      beforeShiftTypes: components['schemas']['SShiftType'][];
      /** @description Allowable shift type after target shift */
      afterShiftTypes: components['schemas']['SShiftType'][];
    };
    /**
     * SShiftTypeResourceRulesViolations
     * @description Violations of employee work rules.
     */
    SShiftTypeResourceRulesViolations: {
      /**
       * @description Violations of the number of shifts by type per period.
       *     Key is shift type.
       */
      periodShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountByTypeViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountByTypeViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @description Violations of the number of shifts on weekend by type per period.
       *     Key is shift type.
       */
      periodShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
      } | null;
      /**
       * @deprecated
       * @description Legacy JSON name of ResourceService.Domain.Contracts.Scheduler.Validations.ResourceRulesViolations`1.PeriodShiftCountOnWeekEndViolations. Never serialized back:
       *     the getter always returns null and null values are ignored on writing.
       *     (A getter is required because System.Text.Json skips set-only collection properties on deserialization.)
       */
      monthlyShiftCountOnWeekEndViolations?: {
        OnCall: components['schemas']['RangeRuleViolation'];
        NoCall: components['schemas']['RangeRuleViolation'];
        Unavailable: components['schemas']['RangeRuleViolation'];
        Vacation: components['schemas']['RangeRuleViolation'];
        Sick: components['schemas']['RangeRuleViolation'];
      } | null;
      periodShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountOnCallPhoneSupportViolation?: components['schemas']['RangeRuleViolation'];
      periodShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      monthlyShiftCountNoCallWeekEndViolation?: components['schemas']['RangeRuleViolation'];
      /**
       * @description Violation of the number shifts in row by shift type.
       *     Key is shift type.
       */
      shiftTypeInRowViolations: {
        OnCall: components['schemas']['ShiftInRowRuleViolations'];
        NoCall: components['schemas']['ShiftInRowRuleViolations'];
        Unavailable: components['schemas']['ShiftInRowRuleViolations'];
        Vacation: components['schemas']['ShiftInRowRuleViolations'];
        Sick: components['schemas']['ShiftInRowRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftNeighborViolations: {
        OnCall: components['schemas']['SShiftTypeShiftNeighborRuleViolations'];
        NoCall: components['schemas']['SShiftTypeShiftNeighborRuleViolations'];
        Unavailable: components['schemas']['SShiftTypeShiftNeighborRuleViolations'];
        Vacation: components['schemas']['SShiftTypeShiftNeighborRuleViolations'];
        Sick: components['schemas']['SShiftTypeShiftNeighborRuleViolations'];
      } | null;
      /** @description Violation of the rule of adjacent shifts by shift type */
      shiftAllowedDayOfWeekViolations: {
        OnCall: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        NoCall: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Unavailable: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Vacation: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolations'];
        Sick: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolations'];
      } | null;
    };
    /**
     * SShiftTypeScheduleValidationResult
     * @description Result of schedule validation.
     */
    SShiftTypeScheduleValidationResult: {
      /** @description True if there are any validation rule violations. */
      hasRuleViolations: boolean;
      /**
       * @description Indicates whether preprocessing has been performed for the schedule.
       *     Schedules without preprocessing can be obtained faster, but they may contain inaccuracies.
       */
      isPreprocessed: boolean;
      scheduleSize: components['schemas']['ScheduleSize'];
      publishReadiness: components['schemas']['SchedulePublishReadiness'];
      /** @description Violations of the rules of service (OnCall, PhoneSupport) requirements by day. */
      dailyRulesViolations: {
        [key: string]: components['schemas']['SShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of the rules of service (OnCall, PhoneSupport) requirements by week.
       *     Key of dictionary is first day of week.
       */
      weeklyRulesViolations: {
        [key: string]: components['schemas']['SShiftTypeServicesRulesViolations'];
      } | null;
      /**
       * @description Violations of employees work rules.
       *     Key of dictionary is resource id.
       */
      resourceRulesViolations: {
        [key: string]: components['schemas']['SShiftTypeResourceRulesViolations'];
      } | null;
    };
    /** SShiftTypeScheduleValidationResultOperationResult */
    SShiftTypeScheduleValidationResultOperationResult: {
      data: components['schemas']['SShiftTypeScheduleValidationResult'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * SShiftTypeServicesRulesViolations
     * @description Violation of the requirements for the number of shifts of a certain type across countries, regions and hubs.
     */
    SShiftTypeServicesRulesViolations: {
      /** @description Violation of needs across the country for different types of shifts. */
      countryRulesViolations: {
        OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
        Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
        Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
        Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
      } | null;
      /**
       * @description Violation of needs in different regions for different types of shifts.
       *     Key is region id.
       */
      regionsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
      /**
       * @description Violation of needs in different hubs for different types of shifts.
       *     Key is hub id.
       */
      hubsRulesViolations: {
        [key: string]: {
          OnCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          NoCall: components['schemas']['ServiceShiftTypeRulesViolations'];
          Unavailable: components['schemas']['ServiceShiftTypeRulesViolations'];
          Vacation: components['schemas']['ServiceShiftTypeRulesViolations'];
          Sick: components['schemas']['ServiceShiftTypeRulesViolations'];
        };
      } | null;
    };
    /**
     * SShiftTypeShiftAllowedDayOfWeekRuleViolation
     * @description Violation of shift type day of week rule
     */
    SShiftTypeShiftAllowedDayOfWeekRuleViolation: {
      /**
       * Format: date
       * @description Date of target shift
       */
      targetDate: string;
      actual: components['schemas']['DayOfWeek'];
    };
    /** SShiftTypeShiftAllowedDayOfWeekRuleViolations */
    SShiftTypeShiftAllowedDayOfWeekRuleViolations: {
      actualRule: components['schemas']['DayOfWeek'][];
      violations: components['schemas']['SShiftTypeShiftAllowedDayOfWeekRuleViolation'][];
    };
    /** SShiftTypeShiftAvailabilityData */
    SShiftTypeShiftAvailabilityData: {
      currentShift: components['schemas']['SShiftTypeCompositeShift'];
      isPartialCurrentShift: boolean;
      nextShift: components['schemas']['SShiftTypeCompositeShift'];
      isPartialNextShift: boolean;
      activeShifts: components['schemas']['SShiftTypeCompositeShift'][];
      unavailabilities: components['schemas']['SShiftTypeCompositeShift'][];
    };
    /**
     * SShiftTypeShiftNeighborRuleViolation
     * @description Shift neighbor rule violation incident
     */
    SShiftTypeShiftNeighborRuleViolation: {
      /**
       * Format: date-time
       * @description A target shift for which the neighborhood requirement is not met.
       */
      targetDate: string;
      /** @description Current types of shifts before the target. */
      actualBefore: components['schemas']['SShiftType'][];
      /** @description Current types of shifts after the target. */
      actualAfter: components['schemas']['SShiftType'][];
    };
    /**
     * SShiftTypeShiftNeighborRuleViolations
     * @description Violations of the rule on the shift neighbors
     */
    SShiftTypeShiftNeighborRuleViolations: {
      violatedRule: components['schemas']['SShiftTypeNeighborRule'];
      /** @description Collection of rule violation incidents */
      violations: components['schemas']['SShiftTypeShiftNeighborRuleViolation'][];
    };
    /**
     * ScheduleFillingState
     * @description Schedule filling state
     * @enum {string}
     */
    ScheduleFillingState: ScheduleFillingState;
    /**
     * ScheduleHrSystemConflictType
     * @description Represents the type of conflict that can occur when processing workday shift types.
     * @enum {string}
     */
    ScheduleHrSystemConflictType: ScheduleHrSystemConflictType;
    /**
     * SchedulePublishBlocker
     * @description A blocker that prevents the schedule from being published.
     */
    SchedulePublishBlocker: {
      /** @description The type of the blocker. */
      type: string | null;
      /** @description The message of the blocker. */
      message: string | null;
      /** @description The data of the blocker. */
      data: {
        [key: string]: components['schemas']['JsonNode'];
      } | null;
    };
    /**
     * SchedulePublishReadiness
     * @description Indicates whether the schedule is ready to publish.
     */
    SchedulePublishReadiness: {
      /** @description True if the schedule is ready to publish. */
      isReadyToPublish?: boolean;
      /** @description Blockers that prevent the schedule from being published. */
      blockers: components['schemas']['SchedulePublishBlocker'][];
    };
    /**
     * ScheduleSize
     * @description Contains information about schedule size
     */
    ScheduleSize: {
      /**
       * Format: int32
       * @description Shift count in schedule
       */
      currentShiftCount: number;
      /**
       * Format: int32
       * @description Resources in schedule with at least one shift
       */
      resourceCount: number;
      /**
       * Format: int32
       * @description Count of schedule days
       */
      daysCount: number;
      /**
       * Format: int32
       * @description The number of changes in the schedule at which all cells of the schedule are filled.
       */
      readonly expectedShiftCount: number;
      /**
       * Format: int32
       * @description The number of uncertainties (gaps) in the schedule.
       */
      readonly missedShiftCount: number;
      fillingState: components['schemas']['ScheduleFillingState'];
      /** @description Collection of resource ids that have at least one shift in the schedule, but not all days are filled. */
      partialFilledResourceIds: string[];
    };
    /**
     * ScheduleType
     * @description Specifies what type of resource the schedule is intended for.
     * @enum {string}
     */
    ScheduleType: ScheduleType;
    /**
     * ServiceShiftTypeRulesViolations
     * @description Violation of the rules of resources needs on a certain type of shift.
     */
    ServiceShiftTypeRulesViolations: {
      global: components['schemas']['ComboRangeRuleViolation'];
      /**
       * @description Organ specific violations
       *     Key is organ type
       */
      byOrganType: {
        Liver: components['schemas']['ComboRangeRuleViolation'];
        Heart: components['schemas']['ComboRangeRuleViolation'];
        Lungs: components['schemas']['ComboRangeRuleViolation'];
        Kidney: components['schemas']['ComboRangeRuleViolation'];
      } | null;
      /**
       * @description Flag specific violations
       *     Key is flag name
       */
      byFlag: {
        [key: string]: components['schemas']['ComboRangeRuleViolation'];
      } | null;
    };
    /** SetCCShiftData */
    SetCCShiftData: {
      shiftType: components['schemas']['CCShiftType'];
      /**
       * @description Indicates whether the coordinator should perform the role of manager.
       *     Clinical coordinator should has one manger on each day
       */
      isManager: boolean | null;
    };
    /**
     * SetCSShiftData
     * @description Data for setting the shift
     */
    SetCSShiftData: {
      shiftType: components['schemas']['CSShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
      /**
       * Format: uuid
       * @description The hub in which the work shift takes place.
       *     If the type of shift is not related to the hub, it will be ignored.
       */
      hubId?: string | null;
      /** @description True if the given work shift is above the monthly resource rule */
      isExtra?: boolean;
      /** @description True if the shift occurs in a non-native hub. */
      isTravel?: boolean;
    };
    /** SetSShiftData */
    SetSShiftData: {
      shiftType: components['schemas']['SShiftType'];
      /**
       * @description List of organs for which the work shift is taking place.
       *     If the type of shift is not specific to the organ, it will be ignored.
       */
      organs?: components['schemas']['Organ'][];
      /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
      unavailabilities?: components['schemas']['Unavailability'][];
      /** @description True if the shift occurs in a non-native region. */
      isTravel?: boolean;
      /**
       * Format: uuid
       * @description The region in which the work shift takes place.
       *     If the type of shift is not regional, it will be ignored.
       */
      regionId?: string | null;
    };
    /**
     * ShiftFixationType
     * @description Indicates the degree of fixation of the shift type in a particular cell.
     * @enum {string}
     */
    ShiftFixationType: ShiftFixationType;
    /**
     * ShiftInRowRuleViolation
     * @description Shift in row rule violation incident
     */
    ShiftInRowRuleViolation: {
      /**
       * Format: int32
       * @description The actual number of consecutive shifts that violate the rule.
       */
      actualLengthInRow: number;
      /**
       * Format: date-time
       * @description The first day of a sequence that breaks the rules.
       */
      startDate: string;
      /**
       * Format: date-time
       * @description The last day of a sequence that breaks the rules.
       */
      endDate: string;
    };
    /**
     * ShiftInRowRuleViolations
     * @description Violations of the rule on the number of consecutive shifts.
     */
    ShiftInRowRuleViolations: {
      violatedRule: components['schemas']['ComboRangeRule'];
      /** @description Collection of violation incidents. */
      violations: components['schemas']['ShiftInRowRuleViolation'][];
    };
    /**
     * ShiftPerPeriodRules
     * @description Describes the number of shifts of different types per period.
     */
    ShiftPerPeriodRules: {
      lead: components['schemas']['LeadShiftPerPeriodRules'];
      specialist: components['schemas']['SpecialistShiftPerPeriodRules'];
    };
    /**
     * ShiftStatus
     * @description Shift status, describes the life cycle of a shift.
     * @enum {string}
     */
    ShiftStatus: ShiftStatus;
    /** SignedUrlData */
    SignedUrlData: {
      signedUrl: string | null;
      fileName: string | null;
    };
    /** SignedUrlDataOperationResult */
    SignedUrlDataOperationResult: {
      data: components['schemas']['SignedUrlData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /**
     * Size
     * @enum {string}
     */
    Size: Size;
    /**
     * SpecialistShiftPerPeriodRules
     * @description Describes the number of shifts of different types per period for a clinical specialist.
     */
    SpecialistShiftPerPeriodRules: {
      /**
       * Format: int32
       * @description OnCall count per period
       */
      onCall: number | null;
      /**
       * Format: int32
       * @description OnCall on weekend count per period
       */
      onCallOnWeekend: number | null;
      /**
       * Format: int32
       * @description AtHub max count per period
       */
      maxAtHub: number | null;
    };
    /**
     * Status
     * @enum {string}
     */
    Status: Status;
    /**
     * SurgeonGroup
     * @description Surgeon group
     * @enum {string}
     */
    SurgeonGroup: SurgeonGroup;
    /** TrackEmployeeLocationRequest */
    TrackEmployeeLocationRequest: {
      /** Format: double */
      latitude: number;
      /** Format: double */
      longitude: number;
      country: string | null;
      city: string | null;
    };
    /**
     * TrackedGeoLocation
     * @description Represents a tracked geographical location with a timestamp.
     */
    TrackedGeoLocation: {
      /**
       * Format: uuid
       * @description Location identifier.
       *     Null if location is not fixed in system.
       */
      id: string | null;
      /**
       * Format: double
       * @description The latitude of the location.
       */
      latitude: number;
      /**
       * Format: double
       * @description The longitude of the location.
       */
      longitude: number;
      /**
       * Format: date-time
       * @description The timestamp when the location was tracked.
       */
      trackedTime: string;
    };
    /** TrackedLocationModel */
    TrackedLocationModel: {
      /** Format: uuid */
      employeeId: string;
      address: string | null;
      /** Format: double */
      latitude?: number;
      /** Format: double */
      longitude?: number;
      /** Format: date-time */
      trackedTime?: string;
    };
    /** TrackedLocationModelOperationResult */
    TrackedLocationModelOperationResult: {
      data: components['schemas']['TrackedLocationModel'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
      readonly hasData: boolean;
    };
    /** TrialProgramResponse */
    TrialProgramResponse: {
      /** Format: uuid */
      id: string;
      name: string | null;
      organ: string | null;
      isActive: boolean;
      /** Format: date-time */
      createdAt: string;
      /** Format: date-time */
      modifiedAt: string;
    };
    /**
     * TrialProgramsFilterType
     * @enum {string}
     */
    TrialProgramsFilterType: TrialProgramsFilterType;
    /** TripLegView */
    TripLegView: {
      /** Format: int32 */
      id: number;
      /** Format: date-time */
      landedUtc: string;
      /** Format: double */
      flyingTime: number;
      /** Format: date-time */
      landedLocal: string;
      /** Format: date-time */
      onBlocksUtc: string;
      /** Format: int32 */
      sectorIndex: number;
      /** Format: date-time */
      takenOffUtc: string;
      /** Format: date-time */
      offBlocksUtc: string;
      /** Format: date-time */
      onBlocksLocal: string;
      /** Format: date-time */
      takenOffLocal: string;
      /** Format: date-time */
      offBlocksLocal: string;
      /** Format: int32 */
      arrivalAirportId: number;
      arrivalAirport: components['schemas']['AirportView'];
    };
    /** TripView */
    TripView: {
      /** Format: int32 */
      id: number;
      reference: string | null;
      status: string | null;
      route: string | null;
      /** Format: date-time */
      tripEnd: string;
      /** Format: date-time */
      tripStart: string;
      flightNumber: string | null;
      externalReference: string | null;
      legs: components['schemas']['TripLegView'][];
      /** Format: int32 */
      preferredAircraftId: number;
    };
    /** Unavailability */
    Unavailability: {
      /** Format: date-time */
      from: string;
      /** Format: date-time */
      to: string;
    };
    /** UnavailabilityInfo */
    UnavailabilityInfo: {
      /** Format: date-time */
      from: string;
      /** Format: date-time */
      to: string;
    };
    /** UnlockResourcesRequest */
    UnlockResourcesRequest: {
      /** Format: uuid */
      caseId: string;
      /** Format: uuid */
      lockId: string;
    };
    /** VacationDeductionRule */
    VacationDeductionRule: {
      /** Format: int32 */
      each: number;
      /** Format: int32 */
      deduction: number;
    };
    /**
     * YearDeductionRules
     * @description Describes the rules for reducing standards depending on the number of vacation days and sickness.
     */
    YearDeductionRules: {
      q1_3: components['schemas']['VacationDeductionRule'];
      q4: components['schemas']['VacationDeductionRule'];
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
};
export type $defs = Record<string, never>;
export enum ActionType {
  Assign = 'Assign',
  AssignWithWarning = 'AssignWithWarning',
  LockedAssign = 'LockedAssign',
  Detach = 'Detach',
}
export enum AffiliationType {
  TMDXContract = 'TMDXContract',
  TXCenter = 'TXCenter',
  OPO = 'OPO',
  NoContract = 'NoContract',
}
export enum AircraftOrderBy {
  None = 'None',
  Registration = 'Registration',
}
export enum AutoSchedulerResultType {
  Optimal = 'Optimal',
  Feasible = 'Feasible',
  Infeasible = 'Infeasible',
  NoTime = 'NoTime',
  Error = 'Error',
}
export enum BannedTailNumberOrderByOptions {
  None = 'None',
  BannedTailNumber = 'BannedTailNumber',
}
export enum CCResourceType {
  TC1 = 'TC1',
  TC2 = 'TC2',
  TC3 = 'TC3',
}
export enum CCShiftType {
  OnCall = 'OnCall',
  NoCall = 'NoCall',
  Unavailable = 'Unavailable',
  Vacation = 'Vacation',
  Sick = 'Sick',
  WeekendOff = 'WeekendOff',
}
export enum CSHolidayDutyGroup {
  GroupA = 'GroupA',
  GroupB = 'GroupB',
  GroupC = 'GroupC',
}
export enum CSShiftTimeGroup {
  GroupA = 'GroupA',
  GroupB = 'GroupB',
}
export enum CSShiftType {
  OnCall = 'OnCall',
  AtHub = 'AtHub',
  NoCall = 'NoCall',
  WeekendOff = 'WeekendOff',
  OfficeDay = 'OfficeDay',
  Unavailable = 'Unavailable',
  Vacation = 'Vacation',
  Sick = 'Sick',
  PhoneSupport = 'PhoneSupport',
  TravelDay = 'TravelDay',
}
export enum CandidateMatchType {
  Perfect = 'Perfect',
  Medium = 'Medium',
  Miss = 'Miss',
}
export enum CaseMatchType {
  AssignmentCandidate = 'AssignmentCandidate',
  AlreadyAssigned = 'AlreadyAssigned',
  AlreadyReserved = 'AlreadyReserved',
  ReservedForAnotherCase = 'ReservedForAnotherCase',
  AssignedToAnotherCase = 'AssignedToAnotherCase',
}
export enum DayOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}
export enum Donor {
  DBD = 'DBD',
  DCD = 'DCD',
}
export enum DriverAffiliationType {
  None = 'None',
  TMDX = 'TMDX',
  SupplementalListProvider = 'SupplementalListProvider',
  TXCenterProvider = 'TXCenterProvider',
}
export enum DriversSearchOrderBy {
  None = 'None',
  Name = 'Name',
  Affiliation = 'Affiliation',
}
export enum EmployeeSearchOrderBy {
  None = 'None',
  Name = 'Name',
  Position = 'Position',
}
export enum GccEmployeeSearchOrderBy {
  None = 'None',
  CreatedAt = 'CreatedAt',
}
export enum InventoryPartType {
  LiverPerfusionSet = 'LiverPerfusionSet',
  LiverBileSaltsSet = 'LiverBileSaltsSet',
  LiverGasCylinder80PercentOxygen = 'LiverGasCylinder80PercentOxygen',
  HeartPerfusionSet = 'HeartPerfusionSet',
  HeartSolutionSetRef1300 = 'HeartSolutionSetRef1300',
  CableTieToolSmallDiameter = 'CableTieToolSmallDiameter',
  GasCylinderEuUsCanada = 'GasCylinderEuUsCanada',
  LungPerfusionSet = 'LungPerfusionSet',
  LungSolutionRef2300 = 'LungSolutionRef2300',
  GasCylinderM15A = 'GasCylinderM15A',
  GasCylinderLu = 'GasCylinderLu',
  KidneyPerfusionSet = 'KidneyPerfusionSet',
}
export enum InventoryPartsSearchOrderBy {
  None = 'None',
  ExpirationDate = 'ExpirationDate',
}
export enum LastCertificationAtHubStatus {
  NotLast = 'NotLast',
  Last = 'Last',
  NotLastButBecomeLast = 'NotLastButBecomeLast',
  LastWithNextSoon = 'LastWithNextSoon',
}
export enum LocationPreference {
  Base = 'Base',
  Home = 'Home',
  Affiliation = 'Affiliation',
}
export enum NodeType {
  Reserved = 'Reserved',
  OnCase = 'OnCase',
  OnRest = 'OnRest',
}
export enum OMSShiftType {
  OnCall = 'OnCall',
  AdminDay = 'AdminDay',
  NoCall = 'NoCall',
  Unavailable = 'Unavailable',
  Vacation = 'Vacation',
  SickLeave = 'SickLeave',
}
export enum OcsConsoleSearchOrderBy {
  None = 'None',
  SerialNumber = 'SerialNumber',
  TrialProgramName = 'TrialProgramName',
}
export enum OcsConsoleStatus {
  Available = 'Available',
  OnCase = 'OnCase',
  Reserved = 'Reserved',
}
export enum Organ {
  Liver = 'Liver',
  Heart = 'Heart',
  Lungs = 'Lungs',
  Kidney = 'Kidney',
}
export enum PlanningProcessStatus {
  Generating = 'Generating',
  Editing = 'Editing',
  Processing = 'Processing',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}
export enum ResourceAvailabilityNodeType {
  Reserved = 'Reserved',
  OnCase = 'OnCase',
  OnRest = 'OnRest',
}
export enum ResourceStatus {
  Done = 'Done',
  Canceled = 'Canceled',
  Reserved = 'Reserved',
  BookingSent = 'BookingSent',
  Booked = 'Booked',
  BookedInMao = 'BookedInMao',
}
export enum SShiftType {
  OnCall = 'OnCall',
  NoCall = 'NoCall',
  Unavailable = 'Unavailable',
  Vacation = 'Vacation',
  Sick = 'Sick',
}
export enum ScheduleFillingState {
  Empty = 'Empty',
  Partial = 'Partial',
  Full = 'Full',
}
export enum ScheduleHrSystemConflictType {
  HrSystemShiftTypeAdded = 'HrSystemShiftTypeAdded',
  HrSystemShiftTypeChanged = 'HrSystemShiftTypeChanged',
  HrSystemShiftTypeRemoved = 'HrSystemShiftTypeRemoved',
  HrSystemShiftTypeOverridden = 'HrSystemShiftTypeOverridden',
}
export enum ScheduleType {
  ClinicalSpecialist = 'ClinicalSpecialist',
  ClinicalCoordinator = 'ClinicalCoordinator',
  Surgeon = 'Surgeon',
  LiSurgeon = 'LiSurgeon',
  HtLuSurgeon = 'HtLuSurgeon',
  OrganManagementSpecialist = 'OrganManagementSpecialist',
}
export enum ShiftFixationType {
  Assigned = 'Assigned',
  Preferred = 'Preferred',
  Required = 'Required',
}
export enum ShiftStatus {
  Actual = 'Actual',
  Deprecated = 'Deprecated',
  InPlanningProcess = 'InPlanningProcess',
}
export enum Size {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
}
export enum Status {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum SurgeonGroup {
  Liver = 'Liver',
  HeartLungs = 'HeartLungs',
}
export enum TrialProgramsFilterType {
  AnyOf = 'AnyOf',
  None = 'None',
}
export type operations = Record<string, never>;
